(function ($) {
  "use strict";
  jQuery(document).ready(function() {
    // menu toggler js
    $("button.navbar-toggle").on('click', function() {
      if (document.body.classList.contains('fbp-mobile-menu-rebuild-ready')) return;
      $(".main-menu-area").addClass("active");
      $(".mm-fullscreen-bg").addClass("active");
      $("body").addClass("ov-hidden");
    });
    $(".close-box").on('click', function() {
      if (document.body.classList.contains('fbp-mobile-menu-rebuild-ready')) return;
      $(".main-menu-area").removeClass("active");
      $(".mm-fullscreen-bg").removeClass("active");
      $("body").removeClass("ov-hidden");
    });
    // filter button js
    $("button.filter-button").on('click', function() {
      $(".filter-sidebar").addClass("active");
      $(".mm-fullscreen-bg").addClass("active");
      $("body").addClass("ov-hidden");
    });
    $("button.close-filter-sidebar").on('click', function() {
      $(".filter-sidebar").removeClass("active");
      $(".mm-fullscreen-bg").removeClass("active");
      $("body").removeClass("ov-hidden");
    });
    // body background color js
    $(".mm-fullscreen-bg").on('click',function() {
      $(".main-menu-area").removeClass("active");
      $(".filter-sidebar").removeClass("active");
      $(".mm-fullscreen-bg").removeClass("active");
      $("body").removeClass("hidden ov-hidden");
    });
    $('.checkout-btn .read-agree').on('click', function () {
      if($('.cust-checkbox').is(':checked')) {
        $('.checkout-btn button.check-btn').removeAttr('disabled');
      }
      else {
        $('.checkout-btn button.check-btn').attr('disabled', 'disabled');
      }
    });
    $('.read-agree').on('click', function () {
      if($('.create-checkbox').is(':checked')) {
        $('.create').removeAttr('disabled');
      }
      else {
        $('.create').attr('disabled', 'disabled');
      }
    });
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl)
    });
    // product-img full-view & magnific popup
    var hasMagnificPopup = $.fn && typeof $.fn.magnificPopup === 'function';
    if (hasMagnificPopup && $('.full-view, .zoom').length && $('.product_img_top').length) {
      $('.full-view, .zoom').on('click', function() {
        $('.product_img_top').magnificPopup({
          delegate: 'a',
          type:'image',
          showCloseBtn: true,
          closeBtnInside: false,
          midClick: true,
          tLoading: 'Loading image #%curr%...',
          mainClass: 'mfp-img-mobile',
          gallery: {
            enabled: true,
            navigateByImgClick: true,
            preload: [0,1]
          }
        }).magnificPopup('open');
      });
    }
    if (hasMagnificPopup && $('.play-button, .popup-vimeo, .popup-gmaps').length) {
      $('.play-button, .popup-vimeo, .popup-gmaps').magnificPopup({
        tClose: 'Close (Esc)',
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false
      });
    }
    $('.item-data').on("click", function() {
      $(this).parents('.option-block').find(".variant-option").removeClass('active-variant');
      $(this).closest('.form-wrap').addClass('active-variant');
      var it_img = $(this).attr('dataimg');
      $(this).parents('.single-product-wrap').find('.product-image .img1 img').attr('src',it_img);
      $(this).parents('.single-product-wrap').find('.product-image .img1 img').attr('srcset',it_img);
      var price = Number($(this).attr('dataprice'));
      var compareprice = Number($(this).attr('datacompare'));
      var stocks = $(this).attr('dataavailable');
      $(this).parents('.single-product-wrap').find('.price-box .new-price').html(Shopify.formatMoney(price, window.money_format));
      if (compareprice > price) {
        $(this).parents('.single-product-wrap').find('.price-box .old-price').show();
        $(this).parents('.single-product-wrap').find('.price-box .old-price').html(Shopify.formatMoney(compareprice, window.money_format));
      }else{
        $(this).parents('.single-product-wrap').find('.price-box .old-price').hide();
      }
    });
  });
})(jQuery);

;(function () {
  function fbpMaterialImageRescueV4() {
    var galleries = Array.prototype.slice.call(document.querySelectorAll('.material-size-guide'));
    if (!galleries.length) return;

    function withRetryToken(src) {
      if (!src) return src;
      return src + (src.indexOf('?') >= 0 ? '&' : '?') + 'fbp_lazy_retry=' + Date.now();
    }

    function promoteImage(img) {
      if (!img) return;
      img.setAttribute('loading', 'eager');
      img.setAttribute('decoding', 'async');
      img.setAttribute('fetchpriority', 'low');
    }

    function tryLoadImage(img) {
      if (!img || (img.complete && img.naturalWidth > 0)) return;

      var src = img.currentSrc || img.getAttribute('src');
      if (!src) return;

      promoteImage(img);

      var preload = new Image();
      preload.decoding = 'async';
      preload.fetchPriority = 'low';
      preload.onload = function () {
        if (!img.complete || img.naturalWidth === 0) {
          img.src = src;
        }
      };
      preload.onerror = function () {
        var retryCount = Number(img.dataset.fbpRetryCount || '0');
        if (retryCount >= 1) return;
        img.dataset.fbpRetryCount = String(retryCount + 1);
        img.src = withRetryToken(src);
      };
      preload.src = src;
    }

    galleries.forEach(function (gallery) {
      if (!gallery || gallery.dataset.fbpMaterialBound === 'true') return;
      gallery.dataset.fbpMaterialBound = 'true';

      var images = Array.prototype.slice.call(gallery.querySelectorAll('.mat-img[src]'));
      if (!images.length) return;

      images.forEach(function (img) {
        img.setAttribute('loading', 'lazy');
        img.setAttribute('decoding', 'async');
        img.setAttribute('fetchpriority', 'low');
        img.addEventListener('error', function () {
          tryLoadImage(img);
        }, { passive: true });
      });

      function nudgeImageLoad() {
        images.forEach(tryLoadImage);
      }

      function nudgeImageLoadIfNearViewport() {
        var rect = gallery.getBoundingClientRect();
        var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
        if (rect.bottom < -500 || rect.top > viewportHeight + 500) return;
        nudgeImageLoad();
      }

      if (!('IntersectionObserver' in window)) {
        nudgeImageLoad();
      } else {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            nudgeImageLoad();
            observer.disconnect();
          });
        }, { rootMargin: '500px 0px' });

        observer.observe(gallery);
      }

      window.addEventListener('orientationchange', nudgeImageLoadIfNearViewport, { passive: true });
      window.addEventListener('pageshow', nudgeImageLoadIfNearViewport, { passive: true });
      window.addEventListener('load', function () {
        window.setTimeout(nudgeImageLoadIfNearViewport, 1200);
      }, { passive: true, once: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fbpMaterialImageRescueV4);
  } else {
    fbpMaterialImageRescueV4();
  }
})();

;(function () {
  function init() {
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest && event.target.closest('[data-fbp-review-jump]');
      if (!trigger) return;

      var panel = document.getElementById('pro-review');
      var tabTrigger = document.querySelector('[data-bs-target="#pro-review"]');
      if (!panel || !tabTrigger) return;

      event.preventDefault();

      if (window.bootstrap && window.bootstrap.Tab && tabTrigger.getAttribute('data-bs-toggle') === 'tab') {
        try {
          window.bootstrap.Tab.getOrCreateInstance(tabTrigger).show();
        } catch (error) {
          tabTrigger.click();
        }
      } else {
        tabTrigger.click();
      }

      window.setTimeout(function () {
        panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 80);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

(function () {
  var MARKER = 'fbp-main-variant-media-sync-2026-04-23';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function productHandle() {
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function fetchProduct(handle) {
    return fetch('/products/' + handle + '.js', {
      credentials: 'same-origin',
      headers: { accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('product json ' + response.status);
      return response.json();
    });
  }

  function cartForm() {
    var forms = Array.prototype.slice.call(document.forms || []);
    return forms.find(function (form) {
      return String(form.action || '').indexOf('/cart/add') !== -1 && form.querySelector('input[name="id"]');
    });
  }

  function selectedVariantId(form) {
    var idInput = form && form.querySelector('input[name="id"]');
    var urlVariant = new URL(window.location.href).searchParams.get('variant');
    return String((idInput && idInput.value) || urlVariant || '');
  }

  function variantMediaId(variant) {
    if (!variant) return '';
    if (variant.featured_media && variant.featured_media.id) return String(variant.featured_media.id);
    if (variant.featured_image && variant.featured_image.id) return String(variant.featured_image.id);
    return '';
  }

  function rail(productId, kind) {
    return document.getElementById('slider-' + kind + '-' + productId);
  }

  function slideFor(root, mediaId) {
    if (!root || !mediaId) return null;
    return root.querySelector('.swiper-slide[data-image-id="' + mediaId + '"]:not(.swiper-slide-duplicate)');
  }

  function activateSlide(root, slide) {
    if (!root || !slide) return false;
    var index = Number(slide.getAttribute('data-index')) - 1;
    if (root.swiper && Number.isFinite(index) && index >= 0) {
      root.swiper.slideTo(index, 0, false);
      root.swiper.updateSlidesClasses();
      return true;
    }
    return false;
  }

  function init() {
    if (document.documentElement.getAttribute(MARKER) === 'true') return;
    var handle = productHandle();
    if (!handle) return;

    fetchProduct(handle).then(function (product) {
      var form = cartForm();
      if (!form || !product || !Array.isArray(product.variants)) return;
      document.documentElement.setAttribute(MARKER, 'true');

      function sync() {
        var variantId = selectedVariantId(form);
        var variant = product.variants.find(function (entry) {
          return String(entry.id) === variantId;
        });
        var mediaId = variantMediaId(variant);
        if (!mediaId) return false;

        var bigRail = rail(product.id, 'big');
        var smallRail = rail(product.id, 'small');
        var bigSlide = slideFor(bigRail, mediaId);
        var smallSlide = slideFor(smallRail, mediaId);
        if (!bigSlide) return false;

        activateSlide(smallRail, smallSlide);
        return activateSlide(bigRail, bigSlide);
      }

      function schedule() {
        var attempts = 0;
        function tick() {
          attempts += 1;
          if (sync()) return;
          if (attempts < 18) window.setTimeout(tick, 250);
        }
        window.setTimeout(tick, 80);
      }

      form.addEventListener('change', function () {
        window.setTimeout(schedule, 0);
      }, true);
      form.addEventListener('click', function () {
        window.setTimeout(schedule, 0);
      }, true);
      window.addEventListener('popstate', schedule);
      schedule();
    }).catch(function () {});
  }

  ready(init);
  window.addEventListener('load', init, { once: true });
})();
/* fbpMaterialImageRescueV4 */

(function () {
  if (window.__fbpHomepageCardTransformGuardV1) return;
  window.__fbpHomepageCardTransformGuardV1 = true;

  function isHomepage() {
    return document.body && document.body.classList.contains('template-index');
  }

  function clearTransform(img) {
    if (!img) return;
    img.style.setProperty('transform', 'none', 'important');
    img.style.setProperty('transform-origin', '50% 50%', 'important');
  }

  function clearHomepageCardTransforms() {
    if (!isHomepage()) return;
    document.querySelectorAll('.single-product-wrap .product-image a.pro-img img').forEach(clearTransform);
  }

  function bindObserver() {
    if (!isHomepage() || window.__fbpHomepageCardTransformGuardV1ObserverBound) return;
    window.__fbpHomepageCardTransformGuardV1ObserverBound = true;
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'attributes' && mutation.target instanceof HTMLImageElement) {
          clearTransform(mutation.target);
          continue;
        }
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof HTMLElement)) return;
          if (node.matches && node.matches('.single-product-wrap .product-image a.pro-img img')) {
            clearTransform(node);
          }
          node.querySelectorAll?.('.single-product-wrap .product-image a.pro-img img').forEach(clearTransform);
        });
      }
    });
    observer.observe(document.documentElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['style'],
    });
  }

  function init() {
    if (!isHomepage()) return;
    clearHomepageCardTransforms();
    bindObserver();
    [250, 1000, 2500, 4500, 6500].forEach((delay) => {
      window.setTimeout(clearHomepageCardTransforms, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  window.addEventListener('load', clearHomepageCardTransforms, { once: true });
})();
/* fbpHomepageCardTransformGuardV1 */

/* fbpDakiCollectionHandleBodyClassV1 */
(function () {
  var targetPath = '/collections/body-pillow-covers-furry-dakimakura';
  var targetClass = 'collection-handle-body-pillow-covers-furry-dakimakura';
  function applyCollectionHandleClass() {
    if (!document.body) return;
    var pathOnly = window.location.pathname.replace(/\/+$/, '') || '/';
    if (pathOnly === targetPath) {
      document.body.classList.add(targetClass);
    } else {
      document.body.classList.remove(targetClass);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyCollectionHandleClass);
  } else {
    applyCollectionHandleClass();
  }
  window.addEventListener('pageshow', applyCollectionHandleClass);
})();

  /* FBP mobile menu runtime repair 2026-04-01, V44.4 (2026-04-19)

     V44.4 removes the runtime CSS-injection half of this handler. The
     original inject appended an inline <style> block with `background:
     #fff !important` rules on every drawer surface. It ran at
     DOMContentLoaded, so it landed in document.head AFTER the section-
     inline V44 redesign styles in the body — that meant the JS-injected
     white rules always won the cascade tie for same-specificity rules,
     and V44's dark drawer background could never render at mobile.

     The layout/structure rules the JS was injecting (display:flex,
     overflow-y:auto, .box-header positioning, .browse-cat sticky, etc.)
     are all redundant with what sections/header-v2.liquid now emits
     statically via V44 and V44.3 — so there's nothing left to inject.

     The unrelated shopLink href fix (mobile sticky-menu "Shop" tab,
     originally pointed at a silk-dress collection instead of the
     dakimakura one) is preserved and still runs on DOMContentLoaded. */
  document.addEventListener('DOMContentLoaded', function() {
    var shopLink = Array.from(document.querySelectorAll('#shopify-section-mobile-sticky-menu a.icon-block')).find(function(link) {
      var title = (link.querySelector('.title') && link.querySelector('.title').textContent || '').trim().toLowerCase();
      return title === 'shop';
    });
    if (shopLink && (!shopLink.getAttribute('href') || shopLink.getAttribute('href').indexOf('silk-dress') !== -1)) {
      shopLink.setAttribute('href', '/collections/body-pillow-covers-furry-dakimakura');
      shopLink.setAttribute('data-fbp-shop-link-runtime-fix', 'true');
    }
  });

/* FBP search main runtime 2026-04-01 start */
(function () {
  if (window.__fbpSearchMainRuntime20260401) return;
  window.__fbpSearchMainRuntime20260401 = true;

  var SEARCH_TRIGGER_SELECTOR = 'a.search-popup, a[href="#seachmodal"], [data-bs-target="#seachmodal"], [data-target="#seachmodal"]';

  function ensureRuntimeStyles() {
    if (document.getElementById('fbp-search-main-style-20260401')) return;
    var style = document.createElement('style');
    style.id = 'fbp-search-main-style-20260401';
    style.textContent = [
      'html.fbp-search-open, body.fbp-search-open { overflow: hidden !important; }',
      'body.fbp-search-open main, body.fbp-search-open .shopify-section-group-header-group { pointer-events: none !important; }',
      'body.fbp-search-open #seachmodal, body.fbp-search-open #seachmodal * { pointer-events: auto !important; }',
      'body.fbp-search-open .modal-backdrop { display: none !important; pointer-events: none !important; }'
    ].join('\n');
    document.head.appendChild(style);
  }

  function getModal() {
    return document.getElementById('seachmodal');
  }

  function ensureModalRoot() {
    var modal = getModal();
    if (!modal) return null;
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }
    modal.style.setProperty('position', 'fixed', 'important');
    modal.style.setProperty('inset', '0', 'important');
    modal.style.setProperty('z-index', '100000', 'important');
    return modal;
  }

  function setBackgroundInteractivity(disabled) {
    document.querySelectorAll('main, .shopify-section-group-header-group').forEach(function (node) {
      if (!node || (node.id && node.id === 'seachmodal') || node.contains(getModal())) return;
      if (disabled) {
        if (!node.hasAttribute('data-fbp-search-prev-pointer')) {
          node.setAttribute('data-fbp-search-prev-pointer', node.style.pointerEvents || '');
        }
        node.style.setProperty('pointer-events', 'none', 'important');
      } else {
        if (!node.hasAttribute('data-fbp-search-prev-pointer')) return;
        var previous = node.getAttribute('data-fbp-search-prev-pointer');
        if (previous) {
          node.style.pointerEvents = previous;
        } else {
          node.style.removeProperty('pointer-events');
        }
        node.removeAttribute('data-fbp-search-prev-pointer');
      }
    });
  }

  function focusInput() {
    var modal = getModal();
    if (!modal || !modal.classList.contains('show') || (document.activeElement !== modal && modal.contains(document.activeElement))) return;
    var input = document.querySelector('#seachmodal input[type="search"], #seachmodal input[name="q"]');
    if (!input) return;
    input.focus();
    if (typeof input.select === 'function') input.select();
  }

  function openSearchModal(event) {
    if (event) {
      event.preventDefault();
      if (typeof event.stopPropagation === 'function') event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
    }
    ensureRuntimeStyles();
    var modal = ensureModalRoot();
    if (!modal) return false;
    modal.classList.add('show');
    modal.style.setProperty('display', 'block', 'important');
    modal.style.setProperty('visibility', 'visible', 'important');
    modal.style.setProperty('pointer-events', 'auto', 'important');
    modal.removeAttribute('aria-hidden');
    modal.setAttribute('aria-modal', 'true');
    document.body.classList.add('modal-open', 'fbp-search-open');
    document.documentElement.classList.add('fbp-search-open');
    setBackgroundInteractivity(true);
    document.querySelectorAll('.modal-backdrop').forEach(function (node) { node.remove(); });
    window.requestAnimationFrame(function () {
      window.setTimeout(focusInput, 30);
    });
    return false;
  }

  function closeSearchModal(event) {
    if (event) {
      event.preventDefault();
      if (typeof event.stopPropagation === 'function') event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
    }
    var modal = ensureModalRoot();
    if (!modal) return false;
    modal.classList.remove('show');
    modal.style.setProperty('display', 'none', 'important');
    modal.setAttribute('aria-hidden', 'true');
    modal.removeAttribute('aria-modal');
    document.body.classList.remove('modal-open', 'fbp-search-open');
    document.documentElement.classList.remove('fbp-search-open');
    setBackgroundInteractivity(false);
    document.querySelectorAll('.modal-backdrop').forEach(function (node) { node.remove(); });
    return false;
  }

  function bindTriggers(root) {
    (root || document).querySelectorAll(SEARCH_TRIGGER_SELECTOR).forEach(function (trigger) {
      if (!trigger || trigger.dataset.fbpSearchMainBound === 'true') return;
      trigger.dataset.fbpSearchMainBound = 'true';
      trigger.removeAttribute('data-bs-toggle');
      trigger.removeAttribute('data-toggle');
      trigger.removeAttribute('data-bs-target');
      trigger.removeAttribute('data-target');
      if (trigger.getAttribute('href') === '#seachmodal' || trigger.getAttribute('href') === '#') {
        trigger.setAttribute('href', '/search');
      }
      trigger.addEventListener('click', openSearchModal, true);
    });
  }

  window.fbpOpenSearchModal = openSearchModal;
  window.fbpCloseSearchModal = closeSearchModal;

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest(SEARCH_TRIGGER_SELECTOR);
    if (trigger) {
      openSearchModal(event);
      return;
    }
    var modal = getModal();
    if (modal && modal.classList.contains('show') && (event.target === modal || event.target.closest('#seachmodal .pop-close'))) {
      closeSearchModal(event);
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    var modal = getModal();
    if (event.key === 'Escape' && modal && modal.classList.contains('show')) {
      closeSearchModal(event);
    }
  });

  function boot() {
    ensureRuntimeStyles();
    bindTriggers(document);
    ensureModalRoot();
    document.querySelectorAll('.modal-backdrop').forEach(function (node) { node.remove(); });
  }

  var observer = new MutationObserver(boot);

  function afterLoad() {
    boot();
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', afterLoad, { once: true });
  } else {
    afterLoad();
  }
})();
/* FBP search main runtime 2026-04-01 end */

/* FBP old feline artist avatars restore 2026-04-01 start */
(function () {
  if (window.__fbpOldFelineArtistRestoreV1) return;
  window.__fbpOldFelineArtistRestoreV1 = true;

  var TARGET_PATHS = new Set(['/collections/feline-body-pillow', '/collections/feline-body-pillow2']);
  var ARTIST_PFP = {
  "Ambris": "pfp-ambris-sidebar-20260402.jpg",
  "Arca": "pfp-arca-sidebar-20260402.jpg",
  "Basilisk": "pfp-basilisk-sidebar-20260402.jpg",
  "Dev_Voxy": "pfp-dev-voxy-sidebar-20260402.jpg",
  "ErdbeerJoghurt": "pfp-erdbeerjoghurt-sidebar-20260402.jpg",
  "Felix F": "pfp-felix-f-sidebar-20260402.jpg",
  "Fensu": "pfp-fensu-sidebar-20260402.jpg",
  "Flash_lioness": "pfp-flash-lioness-sidebar-20260402.jpg",
  "Yulia Gruzdeva": "pfp-yulia-gruzdeva-sidebar-20260402.jpg",
  "Lin Shark": "pfp-lin-shark-sidebar-20260402.jpg",
  "Maaia": "pfp-maaia-sidebar-20260402.jpg",
  "MykeGreywolf": "pfp-mykegrywolf-sidebar-20260402.jpg",
  "Radioactive Mint": "pfp-radioactive-mint-sidebar-20260402.jpg",
  "Ram the Dragon": "pfp-ram-the-dragon-sidebar-20260402.jpg",
  "Zanger danger": "pfp-zanger-danger-sidebar-20260402.jpg",
  "Saint cocoa": "pfp-saint-cocoa-sidebar-20260402.jpg",
  "Shenki": "pfp-shenki-sidebar-20260402.jpg",
  "SparKitty": "pfp-sparkitty-sidebar-20260402.jpg",
  "Taneysha": "pfp-taneysha-sidebar-20260402.jpg",
  "Alibi-cami": "pfp-alibi-cami-sidebar-20260402.jpg",
  "ekihnox": "pfp-ekihnox-sidebar-20260402.jpg",
  "Cerbera": "pfp-cerbera-sidebar-20260402.jpg",
  "Saltamor": "pfp-saltamor-sidebar-20260402.jpg",
  "Dreamweaver": "pfp-dreamweaver-sidebar-20260402.jpg",
  "Tokokami": "pfp-tokokami-sidebar-20260402.jpg",
  "Kuribon": "pfp-kuribon-sidebar-20260402.jpg",
  "Ruhisu": "pfp-ruhisu-sidebar-20260402.jpg",
  "NowIsee": "pfp-nowisee-sidebar-20260402.jpg",
  "dont_jinxit": "pfp-dont-jinxit-sidebar-20260402.jpg",
  "Max Fauler": "pfp-max-fauler-sidebar-20260402.jpg",
  "Echo": "pfp-echo-sidebar-20260402.jpg",
  "methynecros": "pfp-methynecros-sidebar-20260402.jpg",
  "Soapaint": "pfp-soapaint-sidebar-20260402.jpg",
  "Quốc Anh Phùng": "msYE65jU_200x200-sidebar-20260402.jpg"
};
  var THEME_ASSET_BASE = null;

  function isTargetPage() {
    return document.body && document.body.classList.contains('template-collection') && TARGET_PATHS.has(window.location.pathname.replace(/\/+$/, ''));
  }

  function getThemeAssetBase() {
    if (THEME_ASSET_BASE) return THEME_ASSET_BASE;
    var mainScript = Array.from(document.scripts || []).find(function (node) {
      return node.src && /\/cdn\/shop\/t\/\d+\/assets\/main\.js/i.test(node.src);
    });
    if (mainScript && mainScript.src) {
      THEME_ASSET_BASE = mainScript.src.replace(/main\.js(?:\?.*)?$/i, '');
      return THEME_ASSET_BASE;
    }
    var fallbackScript = Array.from(document.querySelectorAll('script[src],link[href]')).map(function (node) {
      return node.src || node.href || '';
    }).find(function (value) {
      return /\/cdn\/shop\/t\/\d+\/assets\//i.test(value);
    });
    if (fallbackScript) {
      var match = fallbackScript.match(/^(https?:)?\/\/[^/]+\/cdn\/shop\/t\/\d+\/assets\//i);
      if (match) {
        THEME_ASSET_BASE = match[0];
        return THEME_ASSET_BASE;
      }
    }
    return window.location.origin + '/cdn/shop/t/37/assets/';
  }

  function themeAssetUrl(filename) {
    if (!filename) return '';
    if (/^https?:\/\//i.test(filename) || filename.indexOf('//') === 0) return filename;
    return getThemeAssetBase() + filename;
  }

  function ensureArtistSearch(artSection) {
    if (!artSection || artSection.querySelector('.fbp-filter-search')) return;
    var artCollapse = artSection.querySelector('.collapse.flt-ele');
    if (!artCollapse || !artCollapse.parentNode) return;
    var input = document.createElement('input');
    input.type = 'text';
    input.placeholder = 'Search artists...';
    input.className = 'fbp-filter-search';
    artCollapse.parentNode.insertBefore(input, artCollapse);
    input.addEventListener('input', function () {
      var query = this.value.toLowerCase().trim();
      artCollapse.querySelectorAll('li').forEach(function (li) {
        var nameNode = li.querySelector('.filter-name');
        if (!nameNode) return;
        li.style.display = nameNode.textContent.toLowerCase().includes(query) ? '' : 'none';
      });
    });
  }

  function enhanceArtSection() {
    if (!isTargetPage()) return false;
    var artSection = document.querySelector('.shop-sidebar.art');
    if (!artSection) return false;

    artSection.querySelectorAll('li').forEach(function (li) {
      var nameNode = li.querySelector('.filter-name');
      var checkbox = li.querySelector('.cust-checkbox');
      if (!nameNode || !checkbox) return;
      if (li.querySelector('.fbp-artist-pfp, .fbp-artist-placeholder')) return;
      var artistName = nameNode.textContent.trim();
      var imageFilename = ARTIST_PFP[artistName];
      if (imageFilename) {
        var img = document.createElement('img');
        img.src = themeAssetUrl(imageFilename);
        img.alt = '';
        img.className = 'fbp-artist-pfp';
        img.decoding = 'async';
        checkbox.after(img);
      } else {
        var placeholder = document.createElement('span');
        placeholder.className = 'fbp-artist-placeholder';
        placeholder.textContent = artistName ? artistName.charAt(0).toUpperCase() : '?';
        checkbox.after(placeholder);
      }
    });

    ensureArtistSearch(artSection);
    return true;
  }

  function bootWhenReady(attempt) {
    if (enhanceArtSection()) return;
    if (attempt >= 80) return;
    window.setTimeout(function () { bootWhenReady(attempt + 1); }, 200);
  }

  function bindObserver() {
    if (window.__fbpOldFelineArtistRestoreObserverBound) return;
    window.__fbpOldFelineArtistRestoreObserverBound = true;
    var root = document.querySelector('stfilter-ele') || document.querySelector('.filter-sidebar');
    if (!root) return;
    new MutationObserver(function () {
      window.requestAnimationFrame(function () {
        enhanceArtSection();
      });
    }).observe(root, { childList: true, subtree: true });
  }

  function init() {
    if (!isTargetPage()) return;
    bootWhenReady(0);
    bindObserver();
    window.addEventListener('popstate', function () {
      window.setTimeout(function () { bootWhenReady(0); }, 60);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
/* FBP old feline artist avatars restore 2026-04-01 end */

/* FBP daki species filter behavior 2026-04-01 start */
(function () {
  if (window.__fbpDakiSpeciesFilterBehaviorV1Loaded) return;
  window.__fbpDakiSpeciesFilterBehaviorV1Loaded = true;

  var TARGET_PATHS = new Set([
    '/collections/feline-body-pillow',
    '/collections/feline-body-pillow2',
    '/collections/bird-body-pillow',
    '/collections/wolf-body-pillow',
    '/collections/dragon-body-pillows',
    '/collections/equines-body-pillow',
    '/collections/fox-body-pillow',
    '/collections/other-body-pillows',
    '/collections/raccoon-body-pillow',
    '/collections/sea-creatures-body-pillow'
  ]);
  var STYLE_ID = 'fbp-daki-species-filter-style';
  var SUMMARY_ID = 'fbp-daki-species-filter-summary';
  var HIDDEN_CATEGORY_PATHS = new Set([
    '/collections/all',
    '/collections/pillow-covers',
    '/collections/best-sellers',
    '/collections/blankets',
    '/collections/cork-coasters',
    '/collections/femboy',
    '/collections/hoodies',
    '/collections/mousepads',
    '/collections/new-arrivals',
    '/collections/new-design'
  ]);
  var ALL_DAKI_PATH = '/collections/body-pillow-covers-furry-dakimakura';

  function currentPath() {
    return window.location.pathname.replace(/\/+$/, '');
  }

  function isAllDakiShell() {
    return !!(document.body && document.body.classList.contains('collection-handle-body-pillow-covers-furry-dakimakura'));
  }

  function isTargetPage() {
    return document.body &&
      document.body.classList.contains('template-collection') &&
      !isAllDakiShell() &&
      TARGET_PATHS.has(currentPath());
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function getSidebar() {
    return document.querySelector('.filter-sidebar');
  }

  function getCategorySection() {
    return document.querySelector('.shop-collection');
  }

  function getCategoryList() {
    var section = getCategorySection();
    if (!section) return null;
    return section.querySelector(':scope > .collapse.flt-ele > ul') ||
      section.querySelector('.collapse.flt-ele ul') ||
      section.querySelector('ul');
  }

  function getFilterSections() {
    return Array.from(document.querySelectorAll('.shop-sidebar.st-filter'));
  }

  function getSectionHeading(section) {
    var heading = section && section.querySelector('.sidebar-heading');
    return heading ? heading.textContent.trim() : '';
  }

  function getSectionByHeading(name) {
    return getFilterSections().find(function (section) {
      return getSectionHeading(section) === name;
    }) || null;
  }

  function getArtistSection() {
    return document.querySelector('.shop-sidebar.art');
  }

  function getGenderSection() {
    return document.querySelector('.shop-sidebar.gender');
  }

  function getPriceSection() {
    return getFilterSections().find(function (section) {
      return getSectionHeading(section) === 'Price';
    }) || null;
  }

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      'body.template-collection.fbp-daki-species-filter-fixed .fbp-active-filters{display:none !important;}',
      'body.template-collection.fbp-daki-species-filter-fixed .fbp-hide-section{display:none !important;}',
      'body.template-collection.fbp-daki-species-filter-fixed #'+ SUMMARY_ID +'{display:block !important;background:rgba(255,255,255,0.78) !important;border:1px solid rgba(201,150,62,0.22) !important;border-radius:14px !important;padding:12px 14px !important;margin-bottom:16px !important;backdrop-filter:blur(16px) saturate(1.2) !important;-webkit-backdrop-filter:blur(16px) saturate(1.2) !important;box-shadow:0 6px 20px rgba(0,0,0,0.06) !important;}',
      'body.template-collection.fbp-daki-species-filter-fixed .fbp-dsf-header{display:flex !important;justify-content:space-between !important;align-items:center !important;gap:12px !important;margin-bottom:8px !important;}',
      'body.template-collection.fbp-daki-species-filter-fixed .fbp-dsf-label{font-size:11px !important;font-weight:700 !important;text-transform:uppercase !important;letter-spacing:0.08em !important;color:#c9963e !important;}',
      'body.template-collection.fbp-daki-species-filter-fixed .fbp-dsf-clear{background:none !important;border:none !important;padding:0 !important;font-size:11px !important;color:rgba(45,45,58,0.56) !important;text-decoration:underline !important;cursor:pointer !important;}',
      'body.template-collection.fbp-daki-species-filter-fixed .fbp-dsf-groups{display:flex !important;flex-direction:column !important;gap:8px !important;}',
      'body.template-collection.fbp-daki-species-filter-fixed .fbp-dsf-group{display:flex !important;align-items:flex-start !important;gap:8px !important;}',
      'body.template-collection.fbp-daki-species-filter-fixed .fbp-dsf-title{min-width:74px !important;font-size:11.5px !important;font-weight:600 !important;color:#2d2d3a !important;padding-top:3px !important;}',
      'body.template-collection.fbp-daki-species-filter-fixed .fbp-dsf-chips{display:flex !important;flex-wrap:wrap !important;gap:6px !important;}',
      'body.template-collection.fbp-daki-species-filter-fixed .fbp-dsf-chip{display:inline-flex !important;align-items:center !important;gap:4px !important;background:rgba(255,255,255,0.92) !important;border:1px solid rgba(201,150,62,0.3) !important;border-radius:999px !important;padding:3px 9px !important;font-size:12px !important;color:#2d2d3a !important;line-height:1.4 !important;}',
      'body.template-collection.fbp-daki-species-filter-fixed .fbp-dsf-chip-remove{background:none !important;border:none !important;padding:0 !important;margin-left:2px !important;font-size:14px !important;line-height:1 !important;color:rgba(45,45,58,0.54) !important;cursor:pointer !important;}',
      'body.template-collection.fbp-daki-species-filter-fixed .shop-collection .cust-checkbox-label,body.template-collection.fbp-daki-species-filter-fixed .shop-sidebar.art .cust-checkbox-label,body.template-collection.fbp-daki-species-filter-fixed .shop-sidebar.gender .cust-checkbox-label{position:relative !important;padding-left:34px !important;}',
      'body.template-collection.fbp-daki-species-filter-fixed .shop-collection input.cust-checkbox,body.template-collection.fbp-daki-species-filter-fixed .shop-sidebar.art input.cust-checkbox,body.template-collection.fbp-daki-species-filter-fixed .shop-sidebar.gender input.cust-checkbox{display:none !important;position:absolute !important;opacity:0 !important;pointer-events:none !important;width:0 !important;height:0 !important;margin:0 !important;padding:0 !important;border:0 !important;appearance:none !important;-webkit-appearance:none !important;}',
      'body.template-collection.fbp-daki-species-filter-fixed .shop-collection .cust-check,body.template-collection.fbp-daki-species-filter-fixed .shop-sidebar.art .cust-check,body.template-collection.fbp-daki-species-filter-fixed .shop-sidebar.gender .cust-check{display:flex !important;align-items:center !important;justify-content:center !important;position:absolute !important;left:8px !important;top:50% !important;transform:translateY(-50%) !important;width:18px !important;height:18px !important;border:1.5px solid rgba(45,45,58,0.22) !important;border-radius:4px !important;background:rgba(255,255,255,0.98) !important;box-shadow:none !important;overflow:hidden !important;color:#c9963e !important;font-size:14px !important;font-weight:700 !important;line-height:1 !important;font-family:Arial,sans-serif !important;}',
      'body.template-collection.fbp-daki-species-filter-fixed .shop-collection .cust-check::after,body.template-collection.fbp-daki-species-filter-fixed .shop-sidebar.art .cust-check::after,body.template-collection.fbp-daki-species-filter-fixed .shop-sidebar.gender .cust-check::after{content:"" !important;}',
      'body.template-collection.fbp-daki-species-filter-fixed .shop-collection li.fbp-active-cat > .cust-checkbox-label .cust-check::after,body.template-collection.fbp-daki-species-filter-fixed .shop-sidebar.art li.fbp-checked > .cust-checkbox-label .cust-check::after,body.template-collection.fbp-daki-species-filter-fixed .shop-sidebar.gender li.fbp-checked > .cust-checkbox-label .cust-check::after{content:"\\2713" !important;color:#c9963e !important;font-size:14px !important;line-height:1 !important;}',
      'body.template-collection.fbp-daki-species-filter-fixed .shop-collection li.fbp-active-cat > .cust-checkbox-label,body.template-collection.fbp-daki-species-filter-fixed .shop-sidebar.art li.fbp-checked > .cust-checkbox-label,body.template-collection.fbp-daki-species-filter-fixed .shop-sidebar.gender li.fbp-checked > .cust-checkbox-label{background:rgba(201,150,62,0.12) !important;color:#1a1a2e !important;border-radius:10px !important;}',
      'body.template-collection.fbp-daki-species-filter-fixed .shop-sidebar.art .fbp-artist-pfp{width:24px !important;height:24px !important;border-radius:999px !important;object-fit:cover !important;flex:0 0 auto !important;box-shadow:0 0 0 1px rgba(201,150,62,0.2) !important;background:#fff !important;}',
      '@media (min-width:1200px){body.template-collection.fbp-daki-species-filter-fixed .pro-grli-wrapper.left-side-wrap{display:grid !important;grid-template-columns:340px minmax(0,1fr) !important;column-gap:32px !important;align-items:start !important;}body.template-collection.fbp-daki-species-filter-fixed .pro-grli-wrapper.left-side-wrap > .pro-grli-wrap.product-sidebar{grid-column:1 !important;grid-row:1 !important;position:sticky !important;top:16px !important;align-self:start !important;margin:0 !important;width:100% !important;height:auto !important;}body.template-collection.fbp-daki-species-filter-fixed .pro-grli-wrapper.left-side-wrap > .pro-grli-wrap.product-grid{grid-column:2 !important;grid-row:1 !important;margin:0 !important;width:100% !important;max-width:none !important;}body.template-collection.fbp-daki-species-filter-fixed .pro-grli-wrapper.left-side-wrap > .pro-grli-wrap.product-grid .collection-img-wrap,body.template-collection.fbp-daki-species-filter-fixed .pro-grli-wrapper.left-side-wrap > .pro-grli-wrap.product-grid .shop-top-bar,body.template-collection.fbp-daki-species-filter-fixed .pro-grli-wrapper.left-side-wrap > .pro-grli-wrap.product-grid .get-data-products,body.template-collection.fbp-daki-species-filter-fixed .pro-grli-wrapper.left-side-wrap > .pro-grli-wrap.product-grid #ProductGridContainer,body.template-collection.fbp-daki-species-filter-fixed .pro-grli-wrapper.left-side-wrap > .pro-grli-wrap.product-grid .product-grid-view,body.template-collection.fbp-daki-species-filter-fixed .shop-product-wrap{width:100% !important;max-width:none !important;margin-left:0 !important;margin-right:0 !important;}body.template-collection.fbp-daki-species-filter-fixed #product-grid{display:grid !important;grid-template-columns:repeat(3,minmax(0,1fr)) !important;column-gap:30px !important;row-gap:24px !important;padding-left:0 !important;margin-left:0 !important;}body.template-collection.fbp-daki-species-filter-fixed #product-grid > li{display:block !important;flex:none !important;width:auto !important;max-width:none !important;margin-left:0 !important;}}'
    ].join('');
    document.head.appendChild(style);
  }

  function ensureSummaryBox() {
    var sidebar = getSidebar();
    var categorySection = getCategorySection();
    if (!sidebar || !categorySection) return null;
    var existing = document.getElementById(SUMMARY_ID);
    if (existing) return existing;
    var box = document.createElement('div');
    box.id = SUMMARY_ID;
    var closeButton = sidebar.querySelector('.close-filter-sidebar');
    if (closeButton) {
      closeButton.insertAdjacentElement('afterend', box);
    } else {
      categorySection.insertAdjacentElement('beforebegin', box);
    }
    box.addEventListener('click', function (event) {
      var clearButton = event.target.closest('.fbp-dsf-clear');
      if (clearButton) {
        event.preventDefault();
        window.location.href = ALL_DAKI_PATH;
        return;
      }
      var removeButton = event.target.closest('.fbp-dsf-chip-remove');
      if (!removeButton) return;
      event.preventDefault();
      var label = removeButton.closest('.fbp-dsf-chip')?.childNodes?.[0]?.textContent?.trim() || '';
      if (!label) return;
      var url = new URL(window.location.href);
      var inputId = removeButton.getAttribute('data-input-id') || '';
      if (inputId) {
        var input = document.getElementById(inputId);
        if (input) {
          removeValueFromSearch(url, input.name, input.value);
          navigateWithUrlObject(url);
          return;
        }
      }
      var removed = false;
      ['filter.p.product_type', 'filter.p.m.custom.gender'].forEach(function (paramName) {
        var values = url.searchParams.getAll(paramName);
        if (!values.length || values.indexOf(label) === -1) return;
        url.searchParams.delete(paramName);
        values.filter(function (value) { return value !== label; }).forEach(function (value) {
          url.searchParams.append(paramName, value);
        });
        removed = true;
      });
      if (removed) {
        navigateWithUrlObject(url);
      }
    });
    return box;
  }

  function cleanSearchParams(params) {
    ['filter.v.price.gte', 'filter.v.price.lte'].forEach(function (key) {
      if ((params.get(key) || '').trim() === '') {
        params.delete(key);
      }
    });
    if ((params.get('page') || '') === '1') {
      params.delete('page');
    }
    return params;
  }

  function cleanCurrentUrl() {
    var url = new URL(window.location.href);
    var before = url.search;
    cleanSearchParams(url.searchParams);
    if (url.search !== before) {
      history.replaceState(history.state, '', url.pathname + url.search + url.hash);
    }
  }

  function getCategoryPathForRow(li) {
    var link = li && li.querySelector('a[href*="/collections/"]');
    if (!link) return '';
    try {
      return new URL(link.href, window.location.origin).pathname.replace(/\/+$/, '');
    } catch (error) {
      return '';
    }
  }

  function normalizeCategories() {
    var list = getCategoryList();
    if (!list) return;
    var allRow = null;
    Array.from(list.children).forEach(function (li) {
      var labelNode = li.querySelector('.filter-name');
      if (!labelNode) return;
      var path = getCategoryPathForRow(li);
      var isActive = !!path && path === currentPath();
      var check = li.querySelector('.cust-check');
      if (path === ALL_DAKI_PATH) {
        labelNode.textContent = 'All Dakimakura Covers';
        allRow = li;
      }
      li.classList.toggle('fbp-active-cat', isActive);
      if (check) {
        check.textContent = isActive ? '✓' : '';
        check.setAttribute('aria-hidden', 'true');
      }
      li.style.display = HIDDEN_CATEGORY_PATHS.has(path) ? 'none' : '';
    });
    if (allRow && list.firstElementChild !== allRow) {
      list.insertBefore(allRow, list.firstElementChild);
    }
  }

  function hidePriceSection() {
    var section = getPriceSection();
    if (section) {
      section.classList.add('fbp-hide-section');
    }
  }

  function hoistNestedSections() {
    var priceSection = getPriceSection();
    if (!priceSection || !priceSection.parentElement) return;
    var parent = priceSection.parentElement;
    var nestedSections = Array.from(priceSection.querySelectorAll('.shop-sidebar.st-filter')).filter(function (section) {
      if (section === priceSection) return false;
      var heading = getSectionHeading(section);
      return heading === 'Art By :' || heading === 'Gender';
    });
    if (!nestedSections.length) return;
    var anchor = priceSection;
    nestedSections.forEach(function (section) {
      if (section.parentElement !== parent || section.previousElementSibling !== anchor) {
        parent.insertBefore(section, anchor.nextElementSibling);
      }
      anchor = section;
    });
  }

  function dedupeFilterSections() {
    var sidebar = getSidebar();
    if (!sidebar) return;
    ['Art By :', 'Gender'].forEach(function (heading) {
      var sections = getFilterSections().filter(function (section) {
        return getSectionHeading(section) === heading;
      });
      if (sections.length <= 1) return;
      var preferred = sections.find(function (section) {
        return section.parentElement === sidebar;
      }) || sections[0];
      sections.forEach(function (section) {
        if (section === preferred) return;
        section.remove();
      });
    });
  }

  function syncSectionState(section) {
    if (!section) return;
    var checkedInputs = Array.from(section.querySelectorAll('input.cust-checkbox:checked'));
    var countNode = section.querySelector('.flt-selected');
    if (countNode) {
      countNode.textContent = checkedInputs.length + ' selected';
    }
    var resetLink = section.querySelector('flt-clear a');
    if (resetLink) {
      resetLink.style.display = checkedInputs.length > 0 ? '' : 'none';
    }
    Array.from(section.querySelectorAll('li')).forEach(function (li) {
      li.classList.remove('fbp-checked');
      var input = li.querySelector('input.cust-checkbox');
      var check = li.querySelector('.cust-check');
      if (input && input.checked) {
        li.classList.add('fbp-checked');
      }
      if (check) {
        check.textContent = input && input.checked ? '✓' : '';
        check.setAttribute('aria-hidden', 'true');
      }
    });
  }

  function forceGrid3() {
    var grid = document.querySelector('#product-grid');
    var wrap = document.querySelector('.shop-product-wrap');
    if (wrap) {
      wrap.classList.remove('grid-1', 'grid-2', 'grid-4');
      wrap.classList.add('grid-3');
    }
    if (grid && window.matchMedia('(min-width: 1200px)').matches) {
      grid.style.display = 'grid';
      grid.style.gridTemplateColumns = 'repeat(3, minmax(0, 1fr))';
      grid.style.columnGap = '30px';
      grid.style.rowGap = '24px';
      grid.style.paddingLeft = '0';
      grid.style.marginLeft = '0';
    }
    Array.from(document.querySelectorAll('#product-grid > li')).forEach(function (item) {
      item.classList.remove('grid-1', 'grid-2', 'grid-4');
      item.classList.add('grid-3');
      if (window.matchMedia('(min-width: 1200px)').matches) {
        item.style.marginLeft = '0';
        item.style.width = 'auto';
        item.style.maxWidth = 'none';
        item.style.flex = 'none';
      }
    });
  }

  function getActiveCategoryLabel() {
    var active = document.querySelector('.shop-collection li.fbp-active-cat .filter-name');
    return active ? active.textContent.trim() : '';
  }

  function getCheckedItems(section, title) {
    if (!section) return null;
    var checked = Array.from(section.querySelectorAll('input.cust-checkbox:checked')).map(function (input) {
      var li = input.closest('li');
      var labelNode = li && li.querySelector('.filter-name');
      return {
        label: labelNode ? labelNode.textContent.trim() : input.value,
        inputId: input.id || '',
      };
    }).filter(function (item) {
      return !!item.label;
    });
    if (!checked.length) return null;
    return { title: title, items: checked };
  }

  function getParamValues(paramName) {
    var url = new URL(window.location.href);
    return Array.from(new Set(url.searchParams.getAll(paramName).map(function (value) {
      return (value || '').trim();
    }).filter(Boolean)));
  }

  function findFilterItem(section, value) {
    if (!section) return null;
    var input = Array.from(section.querySelectorAll('input.cust-checkbox')).find(function (node) {
      return (node.value || '').trim() === value;
    });
    if (!input) return null;
    var li = input.closest('li');
    var labelNode = li && li.querySelector('.filter-name');
    return {
      label: labelNode ? labelNode.textContent.trim() : value,
      inputId: input.id || '',
    };
  }

  function getUrlDrivenItems(section, paramName) {
    var values = getParamValues(paramName);
    if (!values.length) return [];
    return values.map(function (value) {
      return findFilterItem(section, value) || { label: value, inputId: '' };
    });
  }

  function renderSummary() {
    var box = ensureSummaryBox();
    if (!box) return;
    var groups = [
      {
        title: 'Product',
        items: [{ label: 'Dakimakura', inputId: '', removable: false }]
      }
    ];

    var categoryLabel = getActiveCategoryLabel();
    if (categoryLabel) {
      groups.push({
        title: 'Category',
        items: [{ label: categoryLabel, inputId: '', removable: false }]
      });
    }

    var artistItems = getUrlDrivenItems(getArtistSection(), 'filter.p.product_type');
    var genderItems = getUrlDrivenItems(getGenderSection(), 'filter.p.m.custom.gender');
    if (!artistItems.length) {
      var artistGroup = getCheckedItems(getArtistSection(), 'Artist');
      artistItems = artistGroup ? artistGroup.items : [];
    }
    if (!genderItems.length) {
      var genderGroup = getCheckedItems(getGenderSection(), 'Gender');
      genderItems = genderGroup ? genderGroup.items : [];
    }
    if (artistItems.length) {
      groups.push({
        title: 'Artist',
        items: artistItems.map(function (item) {
          return { label: item.label, inputId: item.inputId || '', removable: true };
        })
      });
    }
    if (genderItems.length) {
      groups.push({
        title: 'Gender',
        items: genderItems.map(function (item) {
          return { label: item.label, inputId: item.inputId || '', removable: true };
        })
      });
    }

    var html = '<div class="fbp-dsf-header"><span class="fbp-dsf-label">Selected filters</span><button type="button" class="fbp-dsf-clear">Clear all</button></div><div class="fbp-dsf-groups">';
    groups.forEach(function (group) {
      html += '<div class="fbp-dsf-group"><span class="fbp-dsf-title">' + escapeHtml(group.title) + ':</span><div class="fbp-dsf-chips">';
      group.items.forEach(function (item) {
        html += '<span class="fbp-dsf-chip">' + escapeHtml(item.label);
        if (item.removable) {
          html += '<button type="button" class="fbp-dsf-chip-remove" data-input-id="' + escapeHtml(item.inputId) + '">x</button>';
        }
        html += '</span>';
      });
      html += '</div></div>';
    });
    html += '</div>';
    box.innerHTML = html;
  }

  function triggerCheckbox(input, checked) {
    if (!input || input.checked === checked) return;
    input.checked = checked;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function navigateWithUrlObject(url) {
    cleanSearchParams(url.searchParams);
    ajaxNavigate(url.pathname + url.search + url.hash);
  }

  function removeValueFromSearch(url, paramName, value) {
    var values = url.searchParams.getAll(paramName).filter(function (entry) {
      return entry !== value;
    });
    url.searchParams.delete(paramName);
    values.forEach(function (entry) {
      url.searchParams.append(paramName, entry);
    });
  }

  function toggleFilterInUrl(paramName, value) {
    var url = new URL(window.location.href);
    cleanSearchParams(url.searchParams);
    var values = url.searchParams.getAll(paramName);
    if (values.indexOf(value) !== -1) {
      removeValueFromSearch(url, paramName, value);
    } else {
      url.searchParams.append(paramName, value);
    }
    navigateWithUrlObject(url);
  }

  function setSingleFilterInUrl(paramName, value) {
    var url = new URL(window.location.href);
    cleanSearchParams(url.searchParams);
    var values = url.searchParams.getAll(paramName);
    url.searchParams.delete(paramName);
    if (!(values.length === 1 && values[0] === value)) {
      url.searchParams.append(paramName, value);
    }
    navigateWithUrlObject(url);
  }

  function buildCollectionUrl(targetPath) {
    var url = new URL(window.location.href);
    cleanSearchParams(url.searchParams);
    url.pathname = targetPath;
    url.searchParams.delete('page');
    return url.pathname + url.search + url.hash;
  }

  function ajaxNavigate(url) {
    var wrap = document.querySelector('.shop-product-wrap');
    if (wrap) wrap.classList.add('fbp-loading');

    fetch(url, { credentials: 'same-origin' })
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('#product-grid');
        var oldGrid = document.querySelector('#product-grid');
        var newPagination = doc.querySelector('.paginatoin-area');
        var oldPagination = document.querySelector('.paginatoin-area');
        var newHeading = doc.querySelector('h1.st-title');
        var oldHeading = document.querySelector('h1.st-title');
        var newFilter = doc.querySelector('stfilter-ele');
        var oldFilter = document.querySelector('stfilter-ele');

        if (!newGrid || !oldGrid || !newFilter || !oldFilter) {
          window.location.href = url;
          return;
        }

        oldGrid.innerHTML = newGrid.innerHTML;
        if (newPagination && oldPagination) {
          oldPagination.innerHTML = newPagination.innerHTML;
        } else if (!newPagination && oldPagination) {
          oldPagination.innerHTML = '';
        }
        if (newHeading && oldHeading) {
          oldHeading.innerHTML = newHeading.innerHTML;
        }
        oldFilter.innerHTML = newFilter.innerHTML;
        history.pushState({ fbpSpeciesFilter: url }, '', url);
        document.title = doc.title;
        if (wrap) wrap.classList.remove('fbp-loading');
        window.setTimeout(refresh, 40);
      })
      .catch(function () {
        if (wrap) wrap.classList.remove('fbp-loading');
        window.location.href = url;
      });
  }

  function handleCategoryClick(event) {
    var link = event.target.closest('.shop-collection a[href*="/collections/"]');
    if (!link || !isTargetPage()) return false;
    var targetPath = '';
    try {
      targetPath = new URL(link.href, window.location.origin).pathname.replace(/\/+$/, '');
    } catch (error) {
      targetPath = '';
    }
    if (!targetPath) return false;
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }
    ajaxNavigate(buildCollectionUrl(targetPath));
    return true;
  }

  function handleSectionReset(event) {
    var link = event.target.closest('.shop-sidebar.art flt-clear a, .shop-sidebar.gender flt-clear a');
    if (!link || !isTargetPage()) return false;
    event.preventDefault();
    var section = link.closest('.shop-sidebar');
    if (!section) return false;
    var firstInput = section.querySelector('input.cust-checkbox');
    if (!firstInput) return false;
    var url = new URL(window.location.href);
    url.searchParams.delete(firstInput.name);
    navigateWithUrlObject(url);
    return true;
  }

  function handleLabelToggle(event) {
    var control = event.target.closest('.shop-sidebar.art .cust-checkbox-label, .shop-sidebar.gender .cust-checkbox-label, .shop-sidebar.art input.cust-checkbox, .shop-sidebar.gender input.cust-checkbox');
    if (!control || !isTargetPage()) return false;
    var input = control.matches('input.cust-checkbox') ? control : control.querySelector('input.cust-checkbox');
    if (!input) return false;
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }
    if (input.name === 'filter.p.m.custom.gender') {
      setSingleFilterInUrl(input.name, input.value);
    } else {
      toggleFilterInUrl(input.name, input.value);
    }
    return true;
  }

  function bindEvents() {
    if (window.__fbpDakiSpeciesFilterBehaviorV1Bound) return;
    window.__fbpDakiSpeciesFilterBehaviorV1Bound = true;

    document.addEventListener('click', function (event) {
      if (handleCategoryClick(event)) return;
      if (handleSectionReset(event)) return;
      handleLabelToggle(event);
    }, true);

    document.addEventListener('change', function (event) {
      if (!isTargetPage()) return;
      var input = event.target.closest('.shop-sidebar.art input.cust-checkbox, .shop-sidebar.gender input.cust-checkbox');
      if (!input) return;
      window.setTimeout(refresh, 60);
    }, true);

    window.addEventListener('popstate', function () {
      window.setTimeout(refresh, 60);
    });
  }

  function refresh() {
    if (!isTargetPage()) return;
    document.body.classList.add('fbp-daki-species-filter-fixed');
    injectStyle();
    cleanCurrentUrl();
    hoistNestedSections();
    dedupeFilterSections();
    hidePriceSection();
    normalizeCategories();
    syncSectionState(getArtistSection());
    syncSectionState(getGenderSection());
    renderSummary();
    forceGrid3();
  }

  function bindObserver() {
    if (window.__fbpDakiSpeciesFilterBehaviorV1Observer) return;
    var root = document.querySelector('stfilter-ele') || document.getElementById('main-collection-filters');
    if (!root) return;
    var observer = new MutationObserver(function () {
      cancelAnimationFrame(window.__fbpDakiSpeciesFilterBehaviorV1Raf);
      window.__fbpDakiSpeciesFilterBehaviorV1Raf = requestAnimationFrame(refresh);
    });
    observer.observe(root, { childList: true, subtree: true, attributes: true });
    window.__fbpDakiSpeciesFilterBehaviorV1Observer = observer;
  }

  function init() {
    bindEvents();
    if (!isTargetPage()) return;
    refresh();
    bindObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
/* FBP daki species filter behavior 2026-04-01 end */

/* FBP shop-by-category runtime images 2026-04-02 start */
(function () {
  if (window.__fbpShopByCategoryRuntimeImagesV1Loaded) return;
  window.__fbpShopByCategoryRuntimeImagesV1Loaded = true;

  var IMAGE_MAP = {"feline-body-pillow":"https://cdn.shopify.com/s/files/1/0332/1921/5496/files/snow-tiger-dakimakura__dressed.jpg?width=600","wolf-body-pillow":"https://cdn.shopify.com/s/files/1/0332/1921/5496/files/califra-wolf-dakimakura__swimsuit.jpg?width=600","dragon-body-pillows":"https://cdn.shopify.com/s/files/1/0332/1921/5496/files/female-sfw-queen.jpg?width=600","fox-body-pillow":"https://cdn.shopify.com/s/files/1/0332/1921/5496/files/esverty-fox-dakimakura__dressed.jpg?width=600","femboy":"https://cdn.shopify.com/s/files/1/0332/1921/5496/files/sam-raccoon-dakimakura__shorts.jpg?width=600","other-body-pillows":"https://cdn.shopify.com/s/files/1/0332/1921/5496/files/2201.jpg?width=600","sea-creatures-body-pillow":"https://cdn.shopify.com/s/files/1/0332/1921/5496/files/2201_3.jpg?width=600","bird-body-pillow":"https://cdn.shopify.com/s/files/1/0332/1921/5496/files/avi-avali-dakimakura__dressed.jpg?width=600","raccoon-body-pillow":"https://cdn.shopify.com/s/files/1/0332/1921/5496/files/sam-raccoon-dakimakura__shorts.jpg?width=600","equines-body-pillow":"https://cdn.shopify.com/s/files/1/0332/1921/5496/files/brett-horse-dakimakura__nude-sfw.jpg?width=600"};
  var TARGET_PATH = '/collections';
  var BROKEN_SRC_HINTS = [
    '01_65da73ff-388d-4bc5-ad8e-fc269e5d8b7f.png',
    '01_0cdc41b1-46e8-42cc-895d-bd59cca37298.png',
    '02_3ea0321e-32aa-4afe-9028-b9f173931426.png',
    '01_e927cd88-9f3d-4ba1-ae14-22453f1ab865.png',
    '01_91dec558-fb90-4de5-8803-3b8ec8521ca7.png',
    'Screenshot_1.png',
    'Screenshot_28.png'
  ];

  function currentPath() {
    return window.location.pathname.replace(/\/+$/, '') || '/';
  }

  function shouldReplace(img, fixedSrc) {
    if (!img || !fixedSrc) return false;
    var current = img.currentSrc || img.src || '';
    if (!current) return true;
    if (current === fixedSrc) return img.naturalWidth === 0;
    if (BROKEN_SRC_HINTS.some(function (part) { return current.indexOf(part) !== -1; })) return true;
    return img.naturalWidth === 0;
  }

  function applyFix() {
    if (currentPath() !== TARGET_PATH) return;
    var cards = document.querySelectorAll('a.fbp-cat3__species-card[data-collection]');
    cards.forEach(function (card) {
      var handle = card.getAttribute('data-collection') || '';
      var fixedSrc = IMAGE_MAP[handle];
      var img = card.querySelector('img.fbp-cat3__species-img');
      if (!img || !fixedSrc) return;
      if (shouldReplace(img, fixedSrc)) {
        img.src = fixedSrc;
        img.removeAttribute('srcset');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyFix, { once: true });
  } else {
    applyFix();
  }

  window.addEventListener('pageshow', applyFix);
  window.addEventListener('load', applyFix);
  setTimeout(applyFix, 250);
  setTimeout(applyFix, 1200);
})();
/* FBP shop-by-category runtime images 2026-04-02 end */

/* FBP product artist filter links 2026-04-02 start */
(function () {
  if (window.__fbpProductArtistLinksV1Loaded) return;
  window.__fbpProductArtistLinksV1Loaded = true;

  var STYLE_ID = 'fbp-product-artist-filter-link-style';
  var DEFAULT_COLLECTION_PATH = '/collections/body-pillow-covers-furry-dakimakura';

  function currentPath() {
    return window.location.pathname.replace(/\/+$/, '') || '/';
  }

  function getCollectionBasePath() {
    var path = currentPath();
    if (/^\/collections\/[^/]+$/.test(path)) return path;
    return DEFAULT_COLLECTION_PATH;
  }

  function artistFilterKey(name) {
    var key = String(name || '').replace(/\s+/g, ' ').trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    return key === 'qu-c-anh-ph-ng' ? 'quoc-anh-phung' : key;
  }

  function ensureStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '.product-artist .fbp-artist-filter-link{color:inherit !important;text-decoration:none !important;border-bottom:1px solid rgba(201,150,62,0.35) !important;transition:color .18s ease,border-color .18s ease,opacity .18s ease;}',
      '.product-artist .fbp-artist-filter-link:hover,.product-artist .fbp-artist-filter-link:focus-visible{color:#c9963e !important;border-bottom-color:#c9963e !important;outline:none !important;}'
    ].join('');
    document.head.appendChild(style);
  }

  function buildArtistHref(artistName) {
    var url = new URL(window.location.origin + getCollectionBasePath());
    if (/^\/collections\/[^/]+$/.test(currentPath())) {
      var params = new URLSearchParams(window.location.search);
      params.forEach(function (value, key) {
        if (key === 'page') return;
        if (key === 'filter.p.product_type') return;
        if (key !== 'sort_by' && key.indexOf('filter.') !== 0) return;
        url.searchParams.set(key, value);
      });
    }
    url.searchParams.delete('filter.p.product_type');
    url.searchParams.set('fbp_artist', artistFilterKey(artistName));
    url.searchParams.delete('page');
    return url.pathname + url.search;
  }

  function extractArtistName(text) {
    var cleaned = String(text || '').trim();
    for (var index = 0; index < 3; index += 1) {
      var next = cleaned.replace(/^\s*(?:by:|art\s+by:)\s*/i, '').trim();
      if (next === cleaned) break;
      cleaned = next;
    }
    return cleaned;
  }

  function linkArtistNode(node) {
    if (!node || node.dataset.fbpArtistLinked === '1') return;
    var text = node.textContent || '';
    var artistName = extractArtistName(text);
    if (!artistName) return;

    ensureStyle();

    var link = document.createElement('a');
    link.className = 'fbp-artist-filter-link';
    link.href = buildArtistHref(artistName);
    link.textContent = artistName;
    link.setAttribute('aria-label', 'Show all works by ' + artistName);

    var isEuLiquidationCard = !!node.closest('.fbp-eu-liquidation-card-item');
    node.textContent = '';
    node.appendChild(document.createTextNode(isEuLiquidationCard ? 'Art by: ' : 'by: '));
    node.appendChild(link);
    node.dataset.fbpArtistLinked = '1';
  }

  function applyArtistLinks(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('p.product-artist').forEach(linkArtistNode);
  }

  function watchForUpdates() {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i += 1) {
        var mutation = mutations[i];
        mutation.addedNodes.forEach(function (node) {
          if (!node || node.nodeType !== 1) return;
          if (node.matches && node.matches('p.product-artist')) {
            linkArtistNode(node);
            return;
          }
          if (node.querySelectorAll) {
            applyArtistLinks(node);
          }
        });
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { applyArtistLinks(document); }, { once: true });
  } else {
    applyArtistLinks(document);
  }

  window.addEventListener('pageshow', function () { applyArtistLinks(document); });
  window.addEventListener('load', function () { applyArtistLinks(document); });
  setTimeout(function () { applyArtistLinks(document); }, 300);
  setTimeout(function () { applyArtistLinks(document); }, 1200);
  watchForUpdates();
})();
/* FBP product artist filter links 2026-04-02 end */

/* FBP duplicated menu collapse id repair 2026-05-24 start */
(function () {
  if (window.__fbpMenuCollapseIdRepair20260524) return;
  window.__fbpMenuCollapseIdRepair20260524 = true;

  function repairMenuCollapseIds() {
    var seen = new Map();
    document.querySelectorAll('[id^="single-collapse-"]').forEach(function (panel) {
      var oldId = panel.id;
      var count = seen.get(oldId) || 0;
      seen.set(oldId, count + 1);
      if (count === 0) return;

      var newId = oldId + '-copy-' + count;
      panel.id = newId;
      var menuLink = panel.closest('.menu-link');
      if (!menuLink) return;
      var oldHref = '#' + oldId;
      var newHref = '#' + newId;
      menuLink.querySelectorAll('a[href="' + oldHref + '"]').forEach(function (link) {
        link.setAttribute('href', newHref);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', repairMenuCollapseIds, { once: true });
  } else {
    repairMenuCollapseIds();
  }
  window.addEventListener('pageshow', repairMenuCollapseIds);
  window.setTimeout(repairMenuCollapseIds, 500);
})();
/* FBP duplicated menu collapse id repair 2026-05-24 end */

/* FBP product species links 2026-04-02 start */
(function () {
  if (window.__fbpProductSpeciesLinksV1Loaded) return;
  window.__fbpProductSpeciesLinksV1Loaded = true;

  var SPECIES_BY_HANDLE = {"snow-tiger-dakimakura":{"label":"Feline","href":"/collections/feline-body-pillow","handle":"feline-body-pillow"},"simon-cat-dakimakura":{"label":"Feline","href":"/collections/feline-body-pillow","handle":"feline-body-pillow"},"diana-cat-dakimakura":{"label":"Feline","href":"/collections/feline-body-pillow","handle":"feline-body-pillow"},"ashing-cat-dakimakura":{"label":"Feline","href":"/collections/feline-body-pillow","handle":"feline-body-pillow"},"finn-hyena-dakimakura":{"label":"Feline","href":"/collections/feline-body-pillow","handle":"feline-body-pillow"},"sleeva-leopard-dakimakura":{"label":"Feline","href":"/collections/feline-body-pillow","handle":"feline-body-pillow"},"lumi-snow-leopard-dakimakura":{"label":"Feline","href":"/collections/feline-body-pillow","handle":"feline-body-pillow"},"orice-lion-dakimakura":{"label":"Feline","href":"/collections/feline-body-pillow","handle":"feline-body-pillow"},"clawson-dragon-dakimakura":{"label":"Feline","href":"/collections/feline-body-pillow","handle":"feline-body-pillow"},"sean-leopard-hoodie":{"label":"Feline","href":"/collections/feline-body-pillow","handle":"feline-body-pillow"},"misha-cat-dakimakura":{"label":"Feline","href":"/collections/feline-body-pillow","handle":"feline-body-pillow"},"fillona-cat-dakimakura":{"label":"Feline","href":"/collections/feline-body-pillow","handle":"feline-body-pillow"},"sinthia-cat-dakimakura":{"label":"Feline","href":"/collections/feline-body-pillow","handle":"feline-body-pillow"},"vanessa-cat-dakimakura":{"label":"Feline","href":"/collections/feline-body-pillow","handle":"feline-body-pillow"},"soraya-cat-dakimakura":{"label":"Feline","href":"/collections/feline-body-pillow","handle":"feline-body-pillow"},"michael-tiger-dakimakura":{"label":"Feline","href":"/collections/feline-body-pillow","handle":"feline-body-pillow"},"endive-deer-dakimakura":{"label":"Feline","href":"/collections/feline-body-pillow","handle":"feline-body-pillow"},"daki-tiger-dakimakura":{"label":"Feline","href":"/collections/feline-body-pillow","handle":"feline-body-pillow"},"equinix-leopard-dakimakura":{"label":"Feline","href":"/collections/feline-body-pillow","handle":"feline-body-pillow"},"darina-leopard-dakimakura":{"label":"Feline","href":"/collections/feline-body-pillow","handle":"feline-body-pillow"},"apricot-cheetah-dakimakura":{"label":"Feline","href":"/collections/feline-body-pillow","handle":"feline-body-pillow"},"clemetine-tiger-dakimakura":{"label":"Feline","href":"/collections/feline-body-pillow","handle":"feline-body-pillow"},"califra-wolf-dakimakura":{"label":"Canine","href":"/collections/wolf-body-pillow","handle":"wolf-body-pillow"},"ace-dog-dakimakura":{"label":"Canine","href":"/collections/wolf-body-pillow","handle":"wolf-body-pillow"},"zane-dog-dakimakura":{"label":"Canine","href":"/collections/wolf-body-pillow","handle":"wolf-body-pillow"},"bronx-the-punk-white-wolf-male-body-pillow":{"label":"Canine","href":"/collections/wolf-body-pillow","handle":"wolf-body-pillow"},"zyra-dog-dakimakura":{"label":"Canine","href":"/collections/wolf-body-pillow","handle":"wolf-body-pillow"},"louise-wolf-dakimakura":{"label":"Canine","href":"/collections/wolf-body-pillow","handle":"wolf-body-pillow"},"ares-husky-dakimakura":{"label":"Canine","href":"/collections/wolf-body-pillow","handle":"wolf-body-pillow"},"zevren-wolf-dakimakura":{"label":"Canine","href":"/collections/wolf-body-pillow","handle":"wolf-body-pillow"},"siera-wolf-dakimakura":{"label":"Canine","href":"/collections/wolf-body-pillow","handle":"wolf-body-pillow"},"daki-dog-dakimakura":{"label":"Canine","href":"/collections/wolf-body-pillow","handle":"wolf-body-pillow"},"sythe-dog-dakimakura":{"label":"Canine","href":"/collections/wolf-body-pillow","handle":"wolf-body-pillow"},"mia-dog-dakimakura":{"label":"Canine","href":"/collections/wolf-body-pillow","handle":"wolf-body-pillow"},"sofia-dog-dakimakura":{"label":"Canine","href":"/collections/wolf-body-pillow","handle":"wolf-body-pillow"},"anubis-dog-dakimakura":{"label":"Canine","href":"/collections/wolf-body-pillow","handle":"wolf-body-pillow"},"vexx-dog-dakimakura":{"label":"Canine","href":"/collections/wolf-body-pillow","handle":"wolf-body-pillow"},"ben-dog-dakimakura":{"label":"Canine","href":"/collections/wolf-body-pillow","handle":"wolf-body-pillow"},"toffee-husky-dakimakura":{"label":"Canine","href":"/collections/wolf-body-pillow","handle":"wolf-body-pillow"},"maxine-wolf-dakimakura":{"label":"Canine","href":"/collections/wolf-body-pillow","handle":"wolf-body-pillow"},"bernard-wolf-dakimakura":{"label":"Canine","href":"/collections/wolf-body-pillow","handle":"wolf-body-pillow"},"zephyr-dakimakura":{"label":"Dragon","href":"/collections/dragon-body-pillows","handle":"dragon-body-pillows"},"xaryax-dragon-dakimakura":{"label":"Dragon","href":"/collections/dragon-body-pillows","handle":"dragon-body-pillows"},"celestia-the-summer-dragon":{"label":"Dragon","href":"/collections/dragon-body-pillows","handle":"dragon-body-pillows"},"lirana-the-green-female-tribal-raptor":{"label":"Dragon","href":"/collections/dragon-body-pillows","handle":"dragon-body-pillows"},"angel-dragon-dakimakura":{"label":"Dragon","href":"/collections/dragon-body-pillows","handle":"dragon-body-pillows"},"dragi-dragon-dakimakura":{"label":"Dragon","href":"/collections/dragon-body-pillows","handle":"dragon-body-pillows"},"nyxiris-dragon-dakimakura":{"label":"Dragon","href":"/collections/dragon-body-pillows","handle":"dragon-body-pillows"},"venmys-dragon-dakimakura":{"label":"Dragon","href":"/collections/dragon-body-pillows","handle":"dragon-body-pillows"},"emerald-dragon-dakimakura":{"label":"Dragon","href":"/collections/dragon-body-pillows","handle":"dragon-body-pillows"},"eltro-dragon-dakimakura":{"label":"Dragon","href":"/collections/dragon-body-pillows","handle":"dragon-body-pillows"},"elizar-dragon-dakimakura":{"label":"Dragon","href":"/collections/dragon-body-pillows","handle":"dragon-body-pillows"},"sapphire-dragon-dakimakura":{"label":"Dragon","href":"/collections/dragon-body-pillows","handle":"dragon-body-pillows"},"nithe-dragon-dakimakura":{"label":"Dragon","href":"/collections/dragon-body-pillows","handle":"dragon-body-pillows"},"iberika-fox-dakimakura":{"label":"Dragon","href":"/collections/dragon-body-pillows","handle":"dragon-body-pillows"},"vinito-dragon-dakimakura":{"label":"Dragon","href":"/collections/dragon-body-pillows","handle":"dragon-body-pillows"},"agatha-dakimakura":{"label":"Dragon","href":"/collections/dragon-body-pillows","handle":"dragon-body-pillows"},"sinto-the-cute-and-shy-red-femboy-dragon":{"label":"Dragon","href":"/collections/dragon-body-pillows","handle":"dragon-body-pillows"},"lia-lamatt-dragon-dakimakura":{"label":"Dragon","href":"/collections/dragon-body-pillows","handle":"dragon-body-pillows"},"esverty-fox-dakimakura":{"label":"Fox","href":"/collections/fox-body-pillow","handle":"fox-body-pillow"},"heather-fox-dakimakura":{"label":"Fox","href":"/collections/fox-body-pillow","handle":"fox-body-pillow"},"fyra-fox-dakimakura":{"label":"Fox","href":"/collections/fox-body-pillow","handle":"fox-body-pillow"},"bernard-fox-dakimakura":{"label":"Fox","href":"/collections/fox-body-pillow","handle":"fox-body-pillow"},"boline-fox-dakimakura":{"label":"Fox","href":"/collections/fox-body-pillow","handle":"fox-body-pillow"},"mangolin-fox-dakimakura":{"label":"Fox","href":"/collections/fox-body-pillow","handle":"fox-body-pillow"},"cherry-fox-dakimakura":{"label":"Fox","href":"/collections/fox-body-pillow","handle":"fox-body-pillow"},"draven-fox-dakimakura":{"label":"Fox","href":"/collections/fox-body-pillow","handle":"fox-body-pillow"},"victoria-fox-dakimakura":{"label":"Fox","href":"/collections/fox-body-pillow","handle":"fox-body-pillow"},"diane-fox-dakimakura":{"label":"Fox","href":"/collections/fox-body-pillow","handle":"fox-body-pillow"},"tarka-otter-dakimakura":{"label":"Sea Creature","href":"/collections/sea-creatures-body-pillow","handle":"sea-creatures-body-pillow"},"erika-shark-dakimakura":{"label":"Sea Creature","href":"/collections/sea-creatures-body-pillow","handle":"sea-creatures-body-pillow"},"caroline-otter-dakimakura":{"label":"Sea Creature","href":"/collections/sea-creatures-body-pillow","handle":"sea-creatures-body-pillow"},"celti-otter-dakimakura":{"label":"Sea Creature","href":"/collections/sea-creatures-body-pillow","handle":"sea-creatures-body-pillow"},"ruby-shark-dakimakura":{"label":"Sea Creature","href":"/collections/sea-creatures-body-pillow","handle":"sea-creatures-body-pillow"},"burea-shark-dakimakura":{"label":"Sea Creature","href":"/collections/sea-creatures-body-pillow","handle":"sea-creatures-body-pillow"},"kelpily-the-otter-dakimakura":{"label":"Sea Creature","href":"/collections/sea-creatures-body-pillow","handle":"sea-creatures-body-pillow"},"hailina-shark-hoodie":{"label":"Sea Creature","href":"/collections/sea-creatures-body-pillow","handle":"sea-creatures-body-pillow"},"avi-avali-dakimakura":{"label":"Bird","href":"/collections/bird-body-pillow","handle":"bird-body-pillow"},"godwing-dragon-dakimakura":{"label":"Bird","href":"/collections/bird-body-pillow","handle":"bird-body-pillow"},"seraphina-bird-dakimakura":{"label":"Bird","href":"/collections/bird-body-pillow","handle":"bird-body-pillow"},"echodito-bat-dakimakura":{"label":"Bird","href":"/collections/bird-body-pillow","handle":"bird-body-pillow"},"fenyx-bird-dakimakura":{"label":"Bird","href":"/collections/bird-body-pillow","handle":"bird-body-pillow"},"cosmi-bat-dakimakura":{"label":"Bird","href":"/collections/bird-body-pillow","handle":"bird-body-pillow"},"sam-raccoon-dakimakura":{"label":"Raccoon","href":"/collections/raccoon-body-pillow","handle":"raccoon-body-pillow"},"rebecca-raccoon-dakimakura":{"label":"Raccoon","href":"/collections/raccoon-body-pillow","handle":"raccoon-body-pillow"},"joseph-raccoon-dakimakura":{"label":"Raccoon","href":"/collections/raccoon-body-pillow","handle":"raccoon-body-pillow"},"ziggy-raccoon-dakimakura":{"label":"Raccoon","href":"/collections/raccoon-body-pillow","handle":"raccoon-body-pillow"},"brett-horse-dakimakura":{"label":"Equine","href":"/collections/equines-body-pillow","handle":"equines-body-pillow"},"kizya-horse-dakimakura":{"label":"Equine","href":"/collections/equines-body-pillow","handle":"equines-body-pillow"},"ashen-bunny-dakimakura":{"label":"Other Species","href":"/collections/other-body-pillows","handle":"other-body-pillows"},"equa-dakimakura":{"label":"Other Species","href":"/collections/other-body-pillows","handle":"other-body-pillows"},"elevit-dakimakura":{"label":"Other Species","href":"/collections/other-body-pillows","handle":"other-body-pillows"},"starry-dakimakura":{"label":"Other Species","href":"/collections/other-body-pillows","handle":"other-body-pillows"},"asher-dakimakura":{"label":"Other Species","href":"/collections/other-body-pillows","handle":"other-body-pillows"},"protis-protogen-dakimakura":{"label":"Other Species","href":"/collections/other-body-pillows","handle":"other-body-pillows"},"zara-dakimakura":{"label":"Other Species","href":"/collections/other-body-pillows","handle":"other-body-pillows"},"leila-bear-dakimakura":{"label":"Other Species","href":"/collections/other-body-pillows","handle":"other-body-pillows"},"fridolie-bunny-dakimakura":{"label":"Other Species","href":"/collections/other-body-pillows","handle":"other-body-pillows"},"fawnelle-deer-dakimakura":{"label":"Other Species","href":"/collections/other-body-pillows","handle":"other-body-pillows"},"jessie-bunny-dakimakura":{"label":"Other Species","href":"/collections/other-body-pillows","handle":"other-body-pillows"},"koto-dakimakura":{"label":"Other Species","href":"/collections/other-body-pillows","handle":"other-body-pillows"}};
  var STYLE_ID = 'fbp-product-species-link-style';

  function ensureStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '.product-species{font-size:13px !important;color:#888 !important;margin:0 0 6px !important;text-align:center !important;}',
      '.product-species .fbp-species-filter-link{color:inherit !important;text-decoration:none !important;border-bottom:1px solid rgba(201,150,62,0.35) !important;transition:color .18s ease,border-color .18s ease,opacity .18s ease;}',
      '.product-species .fbp-species-filter-link:hover,.product-species .fbp-species-filter-link:focus-visible{color:#c9963e !important;border-bottom-color:#c9963e !important;outline:none !important;}'
    ].join('');
    document.head.appendChild(style);
  }

  function getProductHandleFromCard(card) {
    var link = card && (card.querySelector('.product-title a[href*="/products/"]') || card.querySelector('.pro-img[href*="/products/"]'));
    var href = link ? (link.getAttribute('href') || '') : '';
    var match = href.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function addSpeciesLine(card) {
    if (!card) return;
    var content = card.querySelector('.product-content');
    if (!content) return;

    var handle = getProductHandleFromCard(card);
    var species = SPECIES_BY_HANDLE[handle];
    if (!species) return;

    ensureStyle();

    var existing = content.querySelector('p.product-species');
    if (existing) {
      existing.innerHTML = 'Species: <a class="fbp-species-filter-link" href="' + species.href + '" aria-label="Show all ' + species.label + ' daki">' + species.label + '</a>';
      return;
    }

    var node = document.createElement('p');
    node.className = 'product-species';
    node.innerHTML = 'Species: <a class="fbp-species-filter-link" href="' + species.href + '" aria-label="Show all ' + species.label + ' daki">' + species.label + '</a>';

    var artist = content.querySelector('p.product-artist');
    var price = content.querySelector('.price-box');
    if (artist) {
      artist.insertAdjacentElement('afterend', node);
      return;
    }
    if (price) {
      price.insertAdjacentElement('beforebegin', node);
      return;
    }
    content.appendChild(node);
  }

  function applySpeciesLines(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.single-product-wrap').forEach(addSpeciesLine);
  }

  function watchForUpdates() {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i += 1) {
        var mutation = mutations[i];
        mutation.addedNodes.forEach(function (node) {
          if (!node || node.nodeType !== 1) return;
          if (node.matches && node.matches('.single-product-wrap')) {
            addSpeciesLine(node);
            return;
          }
          if (node.querySelectorAll) {
            applySpeciesLines(node);
          }
        });
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { applySpeciesLines(document); }, { once: true });
  } else {
    applySpeciesLines(document);
  }

  window.addEventListener('pageshow', function () { applySpeciesLines(document); });
  window.addEventListener('load', function () { applySpeciesLines(document); });
  setTimeout(function () { applySpeciesLines(document); }, 300);
  setTimeout(function () { applySpeciesLines(document); }, 1200);
  watchForUpdates();
})();
/* FBP product species links 2026-04-02 end */

/* FBP best-sellers runtime bridge 2026-04-02 start */
(function() {
  var STYLE_ID = 'fbp-best-sellers-runtime-top10-style';
  var RETRY_KEY = '__fbpBestSellersRuntimeAttempts';

  function ensureStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '.template-index section.special-category.fbp-best-sellers-runtime .swiper-dots{display:block!important;margin-top:44px!important;}',
      '.template-index section.special-category.fbp-best-sellers-runtime .swiper-pagination.swiper-pagination-bullets{display:flex!important;justify-content:center;gap:10px;margin:0!important;}',
      '.template-index section.special-category.fbp-best-sellers-runtime .swiper-pagination.swiper-pagination-bullet{width:44px;height:44px;margin:0!important;border:1px solid rgba(213,164,65,.45);border-radius:999px;background:rgba(255,255,255,.88);color:#6a5524;font-size:15px;font-weight:800;opacity:1;display:inline-flex;align-items:center;justify-content:center;cursor:pointer;transition:transform .18s ease,background .18s ease,color .18s ease,border-color .18s ease;}',
      '.template-index section.special-category.fbp-best-sellers-runtime .swiper-pagination.swiper-pagination-bullet.swiper-pagination-bullet-active{background:linear-gradient(135deg,#f3d88d 0%,#d5a441 100%);border-color:#d5a441;color:#3f2b04;transform:translateY(-1px);box-shadow:0 10px 20px rgba(213,164,65,.16);}',
      '.template-index section.special-category.fbp-best-sellers-runtime .fbp-best-seller-shell{position:relative;width:100%;padding-top:26px;}',
      '.template-index section.special-category.fbp-best-sellers-runtime .fbp-best-seller-shell .single-product-wrap{height:100%!important;display:flex!important;flex-direction:column!important;}',
      '.template-index section.special-category.fbp-best-sellers-runtime .fbp-best-seller-shell .product-content{flex:1 1 auto!important;display:flex!important;flex-direction:column!important;}',
      '.template-index section.special-category.fbp-best-sellers-runtime .fbp-best-seller-shell.is-most-sold .single-product-wrap{border:2px solid #d5a441!important;border-radius:24px!important;box-shadow:0 22px 48px rgba(213,164,65,.18)!important;}',
      '.template-index section.special-category.fbp-best-sellers-runtime .fbp-most-sold-badge{position:absolute;top:0;left:18px;z-index:6;display:inline-flex;align-items:center;justify-content:center;min-height:34px;padding:7px 14px;border-radius:999px;background:linear-gradient(135deg,#f3d88d 0%,#d5a441 100%);color:#3f2b04;font-size:12px;font-weight:800;letter-spacing:.08em;text-transform:uppercase;box-shadow:0 12px 24px rgba(213,164,65,.22);}',
      '.template-index section.special-category.fbp-best-sellers-runtime .swiper-wrapper{align-items:stretch!important;}',
      '.template-index section.special-category.fbp-best-sellers-runtime .swiper-slide{height:auto!important;display:flex!important;}',
      '.template-index section.special-category.fbp-best-sellers-runtime .swiper-slide > *{width:100%!important;}',
      '@media (max-width:1023px){.template-index section.special-category.fbp-best-sellers-runtime .swiper-dots{display:none!important;}}'
    ].join('');
    document.head.appendChild(style);
  }

  function getSection() {
    var sections = Array.prototype.slice.call(document.querySelectorAll('section.special-category'));
    return sections.find(function(section) {
      var heading = section.querySelector('.section-title h2');
      return heading && heading.textContent && heading.textContent.trim() === 'Best Sellers';
    }) || null;
  }

  function wrapSlides(section) {
    var slides = Array.prototype.slice.call(section.querySelectorAll('.swiper-wrapper > .swiper-slide'));
    slides.forEach(function(slide, index) {
      var card = slide.querySelector('.single-product-wrap');
      if (!card) return;
      var shell = slide.querySelector(':scope > .fbp-best-seller-shell');
      if (!shell) {
        shell = document.createElement('div');
        shell.className = 'fbp-best-seller-shell';
        slide.insertBefore(shell, slide.firstChild);
        shell.appendChild(card);
      }
      shell.classList.toggle('is-most-sold', index === 0);
      var badge = shell.querySelector('.fbp-most-sold-badge');
      if (index === 0) {
        if (!badge) {
          badge = document.createElement('div');
          badge.className = 'fbp-most-sold-badge';
          badge.textContent = 'Most sold design';
          shell.insertBefore(badge, shell.firstChild);
        }
      } else if (badge) {
        badge.remove();
      }
    });
  }

  function patchSwiper(section) {
    var slider = section.querySelector('.special-slider.swiper');
    if (!slider || !slider.swiper) return false;
    var swiper = slider.swiper;
    var desktopGroup = 4;
    swiper.params.slidesPerGroup = window.innerWidth >= 1024 ? desktopGroup : 1;
    if (swiper.params.breakpoints) {
      [0, 320].forEach(function(key) {
        if (swiper.params.breakpoints[key]) swiper.params.breakpoints[key].slidesPerGroup = 1;
      });
      [360, 540].forEach(function(key) {
        if (swiper.params.breakpoints[key]) swiper.params.breakpoints[key].slidesPerGroup = 2;
      });
      [640, 768].forEach(function(key) {
        if (swiper.params.breakpoints[key]) swiper.params.breakpoints[key].slidesPerGroup = 3;
      });
      [1024, 1199].forEach(function(key) {
        if (swiper.params.breakpoints[key]) swiper.params.breakpoints[key].slidesPerGroup = desktopGroup;
      });
    }
    swiper.params.pagination = swiper.params.pagination || {};
    swiper.params.pagination.clickable = true;
    swiper.params.pagination.renderBullet = function(index, className) {
      return '<button type="button" class="' + className + '">' + (index + 1) + '</button>';
    };
    if (swiper.autoplay && typeof swiper.autoplay.stop === 'function') {
      swiper.autoplay.stop();
    }
    if (swiper.pagination) {
      if (typeof swiper.pagination.destroy === 'function') swiper.pagination.destroy();
      if (typeof swiper.pagination.init === 'function') swiper.pagination.init();
      if (typeof swiper.pagination.render === 'function') swiper.pagination.render();
      if (typeof swiper.pagination.update === 'function') swiper.pagination.update();
    }
    swiper.update();
    return true;
  }

  function enhance() {
    if (!document.body.classList.contains('template-index')) return;
    var section = getSection();
    if (!section) return;
    ensureStyle();
    section.classList.add('fbp-best-sellers-runtime');
    wrapSlides(section);
    patchSwiper(section);
  }

  function queueEnhance() {
    window[RETRY_KEY] = (window[RETRY_KEY] || 0) + 1;
    enhance();
    if (window[RETRY_KEY] < 8) {
      window.setTimeout(enhance, 600 * window[RETRY_KEY]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', queueEnhance, { once: true });
  } else {
    queueEnhance();
  }
  window.addEventListener('load', enhance);
  document.addEventListener('shopify:section:load', enhance);
  window.addEventListener('resize', function() {
    window.clearTimeout(window.__fbpBestSellersResizeTimer);
    window.__fbpBestSellersResizeTimer = window.setTimeout(enhance, 180);
  });
})();
/* FBP best-sellers runtime bridge 2026-04-02 end */

/* FBP new-arrivals newest highlight runtime bridge 2026-04-03 start */
(function() {
  var STYLE_ID = 'fbp-new-arrivals-runtime-newest-style';
  var RETRY_KEY = '__fbpNewArrivalsRuntimeAttempts';
  var MAX_ATTEMPTS = 20;
  var OBSERVER_KEY = '__fbpNewArrivalsObserverAttached';
  var DEFER_START_INDEX = 12;
  var PLACEHOLDER_SRC = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';

  function ensureStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '.template-index section.special-category.fbp-new-arrivals-runtime .swiper-dots{display:block!important;margin-top:44px!important;}',
      '.template-index section.special-category.fbp-new-arrivals-runtime .swiper-pagination{display:flex!important;justify-content:center;gap:10px;margin:0!important;}',
      '.template-index section.special-category.fbp-new-arrivals-runtime .swiper-pagination .swiper-pagination-bullet{width:44px!important;height:44px!important;margin:0!important;border:1px solid rgba(213,164,65,.45)!important;border-radius:999px!important;background:rgba(255,255,255,.88)!important;color:#6a5524!important;font-size:15px!important;font-weight:800!important;opacity:1!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;cursor:pointer;transition:transform .18s ease,background .18s ease,color .18s ease,border-color .18s ease;line-height:1!important;padding:0!important;}',
      '.template-index section.special-category.fbp-new-arrivals-runtime .swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active{background:linear-gradient(135deg,#f3d88d 0%,#d5a441 100%)!important;border-color:#d5a441!important;color:#3f2b04!important;transform:translateY(-1px);box-shadow:0 10px 20px rgba(213,164,65,.16);}',
      '.template-index section.special-category.fbp-new-arrivals-runtime .single-product-wrap.is-newest-design{position:relative!important;}',
      '.template-index section.special-category.fbp-new-arrivals-runtime .single-product-wrap.is-newest-design::after{content:"";position:absolute;inset:0;border:2px solid #d5a441;border-radius:24px;box-shadow:0 22px 48px rgba(213,164,65,.18);pointer-events:none;z-index:5;}',
      '.template-index section.special-category.fbp-new-arrivals-runtime .fbp-newest-badge{position:absolute;top:14px;left:14px;z-index:6;display:inline-flex;align-items:center;justify-content:center;min-height:32px;padding:7px 14px;border-radius:999px;background:linear-gradient(135deg,#f3d88d 0%,#d5a441 100%);color:#3f2b04;font-size:12px;font-weight:800;letter-spacing:.08em;text-transform:uppercase;box-shadow:0 12px 24px rgba(213,164,65,.22);pointer-events:none;}',
      '@media (max-width:1023px){.template-index section.special-category.fbp-new-arrivals-runtime .swiper-dots{display:none!important;}.template-index section.special-category.fbp-new-arrivals-runtime .fbp-newest-badge{top:12px;left:12px;min-height:28px;padding:6px 12px;font-size:11px;}}'
    ].join('');
    document.head.appendChild(style);
  }

  function getSection() {
    var sections = Array.prototype.slice.call(document.querySelectorAll('section.special-category'));
    return sections.find(function(section) {
      var heading = section.querySelector('.section-title h2');
      return heading && heading.textContent && heading.textContent.trim() === 'New Arrivals';
    }) || null;
  }

  function watchVisibility(section) {
    if (!section || section[OBSERVER_KEY]) return;
    section[OBSERVER_KEY] = true;
    if (typeof IntersectionObserver === 'function') {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            window.setTimeout(queueEnhance, 80);
            window.setTimeout(queueEnhance, 500);
          }
        });
      }, { rootMargin: '240px 0px' });
      observer.observe(section);
    }
  }

  function markNewest(section) {
    var slides = Array.prototype.slice.call(section.querySelectorAll('.swiper-wrapper > .swiper-slide'));
    slides.forEach(function(slide, index) {
      var card = slide.querySelector('.single-product-wrap');
      if (!card) return;
      card.classList.toggle('is-newest-design', index === 0);
      var badge = card.querySelector(':scope > .fbp-newest-badge');
      if (index === 0) {
        if (!badge) {
          badge = document.createElement('div');
          badge.className = 'fbp-newest-badge';
          badge.textContent = 'Newest';
          card.insertBefore(badge, card.firstChild);
        }
      } else if (badge) {
        badge.remove();
      }
    });
  }

  function deferFuturePages(section) {
    if (!section || section.dataset.fbpDeferredPrepared === '1') return;
    var slides = Array.prototype.slice.call(section.querySelectorAll('.swiper-wrapper > .swiper-slide'));
    slides.forEach(function(slide, index) {
      if (index < DEFER_START_INDEX) return;
      Array.prototype.slice.call(slide.querySelectorAll('img')).forEach(function(img) {
        if (!img || img.dataset.fbpDeferredPrepared === '1') return;
        var src = img.getAttribute('src');
        var srcset = img.getAttribute('srcset');
        var sizes = img.getAttribute('sizes');
        if (src) img.dataset.fbpDeferredSrc = src;
        if (srcset) img.dataset.fbpDeferredSrcset = srcset;
        if (sizes) img.dataset.fbpDeferredSizes = sizes;
        img.setAttribute('src', PLACEHOLDER_SRC);
        img.removeAttribute('srcset');
        if (sizes) img.removeAttribute('sizes');
        img.dataset.fbpDeferredPrepared = '1';
        img.dataset.fbpDeferredLive = '0';
      });
      slide.dataset.fbpDeferredPage = '1';
    });
    section.dataset.fbpDeferredPrepared = '1';
  }

  function restoreDeferredPages(section) {
    if (!section || section.dataset.fbpDeferredLoaded === '1') return;
    Array.prototype.slice.call(section.querySelectorAll('.swiper-wrapper > .swiper-slide[data-fbp-deferred-page="1"] img[data-fbp-deferred-prepared="1"]')).forEach(function(img) {
      if (img.dataset.fbpDeferredSrc) img.setAttribute('src', img.dataset.fbpDeferredSrc);
      if (img.dataset.fbpDeferredSrcset) img.setAttribute('srcset', img.dataset.fbpDeferredSrcset);
      if (img.dataset.fbpDeferredSizes) img.setAttribute('sizes', img.dataset.fbpDeferredSizes);
      img.dataset.fbpDeferredLive = '1';
    });
    section.dataset.fbpDeferredLoaded = '1';
  }

  function bindDeferredPager(section) {
    if (!section || section.dataset.fbpDeferredBound === '1') return;
    section.dataset.fbpDeferredBound = '1';
    section.addEventListener('pointerdown', function(event) {
      var bullet = event.target && event.target.closest ? event.target.closest('.swiper-pagination .swiper-pagination-bullet') : null;
      if (!bullet) return;
      var pageNumber = parseInt((bullet.textContent || '').trim(), 10);
      if (pageNumber >= 4) {
        restoreDeferredPages(section);
      }
    }, true);
  }

  function patchSwiper(section) {
    var slider = section.querySelector('.special-slider.swiper');
    if (!slider || !slider.swiper) return false;
    var swiper = slider.swiper;
    var desktopGroup = 4;
    swiper.params.slidesPerGroup = window.innerWidth >= 1024 ? desktopGroup : 1;
    if (swiper.params.breakpoints) {
      [0, 320].forEach(function(key) {
        if (swiper.params.breakpoints[key]) swiper.params.breakpoints[key].slidesPerGroup = 1;
      });
      [360, 540].forEach(function(key) {
        if (swiper.params.breakpoints[key]) swiper.params.breakpoints[key].slidesPerGroup = 2;
      });
      [640, 768].forEach(function(key) {
        if (swiper.params.breakpoints[key]) swiper.params.breakpoints[key].slidesPerGroup = 3;
      });
      [1024, 1199].forEach(function(key) {
        if (swiper.params.breakpoints[key]) swiper.params.breakpoints[key].slidesPerGroup = desktopGroup;
      });
    }
    swiper.params.pagination = swiper.params.pagination || {};
    swiper.params.pagination.clickable = true;
    swiper.params.pagination.renderBullet = function(index, className) {
      return '<button type="button" class="' + className + '">' + (index + 1) + '</button>';
    };
    if (swiper.originalParams) {
      swiper.originalParams.slidesPerGroup = window.innerWidth >= 1024 ? desktopGroup : 1;
      swiper.originalParams.pagination = swiper.originalParams.pagination || {};
      swiper.originalParams.pagination.clickable = true;
      swiper.originalParams.pagination.renderBullet = swiper.params.pagination.renderBullet;
      if (swiper.originalParams.breakpoints) {
        [0, 320].forEach(function(key) {
          if (swiper.originalParams.breakpoints[key]) swiper.originalParams.breakpoints[key].slidesPerGroup = 1;
        });
        [360, 540].forEach(function(key) {
          if (swiper.originalParams.breakpoints[key]) swiper.originalParams.breakpoints[key].slidesPerGroup = 2;
        });
        [640, 768].forEach(function(key) {
          if (swiper.originalParams.breakpoints[key]) swiper.originalParams.breakpoints[key].slidesPerGroup = 3;
        });
        [1024, 1199].forEach(function(key) {
          if (swiper.originalParams.breakpoints[key]) swiper.originalParams.breakpoints[key].slidesPerGroup = desktopGroup;
        });
      }
    }
    if (typeof swiper.setBreakpoint === 'function') {
      swiper.setBreakpoint();
    }
    if (swiper.pagination) {
      if (typeof swiper.pagination.destroy === 'function') swiper.pagination.destroy();
      if (typeof swiper.pagination.init === 'function') swiper.pagination.init();
      if (typeof swiper.pagination.render === 'function') swiper.pagination.render();
      if (typeof swiper.pagination.update === 'function') swiper.pagination.update();
    }
    var paginationEl = section.querySelector('.swiper-pagination');
    if (paginationEl) {
      paginationEl.classList.add('swiper-pagination-bullets');
    }
    if (!swiper.__fbpDeferredPageHooked && typeof swiper.on === 'function') {
      swiper.__fbpDeferredPageHooked = true;
      swiper.on('slideChangeTransitionStart', function() {
        if (swiper.activeIndex >= DEFER_START_INDEX) {
          restoreDeferredPages(section);
        }
      });
    }
    swiper.update();
    var bullets = section.querySelectorAll('.swiper-pagination .swiper-pagination-bullet');
    return bullets.length > 0 && Array.prototype.some.call(bullets, function(el) { return el.textContent && el.textContent.trim(); });
  }

  function enhance() {
    if (!document.body.classList.contains('template-index')) return;
    var section = getSection();
    if (!section) return;
    ensureStyle();
    section.classList.add('fbp-new-arrivals-runtime');
    watchVisibility(section);
    markNewest(section);
    deferFuturePages(section);
    bindDeferredPager(section);
    return patchSwiper(section);
  }

  function queueEnhance() {
    window[RETRY_KEY] = (window[RETRY_KEY] || 0) + 1;
    var ready = enhance();
    if (!ready && window[RETRY_KEY] < MAX_ATTEMPTS) {
      window.setTimeout(queueEnhance, 500 + 200 * window[RETRY_KEY]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', queueEnhance, { once: true });
  } else {
    queueEnhance();
  }
  window.addEventListener('load', enhance);
  document.addEventListener('shopify:section:load', enhance);
  window.addEventListener('scroll', function() {
    window.clearTimeout(window.__fbpNewArrivalsScrollTimer);
    window.__fbpNewArrivalsScrollTimer = window.setTimeout(enhance, 120);
  }, { passive: true });
  window.addEventListener('resize', function() {
    window.clearTimeout(window.__fbpNewArrivalsResizeTimer);
    window.__fbpNewArrivalsResizeTimer = window.setTimeout(enhance, 180);
  });
})();
/* FBP new-arrivals newest highlight runtime bridge 2026-04-03 end */

/* FBP desktop collection filter toggle 2026-04-03 start */
(function () {
  if (window.__fbpDesktopCollectionFilterToggleLoaded) return;
  window.__fbpDesktopCollectionFilterToggleLoaded = true;

  var STYLE_ID = 'fbp-desktop-collection-filter-toggle-style';
  var COLLAPSED_CLASS = 'fbp-desktop-filter-collapsed';
  var READY_CLASS = 'fbp-desktop-filter-toggle-ready';
  var ANIMATING_CLASS = 'fbp-desktop-filter-animating';
  var TOGGLE_DURATION_MS = 220;
  var STORAGE_KEY = 'fbpDesktopCollectionFilterCollapsed:' + location.pathname;

  function isCollectionPage() {
    return document.body.classList.contains('template-collection');
  }

  function isDesktop() {
    return window.innerWidth >= 1024;
  }

  function ensureStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '@media (min-width:1024px){',
      'body.template-collection.' + READY_CLASS + '{--fbp-collapsed-grid-width:1460px;--fbp-collapsed-card-width:341px;--fbp-collapsed-header-width:1072px;--fbp-collapsed-header-offset:320px;}',
      'body.template-collection.' + READY_CLASS + ' .product-filter .filter-button{transition:background .18s ease,color .18s ease,border-color .18s ease,transform .18s ease;}',
      'body.template-collection.' + READY_CLASS + ' .product-filter .filter-button[aria-pressed="true"]{background:linear-gradient(135deg,#f3d88d 0%,#d5a441 100%)!important;border-color:#d5a441!important;color:#3f2b04!important;box-shadow:0 10px 20px rgba(213,164,65,.16);}',
      'body.template-collection.' + READY_CLASS + ' .fbp-top-pagination{margin:18px 0 18px!important;}',
      'body.template-collection.' + READY_CLASS + ' .fbp-top-pagination .pagination-box{margin:0!important;}',
      'body.template-collection.' + READY_CLASS + ' .pro-grli-wrapper.left-side-wrap{overflow:hidden!important;}',
      'body.template-collection.' + READY_CLASS + ' .pro-grli-wrap.product-sidebar{display:block!important;overflow:hidden!important;transition:max-width .20s cubic-bezier(.28,.84,.42,1),flex-basis .20s cubic-bezier(.28,.84,.42,1),width .20s cubic-bezier(.28,.84,.42,1),opacity .16s ease,transform .20s cubic-bezier(.28,.84,.42,1),margin-right .20s cubic-bezier(.28,.84,.42,1),clip-path .20s cubic-bezier(.28,.84,.42,1);transform:translateX(0);opacity:1;max-width:320px;clip-path:inset(0 0 0 0);}',
      'body.template-collection.' + READY_CLASS + ' .pro-grli-wrap.product-grid{overflow:visible!important;transition:max-width .20s cubic-bezier(.28,.84,.42,1),flex-basis .20s cubic-bezier(.28,.84,.42,1),width .20s cubic-bezier(.28,.84,.42,1),padding .20s cubic-bezier(.28,.84,.42,1);}',
      'body.template-collection.' + READY_CLASS + ' .pro-grli-wrap.product-grid .product-view > li.st-col-item.grid-4{transform:translateZ(0);backface-visibility:hidden;}',
      'body.template-collection.' + ANIMATING_CLASS + ' .pro-grli-wrap.product-grid{overflow:hidden!important;}',
      'body.template-collection.' + ANIMATING_CLASS + ' .pro-grli-wrap.product-grid .product-view > li.st-col-item.grid-4{pointer-events:none!important;}',
      'body.template-collection.' + COLLAPSED_CLASS + ' .pro-grli-wrap.product-sidebar{max-width:0!important;width:0!important;flex-basis:0!important;opacity:0!important;transform:translateX(-20px)!important;margin-right:0!important;clip-path:inset(0 100% 0 0)!important;pointer-events:none!important;}',
      'body.template-collection.' + COLLAPSED_CLASS + ' .pro-grli-wrap.product-grid{width:var(--fbp-collapsed-grid-width)!important;min-width:var(--fbp-collapsed-grid-width)!important;max-width:var(--fbp-collapsed-grid-width)!important;padding-left:12px!important;padding-right:12px!important;flex:0 0 var(--fbp-collapsed-grid-width)!important;}',
      'body.template-collection.' + COLLAPSED_CLASS + ' .pro-grli-wrap.product-grid > .collection-img-wrap,body.template-collection.' + COLLAPSED_CLASS + ' .pro-grli-wrap.product-grid > .shop-top-bar,body.template-collection.' + COLLAPSED_CLASS + ' .pro-grli-wrap.product-grid > .fbp-top-pagination{width:var(--fbp-collapsed-header-width)!important;max-width:var(--fbp-collapsed-header-width)!important;margin-left:var(--fbp-collapsed-header-offset)!important;margin-right:0!important;}',
      'body.template-collection.' + COLLAPSED_CLASS + ' .pro-grli-wrap.product-grid .product-view{display:grid!important;grid-template-columns:repeat(4,var(--fbp-collapsed-card-width))!important;justify-content:space-between!important;align-items:stretch!important;row-gap:24px!important;width:calc(var(--fbp-collapsed-grid-width) - 24px)!important;max-width:calc(var(--fbp-collapsed-grid-width) - 24px)!important;margin-left:0!important;}',
      'body.template-collection.' + COLLAPSED_CLASS + ' .pro-grli-wrap.product-grid .product-view > li.st-col-item.grid-4{width:var(--fbp-collapsed-card-width)!important;max-width:var(--fbp-collapsed-card-width)!important;min-width:var(--fbp-collapsed-card-width)!important;flex:0 0 var(--fbp-collapsed-card-width)!important;margin-left:0!important;margin-right:0!important;display:flex!important;align-self:stretch!important;}',
      'body.template-collection.' + COLLAPSED_CLASS + ' .pro-grli-wrap.product-grid .product-view > li.st-col-item.grid-4 .single-product-wrap{display:flex!important;flex-direction:column!important;height:100%!important;width:100%!important;}',
      '}'
    ].join('');
    document.head.appendChild(style);
  }

  function updateDesktopMetrics() {
    if (!isCollectionPage() || !isDesktop() || document.body.classList.contains(COLLAPSED_CLASS)) return;
    var outer = document.querySelector('.pro-grli-wrapper.left-side-wrap');
    var topBar = document.querySelector('.pro-grli-wrap.product-grid > .shop-top-bar');
    var firstCard = document.querySelector('.product-view > li.st-col-item.grid-4');
    if (!outer || !topBar || !firstCard) return;
    var outerRect = outer.getBoundingClientRect();
    var topBarRect = topBar.getBoundingClientRect();
    var firstCardRect = firstCard.getBoundingClientRect();
    document.body.style.setProperty('--fbp-collapsed-grid-width', Math.round(outerRect.width * 1000) / 1000 + 'px');
    document.body.style.setProperty('--fbp-collapsed-header-width', Math.round(topBarRect.width * 1000) / 1000 + 'px');
    document.body.style.setProperty('--fbp-collapsed-card-width', Math.round(firstCardRect.width * 1000) / 1000 + 'px');
  }

  function ensureTopPagination() {
    if (!isCollectionPage()) return;
    var grid = document.querySelector('.pro-grli-wrap.product-grid');
    var topBar = grid && grid.querySelector(':scope > .shop-top-bar');
    var pagerArea = document.querySelector('.paginatoin-area');
    if (!grid || !topBar || !pagerArea) return;

    var existing = grid.querySelector(':scope > .fbp-top-pagination');
    var pagerHtml = pagerArea.innerHTML;
    if (existing) {
      var currentHtml = existing.getAttribute('data-pagination-html') || '';
      if (currentHtml === pagerHtml) return;
      existing.remove();
    }

    var clone = document.createElement('div');
    clone.className = 'paginatoin-area fbp-top-pagination';
    clone.setAttribute('data-pagination-html', pagerHtml);
    clone.innerHTML = pagerHtml;
    topBar.insertAdjacentElement('afterend', clone);
  }

  function readPersistedCollapsedState() {
    try {
      return window.sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch (error) {
      return false;
    }
  }

  function persistCollapsedState() {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, document.body.classList.contains(COLLAPSED_CLASS) ? '1' : '0');
    } catch (error) {
      /* ignore storage failures */
    }
  }

  function clearOverlayState() {
    var sidebar = document.querySelector('.filter-sidebar');
    var overlay = document.querySelector('.mm-fullscreen-bg');
    if (sidebar) sidebar.classList.remove('active');
    if (overlay) overlay.classList.remove('active');
    document.body.classList.remove('ov-hidden');
  }

  function syncButtonState() {
    var button = document.querySelector('button.filter-button');
    if (!button) return;
    button.setAttribute('aria-pressed', document.body.classList.contains(COLLAPSED_CLASS) ? 'true' : 'false');
  }

  function animateProductGridToggle(willCollapse) {
    if (window.__fbpDesktopCollectionFilterAnimating) return;
    window.__fbpDesktopCollectionFilterAnimating = true;
    document.body.classList.add(ANIMATING_CLASS);

    var items = Array.prototype.slice.call(document.querySelectorAll('.product-view > li.st-col-item.grid-4'));
    if (!items.length) {
      document.body.classList.toggle(COLLAPSED_CLASS);
      clearOverlayState();
      syncButtonState();
      persistCollapsedState();
      document.body.classList.remove(ANIMATING_CLASS);
      window.__fbpDesktopCollectionFilterAnimating = false;
      return;
    }

    items.forEach(function (item) {
      item.style.willChange = 'transform';
    });

    var firstRects = items.map(function(item) {
      return { item: item, rect: item.getBoundingClientRect() };
    });

    document.body.classList.toggle(COLLAPSED_CLASS);
    clearOverlayState();
    syncButtonState();
    persistCollapsedState();

    var lastRects = items.map(function(item) {
      return { item: item, rect: item.getBoundingClientRect() };
    });

    lastRects.forEach(function(entry, index) {
      var first = firstRects[index];
      if (!first || !entry) return;
      var dx = first.rect.left - entry.rect.left;
      var dy = first.rect.top - entry.rect.top;
      var extraX = 0;
      if (willCollapse && entry.rect.left > first.rect.left && entry.rect.top <= first.rect.top) {
        extraX = 76;
      } else if (!willCollapse && entry.rect.left < first.rect.left && entry.rect.top >= first.rect.top) {
        extraX = -44;
      }
      entry.item.style.transition = 'none';
      entry.item.style.transform = 'translate(' + (dx + extraX) + 'px,' + dy + 'px)';
    });

    requestAnimationFrame(function() {
      lastRects.forEach(function(entry) {
        entry.item.style.transition = 'transform .22s cubic-bezier(.18,.82,.24,1)';
        entry.item.style.transform = 'translate(0,0)';
      });
      window.setTimeout(function() {
        lastRects.forEach(function(entry) {
          entry.item.style.transition = '';
          entry.item.style.transform = '';
          entry.item.style.willChange = '';
        });
        document.body.classList.remove(ANIMATING_CLASS);
        window.__fbpDesktopCollectionFilterAnimating = false;
      }, TOGGLE_DURATION_MS + 40);
    });
  }

  function applyDesktopState() {
    if (!isCollectionPage()) return;
    ensureStyle();
    document.body.classList.add(READY_CLASS);
    ensureTopPagination();
    if (isDesktop()) {
      document.body.classList.remove(COLLAPSED_CLASS);
      updateDesktopMetrics();
      if (readPersistedCollapsedState()) {
        document.body.classList.add(COLLAPSED_CLASS);
      }
      clearOverlayState();
    } else {
      document.body.classList.remove(COLLAPSED_CLASS);
    }
    syncButtonState();
  }

  document.addEventListener('click', function (event) {
    if (!isCollectionPage() || !isDesktop()) return;
    var button = event.target && event.target.closest ? event.target.closest('button.filter-button') : null;
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }
    animateProductGridToggle(!document.body.classList.contains(COLLAPSED_CLASS));
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyDesktopState, { once: true });
  } else {
    applyDesktopState();
  }

  window.addEventListener('load', applyDesktopState);
  window.addEventListener('resize', function () {
    window.clearTimeout(window.__fbpDesktopCollectionFilterResizeTimer);
    window.__fbpDesktopCollectionFilterResizeTimer = window.setTimeout(applyDesktopState, 150);
  });
})();
/* FBP desktop collection filter toggle 2026-04-03 end */

/* FBP remove main menu new-arrivals link 2026-04-03 start */
(function () {
  if (window.__fbpRemoveNewArrivalsMenuLoaded) return;
  window.__fbpRemoveNewArrivalsMenuLoaded = true;

  var OBSERVER_KEY = '__fbpRemoveNewArrivalsMenuObserver';
  var RAF_KEY = '__fbpRemoveNewArrivalsMenuRaf';

  function normalizePath(href) {
    try {
      return new URL(href, window.location.origin).pathname.replace(/\/+$/, '') || '/';
    } catch (error) {
      return '';
    }
  }

  function collectTargets(root) {
    return Array.prototype.slice.call(
      (root || document).querySelectorAll('.main-menu a.link-title[href], .main-menu a.link-title-lg[href]')
    ).filter(function (anchor) {
      return normalizePath(anchor.getAttribute('href')) === '/collections/new-arrivals';
    });
  }

  function removeTargets(root) {
    var anchors = collectTargets(root);
    if (!anchors.length) return false;
    var removed = false;
    var seen = new Set();
    anchors.forEach(function (anchor) {
      var item = anchor.closest('li.menu-link');
      if (item && !seen.has(item)) {
        seen.add(item);
        item.remove();
        removed = true;
      }
    });
    return removed;
  }

  function scheduleSweep() {
    if (window[RAF_KEY]) return;
    window[RAF_KEY] = window.requestAnimationFrame(function () {
      window[RAF_KEY] = null;
      removeTargets(document);
    });
  }

  function installObserver() {
    if (window[OBSERVER_KEY] || !document.body) return;
    var observer = new MutationObserver(function () {
      scheduleSweep();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    window[OBSERVER_KEY] = observer;
  }

  function init() {
    removeTargets(document);
    installObserver();
    window.setTimeout(scheduleSweep, 120);
    window.setTimeout(scheduleSweep, 600);
    window.setTimeout(scheduleSweep, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window.addEventListener('load', scheduleSweep);
})();
/* FBP remove main menu new-arrivals link 2026-04-03 end */

/* FBP main menu artist gallery sync 2026-04-03 start */
(function () {
  if (window.__fbpArtistGalleryMainMenuSyncLoaded) return;
  window.__fbpArtistGalleryMainMenuSyncLoaded = true;

  var OBSERVER_KEY = '__fbpArtistGalleryMainMenuSyncObserver';
  var RAF_KEY = '__fbpArtistGalleryMainMenuSyncRaf';
  var TARGET_PATH = '/pages/artist-gallery';
  var TARGET_TEXT = 'Artist Gallery';

  function normalizePath(href) {
    try {
      return new URL(href, window.location.origin).pathname.replace(/\/+$/, '') || '/';
    } catch (error) {
      return '';
    }
  }

  function findTargetLi(list) {
    return Array.prototype.slice.call(list.querySelectorAll(':scope > li.menu-link')).find(function (item) {
      return Array.prototype.slice.call(item.querySelectorAll('a[href]')).some(function (anchor) {
        return normalizePath(anchor.getAttribute('href')) === TARGET_PATH;
      });
    }) || null;
  }

  function findInsertBefore(list) {
    return Array.prototype.slice.call(list.querySelectorAll(':scope > li.menu-link')).find(function (item) {
      return Array.prototype.slice.call(item.querySelectorAll('a[href]')).some(function (anchor) {
        return /track my order/i.test((anchor.textContent || '').trim());
      });
    }) || null;
  }

  function findCloneSource(list) {
    var preferred = Array.prototype.slice.call(list.querySelectorAll(':scope > li.menu-link')).find(function (item) {
      return Array.prototype.slice.call(item.querySelectorAll('a[href]')).some(function (anchor) {
        return /blankets/i.test((anchor.textContent || '').trim());
      });
    });
    return preferred || list.querySelector(':scope > li.menu-link:last-child');
  }

  function sanitizeClone(item) {
    Array.prototype.slice.call(item.querySelectorAll('style, script')).forEach(function (node) {
      node.remove();
    });
    item.removeAttribute('id');
    item.querySelectorAll('*').forEach(function (node) {
      if (node.id) node.removeAttribute('id');
      if (node.hasAttribute && node.hasAttribute('data-bs-toggle')) node.removeAttribute('data-bs-toggle');
      if (node.classList && node.classList.contains('active')) node.classList.remove('active');
    });
  }

  function retargetClone(item) {
    var anchors = Array.prototype.slice.call(item.querySelectorAll('a[href]'));
    anchors.forEach(function (anchor) {
      anchor.setAttribute('href', TARGET_PATH);
      anchor.removeAttribute('data-bs-toggle');
      var span = anchor.querySelector('.sp-link-title');
      if (span) {
        span.textContent = TARGET_TEXT;
      } else {
        anchor.textContent = TARGET_TEXT;
      }
    });
    Array.prototype.slice.call(item.querySelectorAll('.menu-arrow, .single-menu, .menu-dropdown')).forEach(function (node) {
      node.remove();
    });
  }

  function ensureArtistGalleryInList(list) {
    if (!list || findTargetLi(list)) return false;
    var source = findCloneSource(list);
    if (!source) return false;
    var clone = source.cloneNode(true);
    sanitizeClone(clone);
    retargetClone(clone);
    var insertBefore = findInsertBefore(list);
    if (insertBefore) {
      list.insertBefore(clone, insertBefore);
    } else {
      list.appendChild(clone);
    }
    return true;
  }

  function ensureArtistGalleryLinks(root) {
    var changed = false;
    Array.prototype.slice.call((root || document).querySelectorAll('.mainwrap > ul.main-menu')).forEach(function (list) {
      changed = ensureArtistGalleryInList(list) || changed;
    });
    return changed;
  }

  function scheduleSync() {
    if (window[RAF_KEY]) return;
    window[RAF_KEY] = window.requestAnimationFrame(function () {
      window[RAF_KEY] = null;
      ensureArtistGalleryLinks(document);
    });
  }

  function installObserver() {
    if (window[OBSERVER_KEY] || !document.body) return;
    var observer = new MutationObserver(function () {
      scheduleSync();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    window[OBSERVER_KEY] = observer;
  }

  function init() {
    ensureArtistGalleryLinks(document);
    installObserver();
    window.setTimeout(scheduleSync, 120);
    window.setTimeout(scheduleSync, 600);
    window.setTimeout(scheduleSync, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window.addEventListener('load', scheduleSync);
})();
/* FBP main menu artist gallery sync 2026-04-03 end */





/* FBP contact page compact runtime 2026-04-03 start */
(function () {
  if (window.__fbpContactPageCompactRuntimeV1Loaded) return;
  window.__fbpContactPageCompactRuntimeV1Loaded = true;

  var TARGET_PATH = '/pages/contact';
  var STYLE_ID = 'fbp-contact-page-compact-runtime-style';
  var BODY_ATTR = 'data-codex-contact-compact';
  var MASCOT_DATA_URI = "data:image/webp;base64,UklGRrrSAABXRUJQVlA4WAoAAAAQAAAArwEA/wEAQUxQSOIvAAAB8Idt2zI7zf+d133da0VISEhwKMEpEDQFSqE4xd1rSIs7FaT64lZc6w1aQws1KMUdirs7SSCerHVf93X+sSazZp6ZeZ7JV7YtIiYA//+JojHMTwkR81VFgaGbnrQxwnwSBVY66zXybMT5IKIRWPKSWWR/2jTo/I4QA4BwxCfknD6+BMh8DdEAYOEdL36aTNktn/Kj/RHmX0gEsNRBN39KMmd3ctb/+PD8i6BA3O7GaSRzypyn3TG/Iiiw6PHPkTRz1tnP3yB2xyRGAURjVClCUGDFcz8lsznrTzyqSyaoW1WaJAqsdtUM0jIHnbkZtCuG5Q65/L/PPPv4ny46YtNRAFSaIBFY+arZZHIO3jlpNKQLJvr9l1nnx3/ZewSgDVNg6QtmksnZSOcnC3XDBDJ64Q1Pf53st5QyybdOHAWVhgTBiFMmk+ZsrNOXR+i6qBRJNMaA2iOPm8JE0s3I1/cCwuBEgf1eJpOz8T6+CwOEwqhikCv9l4kDcyJ/3YMwGAXW/QeZnE10bgbttshmPYhSCAWw4Bbf+82dz730yI1XfXe9YUDvr5gGkNl4z1iEukLA6HP7aZlNNe7SdQn6zmOrAlGaFgKwze8+YL2vX7kp8DumGmQ/HxsepI4I7PkaaWxy5g5dF+AxTjtsKKChARLqUGCPh0nmlCxnSymR5L1b4AHmWuznLaLzCAHj/kgmZ7OdGyB0VQRrr3emGV85aUlAogymXsUqfyOzOevNycmLl/qQuRb7eTS0RgQOnkTLLOKaXZaIq/xRz4n87KoNAKhKHYIvbiNhgAQcMJWWOXjL/Mfp/fNym/4FCYAolruVNBbQmVfssii24kDrJ/ng4YsDUJVaEYc/ggEScC5pbGziu5/RazHxPEQo8K1JNGcx5izdZUHQx7KRZE4kp1y/+ygAqlLjQlsMAaL4LZOz0Zn1Zv9guPRgod+TxmJmvjMc0l1RbM08gKQZyfd/te1wACGGiN/xKEREXMF+NtHroXNTwZav0ZwFNT4BQZc14ElaLdLNSL519U5jAUh8gi/0hojvs59FTf5d/NyZWFjjwwjdloiDmOZF0lMm+cltx4wH3ib3AzajeWGM3/8VPbO4iddCuy2KTWh1kcwpk7T7jv6E/gJGvO2ZBZ5DcxbqDMTuy9aDI+mWONC41+lMJD2bZS8CMwud+KNuzIb0BpB0M9L98znOQjuLnbkztNsiWHwavSGDzB8/8dBdd31QhKJnrt+NGTGpOe6k++wbxmPVHz6a241z6uKQ7kvvG8zNmPfsp9mGM18N3Rco7qAVIJO03HaMt0LRdY24lqkA9Mw2nPhzxG7MCcVoz8ZtoSLSZVHsRutQzmmLagQQQlclYKVM70zGewD0LLQguquCBd5h7kyJ3x2+/5/e+PSj25dH6KIg4B+0zsT+37zFmg+ErkrE/zF1Jidplj3brKUQuiiKbZg7E2mZJN0/GQHpogQsMo3eoWonToSimxpwH62Tuc1aQUJXJeInTJ0s8SAouqqKLzN3sH5eAEWXVYa8wdyx+nkVIrqtEZcwtbfcBOMfoNJ1UWzM3NY8NS7zl4iC7qvEF5nbWROz37Z8D1pWgkatahE/ZupI5OdzX94AoXASNEZU+oDl5nqHovM/oViiUVFzwQmb/vhYSDWD4iamzuRmb/ZCiiIhBgAIy+78g+uf+jRzyg4SKtsWzJ2JiRdB0VQJYYBoVAAY8eVjr3++jzVvGgVBVRd5irkjGd8ZI9IMUQBQVQAYsu5xt37IgZb6Ms8EFFU9YKXp9KbkdmWcOgEBTQzAkNWWBYDh6x9z4ysk6cmy0zhzX6igwq3JBnuu1a4TJ38ZiiYqek96Jc98dNfN/vAOByZzDkx8fQIiKrxgxHueG1JMb5mc+ex4RDQxYr0nOG9PljnPxPuWQESlV5zB1HHIq0dC0cSInWcyZbq5p8x6E/8yDIpqH2SRKcyDSj4Pb1Kr+tx7twECmqjYMdHYyMRfAwFVX7FTskE523n219ZBFDQxyIrTmNnIfv4aIaDqC8Z95w3mwbT5zKmj0RTFTUxsZD+vgwoqv+IvzOyknpx/7wloYsBK5mxkP29EEHQDbk+pKe5NcG8Jsv/iBUSaEXEsUyMS/yJB0AWMOITNabfOV36xBpqs8qeGGG/XENANFBn1Qc6dI/tDy6JHmhNwD21wmXcFFXQHIw5kajHPBaLx8RDQVMGS0+kN8BdWhnYJoPgXrbWK7Xn20ghNidifxgZmvrUMtEsQZMmPaB2DmTtAm6K43lMjaHx+YYTuABSb9dE6hvnXEZshGPYec0OY+N/eIN0BRGzfR+8UzvURmqHYiM4GJ16D2CVAxFefc+8MmVNGQ5oR8XOmRjHxZMQugcQFrhmcez2e20fiRCiaGeRRWsM8cQfE7kDExUzsiO4zV0FoRsBKfe4NY/bJyyN0Cb7J/g7BqYtBmhFxPBObaHxsiEp1CjHGqKpxoAaROhDkZvZ3BDrXgzZD8BCtGUy8BLE6NVBj1DAg9PQM+xtT7gTGXZoSMN6czU3cE1qRBMvvfvJvJt58842/+dWpB++97YqL9qCmxgAA8WoyZW97iT+W2ISIU5malPPkZSRUoiDLGOvvn/nSXVcct8k4APji/t9cHdj7bXbAxCugTZDeV5ibROO/oVKFIEP2uZ+0ual2Zu3ZL0z8zk8Tafd/E72nPN/X9jLfHS7SMJWtmNn0xOMQK9HALf5qpDkHumdLyVnTjOS9q6N3nWnZ2xuNeyM2DtcxNc9t9uoI1UgBTJjYRyZnnZ6TZSfdjLO+AfyF1u786RClQQFLznBvHo33B5VKBGgAVr96Npl8XnUbuS+WfMgz6d6+aPwhehsUcTITi5h4LLQiAUGBVS79jLRGMPu0ZbE3E9u7m+2IqCKDExn6BnMhPE9fTkJVAoICy5z6MT03gIlnywS2ffe53wYAGVTEPjQW03grtDoBQYHFLyeTDy77qz2jJ9HbHJ386/ZLY/BBHi4MjTtDKxQgEdjqadIHRfd1cIdbu6NncvKbv0OoT7ElM4ua/dXhQaoUIBFDT5pFH1TikfJdtj1Laa5z9s4yiIC7aIVh4k+g1QpQYN3J7oP7PcZ+6t7mBs75/XIQ1K3YjJnFzXnGOAkVCzFO6M8cbOb/FOcxtTXvmzjx2h98EQiQQdxLKxATr4FWLlzONCjn7HEybmb2dpZ5DQD0xCioV7EjjUX2bBOg1Upk1Ef0QdG4G/BTWjtj5l0roebi9QT9n+dC0fgvhGoVcTCNg0+8DD1DH2VuZzROvXDTlcZ/665bEeahOJTGgmd+DVqpRJ5oSObrvYqzmNoajWQfycsQa0kY87HnohkfklClFBszs5GZW8kCbzMXJ3sr0FMm+7gXtFbEJUwsvHFHaKX6PVNDjH/DpnS2OZKe84djRGoovpTMW+HREKqTYNGp9IZ45gpHMRWohROPgGKgaHyCxhbM3AFamSIOpbGxxltvoXWAxMdikBoRp9DYisb7ESpTwP0NI5nZAY2Tl0fAwIC1+sxbgplbQCtSwGrJ2XBnB3R+vhkUA0V7n6KxNY13VKaInzA1rhO6vboRFDUjLmJiq7qtK1qNRJ+hdTKmj1YNoUbEHkxs2cTfoRopJrizkxvviQEDFSt/nr113Gd+AaEKRZzO1Mk89a2KGkEWeIbGFk78P8QKJBKepXUw7+eRUACQiJuZ2MqZ7wyHVB/F2tnZuS3zfCgASMQFTKx/Wn/BaPw6YvWJOIWpU7kZ7XgEASARP2Fi3c7J04p3L0L1EdxP61QkH9gQCgAh4OdMHMzUSfRi0W1taNUJGDeH3pncPrx9TyACgEIup3HQfe8XLvHi6hNxAI2t6q3l/u6SAAIARCz6TyYOPn/oLLjzw5GQiqO4nqllWtw5d5nQAwAhYOPXmNjID1PRaNwXsdoIhr7L3Jkyn4MAkAh8v5+JDXROnlE8vwOh2ijWd2dndv9sVQkSgVXupGc2dvq0wjlnfwGh0kScwNShaLwFvcCIH02nORs8ZzK9YEw8HrHSBNxM61SebUWMPuIV0tjw9BkLb3wEUmUEQ99hLoh726HxilPfI83ZxBnFo6dVESpMwFrODm+ZTZ2Ti5d4MmKFiTiIqZPllNnk1ALGRyVUmqs7WwGzFc+ZvohQXUQepZWalkw8XmJlEYydSq8axrsQKotiY2YWO3v5cU5fHFJVIo5gKlhNLzfM3AtxEBJiVA1BNaoMEJHSdnUVSfwltB7RiPqDCgZqDCVM8BCtFcpu5otR5qURQFjl6yf/+V//uedffz5lpyUBjBg9KmCgli3ByI/o7cg6nNNWRRggUYAFtrv8xcw6p97xrRGLvT7lpWduOGl9AKFcBYx3VtHEA6RHgiqAr1z8Jklaspopk3zjiO0+5MDHvxWgpUqxM3M1+TUEABY66D6SOWVnnW5GPnjqG5aSkw9/FSIlKuIHTFUk8/mxIxZdZofL3yc9ZQ4+G9Nz/U5mo58uCGXq6mpC8tN3p/aRNGODM+kcaM47RiOUpoD/0CrKwJycTXTOM/HJJRDKEuLzzBXFszuLmvjsWIRyJFh0Or2iFDvxvz0qpShgpdQVYD8vhpYixdbM7AZ64tegZShiP6auALO/PCxIKTq+W8DEo6Cl6LKuQfa3homUoWsrjOdi0bgrYvlR3EKrLGQuVvLroOVH8EBlcb74IN2LlPn2EEjZEcgLzFXFp/7yzsRCu62BMEBKTXyjsgx85v4puUjG7aGABkiZ6Xm7ymT2fzK3SInHhh4RYBjKTO87VYbOYieeBwF2vv2D3aBdOtIL9vMvjF3sdpKblRcIHqFVmmJn/+uUu55hnz0OQTmV2KPrvOK5uuSi1bbEsxDLiQJYYDYzK2z2ornnTOP20FKiWOC719+RnUXNpcv5weX0XLCaxs3LiWKbV1hoL2Gf4FgytUAuKYoDyWRWoPKd+eoQbP02kxfO+eUyErEls7HSGh9GxCJ/pXvxNiwhAUPfprHq/BdhiOAU0guWuVn5CFjo1zRWnj9DAGDjyfRiGb9VOgJGv0RjTffKkngORn7jivvv/MGJn2UvVOIvEMuFhCH/Yj8rb+L3sPxHJDnrcxbb+F+EchHxXfaz+mbuAhlykqd+MnmhnFMXhpQK0f9lq0DkGlDg227uVixmbgMtEyrruLP6Zk4eC5FenEFj0ZOfiVgmIq5mqkRPQQDR3teYi2Z8CFIiFF/zzNJtLZA4EQog4kimojlnLYVQGiSMeJPtzq0N0b0FTkAEILLYNHrBaNwdWhoUpzKx3ed2YzzhSDIXLXMTKAAE/ItWtMQLEctCkKWn59z22q1z1hLYby6tWM7PFoIMiPgpU9GMD0PKQsTZTCzZxn+jFxt9wFQo470QDFTszFw05+QxkHIgGPGh57KVeLTEiOUeYvICJZ6NWCNgFWfhnesglAPFHjSWbPe+FRGgGPpLMhcncztoDcHwd5iLZtwTWhau89QsLx2Zj0IABOCIPqaiOD9fGFIDggdpRUv8IWIpEAx9h7lZ2ctG4s8QAUAUG73OVBDjvxFQO+IqpuKdWRIU69NZtp3rQwcAEYveweyFSDwRsY6jW+GckhBxJlPZyny9F1ILCpxFWhE8r4MwD8XGzMW7uCSIPE4rW4lXIWLeIWDvz5mal/lyhMxDsNAUeuHOLwcBS86ily3jLnVBIsb/j8mblfwSRMw74C5a4c4sB4qtmVmynZ+NgdQDRIycSM9NyvwatI6Ik5gKd1I5iDiSqQVmWUcz3oGAQSpwrNGakvnhCEgdAeOzF8y4V1m4tCWyd7TEoxEHA1Fs9g5TM5JPhKLeIA+5FYt5DYQyEPDnluj09kWEQQERS/6D2RuXuTtiXREHsViZbw+BlAHgf8wlK/NZFTRSIWeS1ijn5NGQukRGvue5SMmvg6IU6mulK/EXiA1BCNh1ElODEv8ERf0RxzAVybhXORAs8F7pytwa2hhIxIoP07whxv0kDkLC0Bdpxcn+8ShIGQhYajq9XDk/HQVpEBAx5DIyN8A5dRHIIKDYhMkLk3g2IsrBqizbiTdB0fgAHDCLaXDmt0ExaMXJ7C+K5xlLSygJq5ew7yA2ARKx7ou0wfHbiIOTiN8wFSTxR1CUhPFlyzl3eYRmABGjbmYehHP6opDBQTT8jakQxmeGqJSF1cuW8QEImqzAebT6Em+CopESRj7KXAC3OWtBURZWyfRSlXgSYrMQsSLpdRl3bRCAsc+5Nc0Tvw1FSRQsMqVkuY1HaJpgyZn1Zb47TKQRgrEXPPRO89x4IiLKQ8+bzGUq8ykRFECfZ64n8TxENFDCsKdYQCNPhKJMPleuEk9GbB4Ut9LqcVsNoRERR3Bu9iZ54uxvQ1EiFTczlSj3OSsgFCDip0x1mP8bAQ0UGfpKzmxuTuSjExBRJiMuKFecMgpSAMXWzPVwF2gjAtams+mf/rAXESXjm7RS1bccQgEEYz6jz8P85R6RRkQc4kam/ibMefr0JYCAchmwbvZSlVcvBBQ3Mc0j8VBENDLgdho5exY5Z25D3D/eAlCUTcHwD+gt4p2ImVtDi7F1tlqZbw0XaYRgoSl0NtVpP0coHVD8jVa07DU6c+K+iEVAwMO0GsbvIKKRip1obLJnfh9aOiJ+yFS0jp54WEEU/5xH5oaiDYm4jKlZtPzuEEjZCFjbvVT9vDB317EFGiISnmduWuazUVA6Jb7EXBQvBb8tzF11bNiYgFX63ZtmvA2hfEScw1SUXAKMtyAUIuCBWs60CkIjIg6ksemJVyCWD8WEnIviHcS8UZlPo5iCR2plvj8c0phfMxXh1DKCEB53K0gZdH6yIKQYD9cy/gcBjZTwLHPzjPuVkohDWKZsNYQiBDxYK/EsxEYELDuX3jz3CdASIrLgh57LEo27QouguKtW5vbQRkTsxsymOyeNgpQQRPyAqTQlnotYJOeUMZDGnMbUPOP9EJRRCcNfo5Ul4wOQYtxSI/nNUDRScWsREi9FbDMSVIO0HhRbMnlJynxGUMSIC5hIGg9AbIQgvsJchG+2GQ2oGVRaDYpTaCUp8XfQYvx4gHPmEpBGBCw5k940Z14NoY0EAKPX2nyz8aMBaKsh4kLmMuN1ZG5VlOMHmP8NAY2MOJiJTc98vRfSPgKw5+2fOJk/uf3bIyHSYqK4i1ZibF6ZLymkGCfU4DclNuj8IiReB0XbDFj+LpLMmSTfPAoIrYUoP2eal5mXjToTJyKiOM4pYxEaEuQWWvOMhyC2jSArvctk7qS7GfmPxaEthoPrcJZY4+0IBTmeicknQtFQwXPMzaOtjtAmJEZ9hP2sMye+uhxCSym+Qq9hvOigiW+4txlvG5lvD4UU4xgmZm6N2BDBwpPoTct8UdEmA4D1mL0eMvHlsRJaKWCxGfRa/8Emr+d20z6dk0YX5VCmzFd6BA1VTGABE69EbA+K+I2/f5452H7eISotBMETzAOcn19FOkuq5f+JFGQfWuKPERsTcZCn5mXuAm0Liq88yYb283BoK0VczjSgprNspmQD01xeiYgiKjZn9jnLITTqbDbP+fnCkHag2Gcuk3kDcv50rEhL7UObhznL63PjJBRkI/bzdgQ0VnEHrWmJt0HRBgM2yzQ2NvE47W2hgMWnu9cqnc43Dz33lrvvuefOc/ZaAIKCfJWJO0ls2H9yEQ5DbAMiI96gscHm/wWitAwUf6OVFOMdqFNQlC+Rr/aKNOxK9jfLOWccQhuIchQTG+595ywCaOuEL79pXk4SL4hDNYSgUQUFDRjvPBERDZYw/J/s9+YY/4uA1peApzw3juSHxw9FCAWSekIEjkm5nBgPQ0TBA8an6UsgNAqCOJHZmpJ4HGIb6MFFzGxmIp/dE9BQGEQNAgkhBmDMJXSW08yvQluAv4ei8SI4mU119q2I0HoR36axuW7kv78KqDRLgw4YgzpX+On7dJZT5/RFIUUTLHzDShKaAAnY4nH3xpnfh4CWV2zfn7xJZM7kNasBUZoiAKQHp378k68uNww9S004+u9zSGNJzXxCpHCFVOCXtMbxMMSWC7LMZ8wsoDlnXfQFQKVxAXv865uAPEqy760XXptOkslZXp5UQfFFpVnSM+p15ka5T10E0nKKPzCxmEZ+dvYXAA0Nkdgjy84l/7YxNpjJzJrJnCXWbVWE4hUw4hwaB5uzk3SfywuhaHXBIp/3W0HoRk45ZxkgqAxu4A7sz+Q/9vnOG5Zzzs6Sa9wF2n6CrDwn+6AG5kxy6hISWk6xG4vsiZx62eoAYqhPsOBxu8QFJtGN5CfvZ2cJTjwNsf1E3E7jIJ1vPDmZpL1/5+4IaPmANZ+45jHmopBuZN+ftw1AiKGOiD3JFw8514w0Y0k2/gOh7Sj2pnGwiSdh4bW/usmqCwCCNvmwF4h0I/nUD1cCEKLKAAlh0TdJzjAOdC9HzkmjIG0mhDEfeh6UcXfUDgHtULH+Y3QW2y2Tc/958DgAUBUM3GIyE0t25pbQNhPxexoH60yrQINqELRFxRFGZ/FzIjnznpPWHwoAoXf4gkM2eNhzyUp+AWJ7idiNxkFnvt4LQdtUfItubEk3I8l3br3zgSdeeOPDTyd/MpNlO/PlHmkrQZb6OOfBJd4IRdsMssqsnNmybslZ6jM3FG0jovg3jY04HLF9KP7KPm+dgdnMcs7u7iUs8Uq0k4jTmdjIvAZC2whYZa6xwjs/XxShbUTsw8QGZr4U0T4jzmF+6BnmqkbjjxDbhWLCzOyNSLwcsX0IrjhvPTxc4XL6eCykPSi+8C4zG5m5I7R91PyiO6u5m5F5HEJbCFjoaRob6Zw0GtJOpBe/olUvzyk5yTn/3BKCdhgw4n4mNjT5n6Bop4rf0VixzTIHfnL7ESugTQYMv4uJjTXui9hOFD9gPyv41Ff+dOLmYwAEbQuKkXczsbHOz8ZC2kiQpWeYVyv3qSfttNHiCgAhBrRFxej7mNjg5DdC0UYjTmdixc72KwDQqII2GbHkY0xsdOYuiO1Ehr7lmWaVis77F0VE+4xY53UmNjrz3QUgbUSxKS2RzJWKic8sj9guRLHNFBobnngBFG004rTk5H1/Z/IaOeVcgZj43oaI0hYCcKwzs/Fu67QXxd2cdMWGwHWkpZRYmY2zv44Q2kDE0N8xZzbe/D4I2mnAsWcvBYQg/zeJA588eftnmSsQM3k6oK0mAas/wexsBr+F2FZqaoAAi+//i0tPXA/ABtm8AtGNdy6OKC2lwAHTmdjMzPdGiLQZjQEDFbVjL37FVIXIxHe2ALR1QsDiN5CZTU08DRHtWmKMMQAhjPnAcyWiMZ/cg6CtESKw7/s0Z1PdZy2L0LbqVOzMVI2YnU9uBQSVwgUFVrqRTGxy4u+h6ICKy5mqEWnk7ZsAiFIkUQFWuHAms7PZOa0lHUG090GmisTs5B07KKAqBQkK4Cu/mUEam554MwI6YsBiLzNVJNKcfPqIxQGoStNCFGD0QfeTNGfzc14f2hmgWO419lcl0jI5aeIOCwAIUYM0SjQKgA2v+ICkOQuYeAsUnVKx1GNMXpXIbCTf+uUui2JgiFE1SJ1BY4wCAKuf9AhJMxYz2wSEjgHFiBtIq0ykp0zys7tP22mFiAaP/MrPHjaSyVlQ4/VQdNAAHDeLlisTyZwySc597c7Ljt9989WXHLPgsCFDho0cs8QXN9/ze1fd/QFJpszCep69soROAglY+24y5epE0i1l1s4zP/v4nTfeePvDz2Ym1vRkzgInXgxFh1XgO6+TlivUQM+WkmXWnS0lyyx2zp8uKqHTIAhGHvcq6Sl7hZqnu3vOObu7sxWNR0PRgRVY4DsPkaSl7G0jeylqdeMzvUE6EUQBfPmspxJJuiXLXjSzBlRi45ZQdGhRAFjtO79+4jPWtJQLVdGN10PRwTVi4KLrf/vM216eTdKTdzc8T1lSQicDJEQVDIzL7XbRsyTNuxmJB0NRAkVjVADQja/6nEzetTDeDZUyUFOCRgDjzvmMNO9OuM1YGQGlUlSBZc6dRlrTvJIlHgVF6RQFVrg60a1Jldx4BxRlVBT40l9Iepch+8dLSiglQFBgo79kelfBE3eEorSGAKz7vOduQuKZiCizqrif1kUw3hVUSo1g0an07kHmO4sjoNQGLNXfRXCbuyEU5VbxNc/sFnriAYgouRE/ZOoa9PN0RJSfP3QPEq9HlNKjuJnWJUj8d28QlOCHuwWJj41EQOkV6GvMXQHjS0sioAyF57sDia8vB0UZDvgHrQuQ+MryUJTiiD8yVb/EJ5eBoiz9ogvQz3+MhqI0HVj5PPGvvVCUZcVOzNUuO88PCCjNAStnepUz5mMhgvIsWPAj5gqXOGlrREGZDrifVtk88ZEvQlGuIy5lqmpGXj0CEaXrW7Rq5onTDgICynbAin2s5EY+sDpUUL4lPMNcvdw496cREWU84gKmquWJfGB9IKCUK7ZkrlhGfnp0gArKuWD4u/Q2M9NLjTntqqWBgNKuuJKpzRhLrGXy9vUBFZS5r9LbTIm1TN6zLaCCUi/6jFsVcnPy3p2BEFDyI45hqj7ZSP59B0AUpV9kzKfu1cYtkzMmbgSIogoqTmOqMG5G8tWfrwAERTUMsvAU94rilkhO/+tuwwENqIyKE5mqSDYj2fefI5cBEAMqpIRhr3quGG7JSc76zwlfBBBUUC0V29Oqg+eUnCTfu/GAZQFIDKieiom00ueeLSVjzU/u+tmmIwFIDKikEka96LnszXvS4787aqOFAEBjQGWNuIyp5Nmkj99+8Jqf7DthYQwMUQVVNsqFZc/n3vRVzFOjCqpuxKFlj+SMP+3aA/SqoAor1nMve5nk0z9YDAhahSA9LzOXPLplctLVawOiUn0izmQqeySzkfbP7QBo5QlYtd8rAOlG8t59hwJScaC4iVYFSLdMPn9ggFQdWTcnrwQkzch7lxCpNlBczuQVgcx93Aux4kgYfjfpVcH40oIiFQeCIetcSKsGbv3rQ1F5BRj1ged25N5p3HkwFBVYerEzUzvqvLlvfwwJVQiIuIypAnjfb9cFNFQh0d6HmMofSZu4NqCh+iBgqXeZyFz2jOyfuCagofJAsfrHTJm55NGNTNesBahUHShWepCzL6eVPNKN7L92HVRgRdh3B/yWqeyRbmT69eIiVQcBgA55kFb66Gmu8wLEygOJGrDY27TSR3LWNSuKVJ+BirU+p5U798l/OHBlVOeIjWczl7xJP1sY6AlVCRFbzmAucwP7fj0e0KqEiK98zlzq3Mg5V6+E6hyx3hR6mSM9kTNOHSJSkRCx7qySR7qRF0Grksq+ZmWP7E8TK5PI8HeYy59xN8SKFHE4jaXfOWUMpBqJDHnNc/lL/BMU1TjiGzSWf+O+EitSCI97BXB+NhZSjRRbMbP8J/8LFNU44DZaBTB+XWI1Ulm131n+nVMXhlSjiEuYKkDymxFQiQVjJrlXAOM3JVajiKNpLP/OqYtAqpHE55kb4KUr+Z+hqMQR2zKzgX2ly7ib9qpqjCoVR3E7rRGlO/MFVOSAVfqcFdD49w3Gr7veV7b55lE7Rak0ivOYqsBAZ+1zoBVGMPIjejVwp3vONjffh1BhesP+NFZF50Dj36CVRRV42BuV+8tX7cQrK4sKMP5yd1bMxB8iVhIVYOM/JTqrpnEPaAVRADv8k6Sxgq6OUDkUkD0fIN2clTPz/QUgFUMFYZ9HyWysosZ7IaiUKsCej5I5s5omXoJYKQTY/SHSMqtq4nmVQoADHyJzZnVN3D/0RlWRahD0WtIyq2zmVqitMQaRkidBn7I+Vt13Hvnjz/eaMBq1NcYg5Q2KzWiVp/anz95w2n7rLYraGkNJg+JWWtXJZsmcNWf8747TvrXuGACQkhZk5TnZK05tzykl1v706T8cvxyknEFxLlMlqu3ZkjlJfvIFkXImYczHOVen2p5T4joI5QyKI2lVi8z+lApKuoTel5krl/G7iGUNKtulypX5+giR8ob15rhXrMQroCjripUnMbNiu3+6hISSFmTUczRW7sRzoOVMVO9iYvV2/2xxCaUs4momVvHE06FlLOIUJlby7J8uBClfEXsweTWj8QjE0qVYb052VjV/MkjZCljybWZW9uxflighaG0pQaI9D9FY3ROvQP1SfiJ+z8QKn/nB4qMW+cL4DTff6mvbbrvtYpCyE3ECEyv+51Omzsqs/e7iIuUmYhsmr3o1PWcz6+OuiKUmYKXJObPq+0DWzL41tMyIDn+Sxi6is385hDITcQ0Tu4mZ7w6HlBjFEUzsKhrvREB5DfjSnOTdhcQfIZYXkRHvM5t5N8G5CbTMjLryVXYXnR+NgJSXgUPWPeHO9+Z0D5LfCEWpVQBY9Z/u3QLjHoilRhRY7tyP6ewSZr4yMkiJkQgscdYU0tktTDwP0PISgMVOn0wmZ/cwz/nVGEQpKYJhP/yINGeX8dWtgFBKgqz5Apmc3cZEnjMUsYxEXMq5zi5kdj66JrSU3JATu5OJMw9AKB+KW2ldChp5ILSE/JGpW8HkDyHUE7QUREwclHcVfg2dlyjKYcQ1g+omGveuQ4F1L9ZycFX3wjl1YUgNUYw8u+8JhFJwVhPmVr3ktyFgoALbvkQehFgKzmlCrnrGAxEBiGL05WT/1MUQSsG5Taj6zhmLIwAK7PQarY9/gKIUnNMkr3DJb0OAKBa6ikzM3KAcZa9uxm9KVGCHN5gzjfcjoByc16QK75wyViIWuopMJI27IZaCHj2/W5H8WgnY7jXmTDL7Cz2CMhgCLi+Q9VeqzB2x4KVk4kDjtxDLQETvhf2Zhc1WpTJfx+YvMmcOzP7ykCCdTxSrP8xuZeJ5PyATa/dzb0R0fAUOnsHUrSAnk5k1vZ9/RUDHj1joWtLYxcysbeSVPUE6nSg2eJHm7GI6ayfOPgQi6PBBcOgcJrage3Wqbc7H1oYKOryi90oysyvqZw5BRKePWPZeJmcX1PPtE4CADi+KLT5gYlc029lAlA4XgKONxi6p8/ktAO1oEQv8np7ZNTXy0tFQ6VgSsdqTNGcXNTtf2QHQDiUBe33OxC5rIn+5MKJ0ogCcRRq7rjnzzR0B7TwBC93O7OzGJvLSBRClwwSs+BwTu7Q585kN0WGDLP4WE7u3if0nLxakk0Rcyn52c3PiwYidJODfZl2dxHuHBekkEcezq5P5ztII6KQioz7w3L3JPm1NKDqr4hBa18Zz3hYRnTboE8xdGjd+AxEdV7GRW3fGEw9HRAdW/JqpG+OJJ6MHnTiEsR/m3I3h6YjozIq9aN2X3HcaonQoKO6kdVuyvzQWEjqU9GLc7OxdFjo/OUYQpRMpsOYfk7Pr6uSDGwPacSRigbPnsivrxnzeQojSWQKw2XOkdWXI7Hx9J0A6SUTPWc7k7Nom8vweSMcQxZoP0TO7tO7ZrC/x1aVFOgVw4Ewmz9lS8i7MPD/51ULtQGqGgRq0Zpz3vESGXU43Z+3cdemf9vn791x//NcWQYsGVY0xqkYNKGjAnzgwvfPS3Zcfe/pM96KYlRrvGM6p644ZgYHaGgGD7Rk+dvTCSy2/zjprbrjBlrvtsct+3/7uz8457/xf/OKCM4ZAagAb7r7jpuuutdKwABwxhc5i5kzmbgATfw4EjSpoScUy2+y4/8mnnHrxjTf85baHHn/8mVcnTf582kw28iYNGKxgxf+yqG7kw3fQcxOyd7jO6Sm9P1oErSkSsftkNtGzDUwppbn5yREi8wqqGnoCvjGFyQvhiXx+b+BE0hrmpFUYd885W0qWSXJNhFZR7NtPy5ZqmlnOOXtNOp11Zk5eCQH1Rwy9lDQW0siPjhsKUWz3EVODMh99nZ7bhLtnSymlXB7q/uyuy/aJaFEJOJmeWUTPc7aAov6IVR+jOYtozjkXLg4oEPGFfzDnRrjNWm6RP5CplTxnSymZZdaZvRBu1vZyX5793qvPPXzdLw7eaBG0rgh+wewsohv3Q0TdErD3Z0wsYjbyz2sCUQBAgf8jUwMSTwKw6bM0bwnLzrrnTPn02TtuueLoQ7fecAa9SZ6TsfWTu2V30hvl/TuvMG5kD2qHqC0SJPyG5iyiG7+HiLoDcDZpLGA28r4tARXUDgHbvss0KOMTUYNixNWktULNyS+/cM/VF5+6zzabLT9qpKDm12hsplsiyen3XTiT3kLurNMblDgRA0VjVEGrBvTcwMRCeuJPEFG3YsytNGfzPZHP7AuEgHojlryDOdfn1r8OFFBg30lMXjDn1GN3Xn+N1RZB/aoxDtXzmBrmljJJf/GqPcfhaBpbN5OXbbTxHtt99ctrrH4Qc2Po/SuLClo7YMhNTCym8XSo1BWw4jNMbL4n8q3DeiGKQSrwI2eqK/HHUAAQxXJ3klYsmv8YtSXGqKpBRAAg4G5aY3Iykvz41mPX6QGw/Fz31jH27Y95hzdzrss9Wxo4lz9FRGsHDLmViYX0xHOhgnqDTHiPc8yye3OMnPLT0YBi8CFgq3eY6jA+oCoDgAicMJvJC+WZm0pPEMFgBQu8zzw4t0SSsx85e+sxAKBD8GcaW7afb26MqDVDLw7lXBuYUkqWWacd12qCIbcwsZiJF0AF9YqEuzlPt5RSsuzug8rOvivHAVHQ0Igl7mDOtTxPWwEB8wwBaz9M5iIx85neIBh8wKocrOeUSfKV3+y7DACEGESxCY2t6pn/WgIR81b9F+v2KW/dde2PDv7m13dcWdDaEnr+ysQCuufESxAEg1140+9d/K8n35jtrNfMUkqWs5P0RF63JhAFjVbgZ2SqkfgNKOqN6D3NmLxATDwJsQGKvWn1ZDOSnPT3E9aOACSqAECQh1vHyLMDFHUKFjzjP4888tB/rrn6gh/uvdX4hXvRJgN+w34fmLOZWarXLCXLZubuTpLnIwgaPHTplTbc55CTf3XTv1/+9HPWnRP54k6ACpoYArZ5n8nJxKsRUX8ANn6KNC+O5xnLSxhcxI+YarklJ9n35AXbLwIAMQbUVuxNY4smTt4DElC3YNAhDtTQYgGnsI+FzJOfOxhBMHjRGIOgzjhi7Jpbbn/YORf86p9Pv9BH8v1jh0EDmhyxxC1k6udjvSqDgEQMO3UOaWmgWa7T3RtC483QwSn+TCM9p0ySb19/4CoAEGIQzFtk6KueW8MTH1gJUTBIiUEkBNUYVYMI2qJg5JMk++dMn/LhW8/fdevtN/3uwsuvOO/MCy489fSz/u+EE084/Ov777vXZhttPGHtpXogaLyEoDHGqAH1L7f6boeNBRTNV+CIaeR74xAweAVWf7CfDXbPlgaaWc5eM3En6KAkPGL9yUjys7t+9JXhABBVUL/icM41M8s5e+2iZPKyIYjokEMW3Wjzdb84bpHRI4ZGNFtRSBEJqjHGGAQ1VVBECVj5z/9bG4pGSgRW3uXQ86/67Y3/ePCp51965bXXX3/jrXc/mtrPRr88TAYjGJtIsu/x87ZbBAA0BsGgBS9w0G6Waprl7O4NMs45EAjoxBKCDowxapynalRVDSEIWjAEjYKiKgAIGhxQv4SgsXfYqCVWXGPd9Tbd44gTf3zOxH/e+9DTb0+ZMXvOnDmz+2xb6CACln3o8XuvOGBFAAhRBQ0+6Mxr/3DzfQ8//dyrH0yeNmtOX+agc86WUkpmlrPX7udr6yMKOqeohhBkIDp8CAhouASNMUYNgmYOH7PYEksttdQSKy87HI2PKiig9I4cs+gSSy272sY77v2Ng39yxcTrb3v09fc+nOps7INLIKK7KfMOIahqjDFqCIImC4LGgCbHqKpB0NjYu8Di47+8yQ6H/vi086+5+5HHn31vRr/lnKZc2ANFl1ZEJIQgITSk2FIzhKAaaysaOHKJccutsPIKCwMB8yVFRIKqxhijBhHMWwXzR0UkDBR0LSWEEFTjPFU11C8dp/sZMJ81YKFxy605Yetd99xnv/3222/fPXfb9strrTV+3Lhx45YdN27Z8WssCZmvoPjS+32JDUy1LfFW6PwExaqfcmC2OrOzXp+5hoT5CIol36DROXifZ/IdoJh/GDDmaSY2M/EURMw/DBj5MBObmXgtosw/CDL8XiY20/jgMBXMN5TQcycTm5n53uIImG8oAX9iYjNznj4BivmGovgNE5vpxt0RMd9QIi5lYlMTj0HEfEOJOJ+JTe3nJYiYfxhxOhObmniTRJl/EHEKE5tqfHK4COYb9uAYJm9K5ptLI2C+YcThNGcz3WeuCcV8wx4cTHM205PtiIj5hRJxKM3Z1MSjEDG/UAK+x+xsaj8vQMT8QgF+QXM2NfF2qMwvEBl7I+f0p5TMLOfsA3POlurs4yMjg2B+YcTxbP7HiyFgvqFgwU33P/Lo44458rvf3GPHrTfdaIP11v3S5ptvu/8x3//hiTV/cOzaUMxnFcxXFI3z1NpBVTXWHfD/BwhWUDggsqIAAPCiAZ0BKrABAAI+PRqLQ6IhoRULnVggA8SzN34+TFHhD+Z/gB8DdLnZ/8DrRtPec/xn96/6Xss1x+6/27/Ff7X+7/ul8nP2Q7fumv2R9PTnj/pf4j8ovmD/sf+9/lPct+kf+//j/34+gP9XP+p/iv9L8Jf+R+4fu5/wH/L/Zf/l/AT+pf4f/3/7j9//mS/3P7ae5v+9f7T9uf+Z8gX9X/zn/n9dn//+49/ov+b/9fcI/qf+k/9ftAf9f90f+d8m/9j/4P7m/8r5Ef6X/mv/v+4v/////0Af+n//+wB/3//b7AHY5f3D8pPdd8e/Zv8N/ff3B/s/p3+M/Pv3H+0/5j/Wf3b9u/jN/u/H71R/wvRr+Q/dT85/cP8x/zv77+8nyz/wv874v/mn7l/vP8z+23+O+QX8e/l3+K/uf7gf379zPpr+p/Y7vwtl/zH/v/1PsEew303/Nf3/9xv8j+5v0ffBf8r/Keqv2O/3v5o/6D7Af55/V/9F/d/3g/wf/6/7/xUf+bxRfyX/B/8f+p+AL+Yf2L/Z/47/Tf+T/T//////jD/R/9b/P/6z/6f7L23fnP+P/6P+V/2f/2/13/////6EfyX+n/6n+7f5j/w/4/////P7y//T7jv3C/9Pug/rx/1PzvaYF4pHkT86mozY+ccr3BN4O6zMUcMZ5QWI2d8rpa9t12a2YF4pHkT52hj1TyyNpDrPnGjYugRZ2nzlvmeCHmQwpHmeGlvVvTyERoIO7Godjjoc9Jzx69bXLRHGqVKx5g3sL9Usm+swLxSPIn510XnmZnHJJMeLmXai4WwOpWB+urr/12/XPzwPXn/0FVoyhcNVVlTOb7Rt+EiAd6KUEuAaJGOB36nPsYpCsZtQHovC61swLxSPIoXFxMI/sc53jvWd1HyPXLztcpUMHTjrBhNnwqhv0tvCxsshH6NqQ0yaLVOUfsa7juDCHIgp6AyJzUupPU6m1fEhE2rqpne1t9BpFO61sKqc5/Wyc+l279usR02md3XMJIXLnfNQfYJrtZtg3SLA800OrIXsu4vNRi7xcOizYTQI8bXJTCOww7pBL06o4shbqdk1Hfjt7dpFO61ssmOBAq9ddWnUG7A67FdqMAmWDHNZdHr3BfXUY5WxCaBAT6IPPOqrV4xF3EbmbrlfCntDYzvbqTcOaZANf8hFYr6GMyjo5Oe+BA3MHKIWlsc0J7xHlIg5P3zrs1swLxOZd1A39GJDl1tBZlYZGCvKbfxjyrcv+W6C80Snh8y9GweqG3KpojUS3GumdIHEk3sojGwozErGXda67I+OLjcZd2PUgJ0acGDxP9diIqxCrZOn3CQaRTutbL/lJgbd+anzf/hbrdyYBzM0EsPTgPOVPc1+VwUUlszm7MVEeG7g1Hn0v4EVm1Xi5VeDRENvhS1qxUf98OiK0IxhKklHLHXcwkidYCBWVJoqo4e6N0dvhT4U1+CBaMUdz86br8BD5/CdACPPc7sOYmMY/hGjdCSEPp/eGbjH2ZytSPk07yJDDANOnin86fYDrvQQIKr8IFMbt+IYEyI8uNLqxGxrHb/9wBCny5dln1hkbMnXKSrbc9zRtMPzrs1OV4uB9x8Ivpxa2xseY81lL748fzA8Ka4kKhLdwUaSR3jAROlOCrWJ1ByzY0O7KmpBJ5TYN8e1MdHRR+ZK9SnbyYLI4kw3hevPGa4gnlHMxE1sMy8OklH7HIa4J4704fPO9x3AZ+ciXUYk4LAm5qkU7rTtH4+9Fqyqu1w3ZvCMi1Oh1gl8snJbeNuYox27lv5VBvIfMZ9CxsMPkk30LrYOlypnhuwTrCH573iyOieHLQ9NsbCPxwdBuRyBtSctFnjALI3NAJCtkuNMGADGbb+K2Rq1bE5d8BEJ87AbYF4pGiY+mMgyvJhS1mCquqQ2I9jvFou+XuS4Gq0QAkBkmx6sEnvXcyco4s3Bvuj7Bverq0+zroCAYXLUJLXfbFn1JqthF3KknT25+Ooennu/UMjXdty7gNXYEJFbl6dE0wWGolo3OjCb53MiNz7l+g0e9EMPrKbpKwv/L+mlJKhan9PLNa6/wx98Jql5qfbSrHtcwoBTnWYfQiWNqOla0Tgmx95SAnKMnPgkhyQ+Un1Jz9hqWcgN6Npil1OndwWlR+ch8kcIrwQJuv4X0LMetPD0zrnm7wMwyLp8JzP91eQnk/ndACCrtMt41ZsWzwwtoqloDiP0UiTzP5EJL7HJv0jiDEDIE8rE1w+kDVa9hoUAFa8ylWyLYZzVvnAOvpvz4j5bkpAe35xAOzkUl5Bkh7yBhGSTXT0/1PJkOPMYIGsl44a1cAWmagG+FDAwkaNGjkwjaLMAtrSOuZ+NWUOnkr78PjVkXwcMNV2JyJzwageiAnSpbQ8+Nt8bniRpQOtKgixtsQkxu8/vJnLI0+GSx3ZWJnyzgc+v539QgheyqA54ZOxUu9A0L+LAxCTf1J+kanFkHdS2Gm0y2IzvwzkfHPX3J2oUNofnARWwV0TSX/D3Kd/pgWoQV3Xx69DN5VB8/obgkv3PUKVsc1DRfp+79QUGvQyE3lDql4B5R+wHi1eM7lDZfeJSyEWEcYk0ctPwhlaKecZGN/Bsz1dehoHEpkxDUgijYvSpEsIW4p2EktYcxiXavwoYThAjTiHxrrqlZ7VzpLMiBYxH7fhOyU0wTJNMBY10INqxVaFGRZV+ax8nhIv2mP9U6+5//7DDvVZ9Syiv6l4/MaStYUsAAAHn853WtfMdd3sB+yLizq2oEW80m7GkTqEvtrV8Fup2xLazVG7btg/95Gc+iuQ4xOjNaooFV/0vVg3JjPoysnmWIARYFMlvE0gAnwy4SXha+RMJ+dZMhY1+cdXgxmkKvg5sLlI7DJ9lB+ddlYGdp3ZpdDGbvPGPG/SVYlZlJuNQUpXcG/g0qfYYzAuKI16pEpKQ6/B3r1XKG0PZW0n6H7by/NXUEt4VH7ntcMH81GgSkKo//mWVv3Rdvt5tgRTNbMC8T7aQtcp6vh6PQRzCYCjPFUKI17cYyqC3t6LXAmrkA/MCOCtvrfTUNMy4njZXKN2Cd4KUteBVbQALGOmFPt8bh+62kx//7ftPgHeME6BkeRPzrs4XyyfrIkUIPG8iHxVU6d+AUYbNQv1O06EJT3ywiR2d6tAT1gCglFuUyXs1j2420Oq6GBZwwpKreV/LjgOushbvrZsVs0kgGh+7MC8UjyJ+adNzqEgPSPGgTy2vg+Wv4K0hgQOVDMGwIb6QWYedt21dPrggPbQCLdh/TqlzhRWS8sy6nDL5f2CEn18x+kyT0mjiEVR7+a21swLxSPIlZbw0ikki5VoXzgpukJ9LobL1MbDg9kXtzZ0YiFUeWwv5bnF6MtN7hrn2De9irp325C/cSOGlUZCGuX6sObXy77IpwaW2Eo4iKtmBeKR5CbNfwYOcedL9zI2qjq4s9fabscFQ7K7HOiR5st+mG0o1wFN5CmYODmJ7g8jWhi2up8ANrZxBKP3313ALiIjYH0EWmmpALrLN1iYX6DSKZ1MPWzAeOrVP9ZMdoT5G0aCzh9fEnVVMcH4PN6rxCyMUhnk3xbWOIjIyHWlu6Bp7O9wiFzaR4kDL38mBs4gW756hChyW4bVGWdHDtGP0jfwkP9HnCddmtla0zhjBF0tOjjFiIczarMn8HlVXuf5/TZMr+Oskc4ABA/4KBaiR5bPvXWuywhi1or0B0Pi8sJPYiSycPAIBuGccM6mmne7RtTUZ5FTXfVYp8idWhd99WUIp3Vdn2yFD5YUXmXZyraO4DL7UzNCyJjPSv9jGr+ANCY0XgSzLm54QHjGztI2DFUcO/GzC88+Ep9WeBaWIs8miKYiOjxR5TxlEmTvTTkUqlQYnp0lh9bN7VNioZQHMDOzMr90+JIFuLTi6zv+U0Gjdz57V/Jm8gKYuKzCp3OklYwqOrkIJ8xUsc9TVsoX2q8ce863DKSSfdnf8qxx/Aq+YygPAptAm6nUzAM8MsWv2Jfqf+G/JEILSfESxzf3yBDhdQi5Z+usP8e3Gkk+cm43Kw8GDKHeDpbMfawVy5kutFwLiF+de9PaBb9k/gE/MWc98c7aCfvjrfvUzC7dXBTLIE6E4jKu9E3PDG+bKY1fIr3RFHo7CxYkR2vInx3KfDhRnCru6+IVejL2W2hUOCijrTyfmhib6ApSYyFObss4riv89wcn+TzMX606Zknr250FzSDdKz3Nh4Xxv47FV3NM7DVDDep1tPGOFwUfJ8bMf906m5oFutTubzcb8zdTR3Cg2pU6ZWhgjDfL+JUO8qgJ4mA0NSMUzk+lKfSs4tkPQjH3Yt530q+724AXnPgWHxfCxHeQRK1BCZkp4fONWbUDT04ErRuWlm5PKrq7i9fV0TirvTSiMDNpssJhOJwLjWPMullZdIvzhz4AlgjEwgtElr5clcemEt89SC1yN/hda2YF4noJIGwbY7TH0qCGpug/Xpq9TBgQ/OuzWzAu9gAD+3kOAjk2DnCme9wgkE1M7ZZuU8kZlRmjFJDCHwtoELaiArh3yGpI+xUTTDSu5M2ZvbacA67ZMY4/IoiY4bBrBFXUbtG7OTxQMGv4iCesagxwv91lsitd6E2PjLBmU5E/Kkv7XcAOLlIwt9h/UMVTbHzTDnnxGxScsW+lNkDHKYIN9RphYta1BcXUj+mr+QyxnQ5W9inmhI/xW0hp3+aUY+JDz/xBko7+08m9+tTqjXa93YKAxNIDPjY736yfsPJR+YwXx5moVLjQS3Qpy1ptjdmppvikG+1TbYrS9Q7g1azzgmlanw3Cq7qhwRA5hmovNzNih3GymckRRG89ZvwyqTT063FqrzNKBOTpF4ode12Yxxb+kLU/eWTZB47QKV6Nj4AArZK5Fv+cn0U9+OCuvI6TABd/GPeeY4WRY4ZUpMlXf8SqMh+JRvzEwhyFrK6vLdnU1iF4La/Z9TmrcsJMzQgAcH1dQZQCqHxlES0wg1sDkxOdLgv+42DMP0ajezaFp94zuPXce6ICFnJb5cJxqoVuhcjnXWcLtEPXd5PdbBVZ9duWPM6wWOdC5PxswDaZLwmh0kMx+eQI8ddtAodm64qUG9dQQV618QT3+UsRDUKub6FV0/n/OFQbwOgETGBSY3qCmGlvFjHwpF/XPcbXmXWxFtgQ7hzrLuABLoIW2gZJEhVND6F5sWcFaKV+PB4IyEZl/mkKxYXx5C1NRROPFdLdSoORMVqWn6JtJ9jY4z/bGbHcCGk3qPJ5f7nvSk9NVV+gMgbNupZQ0voRCoptjdNQWmc3c5/Hbytw7UL3v9coT2CwzHB6DmTN5kGL1oto/8zFO5VsUz4b9fd1r5xgXT9J13NmIGbEwifQo6zNLeuwQVaJ2D3F1781DKer530nK6W1zkdQ/BGD8oTKJEAfqa7PW6Ledztr4dyVY6pQdivskGnrBzzQPerZNOmkOpT8/UH8RSfC71epL7ruizG4lFrcGR7FtN480ggqsug63YB1fClEHWb1Qa/KQpEwC6Ir2474QpYbyAzkh1eKfJB5RLtLQjer1z6w5UplIPNymgdM3HYBidpmItu+wVaYUKNG5vSbNT9UF70sBVNzPULBn4Cb+5vIwdxxD3CBYFwOplFJ+oTuv9uqL97QQKQvVRxH0n2X26m2o0fNpZraF2o3yqZDXdKdZs15v8aiUvbdetjE6Q6bo9mcuj9/RFm/7BXHJ6Y6IgwmWrfBYLzFbGUm0lMj0kT9ADkDrtOuPh+pwt4qTtAbXikP3NSw4e38OlHHLe6uvLRlbz9mfPeRu/lQlEvH7AoFtSsipJi6tyjkmn7Z2Lvqb+zxUmONT3vtVwXcnX/NZSSkI/P3xk7I+jNwHckhmMw9EpXsh/whzkKC/mrInXgzfYs9Or9oiCDAB2BBOkiQBa1vpj6uySriGVV+jH2LKtH1E+FWDK3s5GHE1JYgqOY7+xSkGVAKItW62N9q/2DwbsW0WdLPhrcUPgF3xFpqbGVXXUIYuIL/M7gWWRUZZ9CHOQUO7ejpkhnDeNmB3GqdI/vCcySKlieTaGU7T+fBd3v8A1fVRG1tD6xaV8Dcanuhd3sEZmPnUbFkdQ72ShUW3oSIdihJtgkz0YYvZ2dV4o+LHcOJ22uY0iQ2pVOnOD8GsbZaAuGjunhEzrgKsZR4/JEF3PY2LxCaHUmK/1qe9Ft9AEC+VF1d+hVFrMH5pAe9oF7/I/3gmt/oO+Tjonu3+p9mvd7fsY/n23ZeylgABRuFZEB024ZBLb/QTCR0kjOe6vUhnSAIgfb3F6BJdYP5HYfgGGiZ0rmiIm6fJTEMjLong89fgR2X4JKZFb59cbdS7kSgtJ+jKmuW1qCAVoJfLdHv6UIkDeElLJjnymKWtKyBp8HGeQ/CSkEfBnaq4QzoAPu7QgHDku/j+rRl8Zoeqi65RMmPjDpN870+m9SllFrm1bJv0QEPEF5UB5JC/EVrRtlMeGnqG/YLyOfnG9tUgD9/M7CFhM+aLC9mPbjZdoaTfoUis0UC2KZIvPuid1dfmnUS9N/6Lke2LieoolgpgOvDoIE1ZbooNknwvvYuTtsf+jHAsGx9U10zxXUw0YFHqTbSO5lBs9oGVh5M8LloN+WUOunXH6uKF2tCmRUroeJH4NfMw63MMucy+leG5yc9JsLWWC+hZYV/6xpZkQyeOLxopnLHKlWTmbalfyzrD9hGr0ra5+L5UNr3y9Pcb46FZWxwgbiA3WzS0pPbCr3n7PNm/Bc/17dCxYfXe81IMqJFvTH4+pFIWOUuoeeEzIizJO5RGavH3OY/WYUb65Kbav7OmF7m+7wpakIQGU7Vnqos0zdl80c6lXC/oceRq+jGsT0HnRhUIAlFgllFotZ5qPGz/scyZospEoBd+IB7//fpqJwWjeBU5EvY49Ks14+igwYIZI9SFpcArzyAsyN0XxZX9mO3Mw+9biWWar3VdYjAIKaxturMFTXGx7gdlJ5V1iSUdsZVchI0iyIZWu/hHTdRG7g9RqEUp6g92SrFEzE7BA8RkyIrfG9dsZlPs2xB2WKL3ABnXtF1L2QM84BqvUSdhrhw/6tw8Fta1vBfUTm/1Nkie3PCsyLPsqRotuD2OH6lvl3jXrLsaIC7AQuOSWbKCYh6Y6poVOBxDL4PS5vyP1UTRcypLSMVdvoL21mmL6hK/AmMR+MaOuwZucHEaihf8SeTXbKGRaeoSDNLliqLkO7pTlvPG+1mo8ChWbawJ5Hqd9rroj3tgiaFoSur2QwkNPj8v4TnH1A937r/lU9ekJwV1N2mszfY6SpGNZan6ZNDaY/jIqmLTjMUen2qsXhkrinmZHg4+wZ7SoYQi1KoF1hTxdlu0IABGAd1h/Wjm3n0zQtOmx27Uewmzg9k8z0kxbgrtojnzhL2snYVXaf5sgY4pAOu0PWZvsh4AwZoGSyYaYQmXEDETSMXNvD7Av9vpB9G9JSllG3RBsw81Ckxnv1is9JCDzSL7FC0Qlq5RDRJS1PndUconI+smU8LDskDnLLErnkBI1wzcwxKO4X3YJTmOD3YFk6Q3I80oRKF8Il7SVZVne+806UPdzdef9OqDEzUYymW0sc/vci9Lm/Bn7fT4eXvIRiaWCa+V0PtEuesKnDJnx1wsElq/+io1hLc/cu1D7yOidY4bQmGGqLUFz8uT697WlZT/Ej73nNgPZbOlhLoTS36Mq6WxLmysBnB0B2fF8PwlU6AkF0FZkSUTdFMGm5LxaxX6L/lhg2ESMhALGUcnAyo83w6NZYDwgplm6+O0z/mqiBCg0YrAKCscb8TXPcNZDsFg9XqzhGhqqnRCHvbSc5qJwt/Yc2oY/N/IH6EDle2Uh9s5E6eEDfb1DF5TrBHiMbweUGJn9/ZG0qR/gGqYCz/U+pIuQc3514KiK8q7G9B+q61EhkcCZuOMyVa7ZvFozNl6wKg0TMX4X2kQmSjLPlTVpJiiF7VHJ1TWTQxVfe1aeuUCPxkcnajnfXSGOZ2cKj7JgUyxLSRFk1w2zlWaZmiM4owsZA2LPqBypNDA4QhJ77wmg5AlnO+dApx3lqxAgqWLkpvxP+Rc5MPDepora194gLHNFp+vcg/qzFiviR6hl5miZhpk2GI7PJ3hQbc8VQ54ZcB2uWuDhu/v2hxHmuZ8XuZGPp1+SIENqkaTbnZoTlXjw/MP2c9bTTxfglqswOccdP3poCHAU0gd77odMOGDxYqbgaY/ueFT896vSB2rvuxHwvux780uHjqINl+mPtBszFImMPUdIvzu2fwphYLNukeMqI53luX9gd2O2SiaqqmqZhEPYDiRcUL8ursYXqOEiFGBRFiB8UGzt9ubTOWjiBkXRaBCWMCmA521JgTiVOhnAPvWs4yjJV26tZI6WjxUokRwyo8cnnEB0I+LmK9acIII5Gc3bTWBJg0ZLnms5B6tkiEGrUivfnHwgJ1mIiF/wrk7RZQKzPuurwdS93vMWoQBPpzRHLAar9TWajL6L/c72AsbIOMW/oUJrBwmPwUrbaGDXlgG0ak+Op2DViJd44ToWkgh7LEMnsGh5276H1YQWA53XSDUIgYDaokfny0Wd228Lt97/xLBMD9Ev1azrGa0ihTpQ6LpONzofbboORnukcUcQrdQdVf1LPAGipN9/7IZGDtREJJev/D5mGQPGrITuOG9ceGgst2dyGJBGUddy9H7FXWQQl71J6hC5kXrhcjSBA9zMrza4aepM/53qY550AwtiDNemzUKJBYaE2tT93AR9DEyYpjV0Fu/rQmAi9Xb6BbGKwel3ghxHujY3V7iWGhpjWR3k2/+MS5JxlFBfz7AAGpz5XdNdSvxWL/DdYt/v7iysUWeTrDIJehVRGfxPk4TFpEhUGfgNvPrAGjG+01uSbRBgSdAmJsCmy/LohnIHjZsa9OC+Ub+1DPxR3//mWqwze1pMwIzt4xE2RUK70EzXT+Ad93JEKOCNm3xeEZ6GnDqVxn5XUvJ5UUWpb59BYBmMx/pP9yB2Bi1gOxi/xOqpX04Gdw+sdIJArrbC7seD8S3vPxmcRnqEXQdtL/eUaJH0ZYBt1Aq5FvWbRIGhs121M/R9EJy78+QrRL+K1qRloUadyzp2KxatEN5wIHMPOC2ZoWQP16JCGlDIegrJxbxvqkJpW+OriiSepYEf0LtnWDpOfMoP/U75z4arsmELajZd35iWpXVnrm1XxKrVbwWX8qVX2zvjHKz9uMOm58TV4jlERpfD6J8rALJavBp1COjIF0xguiq0FZxOSFdK9XOuFwbVkehgSiO0a1eCE+nl9ny8373Vytz+WcEg9s4W9M6MTiAExPoInhnZHs1sTmFpboX11hnIOoNNHXt8tBOaRw/hm/F7UFLXjgBV+0mPQMkp8+jTQEw1fh8DTQqPqfukvJ1is/IkWfqbPlbz3GjVhFRu6qvFxHmoxFQFfe4EiMv1xREt6PBg+YUeHPvgtiCfpfueAlsbm91wGzmq2MHBUzXSuNc65wdtBrm8T2trjTEGN1KE0zEArLWweQ3xFFeTSr8b00/IGHJ5+au9sKP30HvoZ5ZQVdn5l9t3X4kludISMMKMoKA8TrB2+gdYqQ3PrxJc/3xk7mJfgXoPRkx2G++leVl3hvoISSvLvptJoz4iOPuqcaBNmvts3yrlcx+4sEMZpO3UAI3xsQLJumFsE91eb78qs10zQtqi3yZhW/ljkWyvkx3zt5am12VZWeLtjJPTZyb7wqBSCAzMRcbY8RaxhMWqBEKtJt8csFslfG/tLqam3AGk/LNllj9rYylwaFogUJHNFXbQl5J4q8qXe8kDLQhMLO/rpN0PRlSUb4K8qQ6u8pYRWXJ3DKMksTEtLsKTKxpzpIx8WjIwkfe98OTPn4RAweSqypGU1zLtcfmsaMbOKCZYsP0DFx6KWYFJfNGrkylsTiR0ConS+LSjCqN6zyiRhFn+/NSsIEn1fV9QjYA/6FO2w/YqzJ+tKmvhatqWvItKqqqURVI9rIiVkoQDPV3DpOe0lgE77mYrz4x16x1NGrUZH4a4psaQoTvpBYiy5eDP2nRqXegfzCR3+OpM3jJXvTUCjK3o9J7t4tJjk7YW/ACxO3D8aZUGdy3xwt94aNAeIIUNY9v2yCFx0tVM+Eq5jdeojheMBnLNOLbHQ1f5lioGrrS0Z9k7sxpgaZWlBKb3vua/KgJs1w57LH7Z4A19WX/7RgD6Bd7mVB4KCs50Nkn+Dgv26GrAbsJJvdC4Q5jh0sl5plKVYgDBWctxDjHAwys31G5PUeoDPPIuToSNwuHIdMGaD2DYSO8gHqnau0rGC/4ThxCwuCP2Gu4jRMj9qGra7HQdBFyl3UNtiNLeoPIJeD53o1bLiSTT9G0AnAAvo3wbMlMcIZm1mj0olHiSBRuBYLJHy97601hMHI4/OWKnqPKISnfb/zjFv6RPgNgMjdCCcQJbr4J+4ymvsCoMs9OEE7POMB1wkS6wc+BcWL+PwnPrqvKPTVBhPn2TP7idfWhXFZVw1z3QLQLlwcu1Wfqb0PDEmKJi3aGPQd7vPSbCbqGu0mACHTi3TC707tFdtV57x0s+lX3pfXk4kvbaKEtxnorhnZcV1bLvDf6D8R3p5wu25o+tjoD4PDAASDLseZj61KzzH80YMbLNNXgGe1LO+eXDgKg9YZNsPalzVFeIC/RJn6pygK144kjOpwquyrdf1KnbQsBPf28dm8+SCT0b1YhTeGH/pWNrBsatkNF2oLCUF7/igioCZ3RJDBOBfmKJEsRh0lkbDnj4lkkxNa7Q2BJ+xB6L/1/+Fhur2jrFQIug00rWum/9Eokm7xnI74XsK5HX7mt6cmGrplfcEmIa2TWGc8osyMy9eMiyG8K/xe0p1aF11/iFO0DCije2dPQ9H1FhVbBTM1SkCapavC8/LJK7fY1tS62UfD3zza5jkFY8bHCymRbbMP9Yw6lyLoG5s7qinvQsCnDWT+V/1d9BsheThLlg8iDj9Cue8nEPU7r8he+HnHpv6dkRvMbjwc/adq+Zm+nNyjGz+ieNIztnlti7gARyEIWmVlmTbBwqDXvssoR5hJMUZ6A0X7ZsKKjx0tztJVJko1aAf9RwBbpTrFBP/Tpqm29NTDdfXvXnsd5levittCWYx+yk+nda/QT9+p5VaDOoCeNWVSHE2wZ0usRMxjlpnB+YANLA8Z9u2h3GFCbv/F8yjx5cEF/OnHEJ1va1Suwrh0dft43VLdSC4i7OWcCn7FWeycr1UkiZgkasgHXKRwl2v+urm/g+hxLYeUFqDtEZBsdobZjUDIyN8VQKiiCa/bsfGMBsePbNY+yZ3IvYOIkuiRXRRj1NGSz/omqms4Jj3AfcFuTa5HUwmnJ5o652rtqDZzGWtTLqvrZKWizE6DRJnHC7GbVbtxqXuuh7XHdnRazxeudibGL9bA2NWKIS1u6i/9acFCnuxJcNfVVEHWnih/c6go3hGdS2Pkcd0+SdynQOR5r1WTcNJvGki0kyDmDb8dVEAZezbo+PKe3ipVKdHSHc28zGCyZwkMnnzOQuzwEhLkdftK+YqGdRW0b4lQiuynBtdJgPPsNQ8mD/XFpuNgJkgx1k67/Uz0mKjOfQ+UEdIJWy8BUBGKS5jUzjZQ3gMQRZvEVviUrN6dIGxDouv7WYhFf9VpM3Vk7Z+7mJa3s2RorIC7gYw4RyieJqx4nDJs4Sp/tuWAnjdm33du27/CiMdZdcdsGsZOPuRpz7vjuMh8KscVqDgIPeSolIq8sZNBAiXThfwODstvyqpixScTtssW5bmPwAKSQUKjAU5JuXgHQeumfcECqTraid2XE7H7bBb6a4ERNNWpvcU0t65VoRrtXVZEoBNcDaCjarL95C2DBDdZ0R+C2bV/27Hl/qXRuZqTzVBtR9ckPq8aB3yD6Mn0AE+SoWIPzTLCGRFhQhXdjPkXbs9XlRg0VCfCDj9qJjSplVZ6tVogOumslZpYNGQisvpxQpdw82rhp7Gu7sU1GQrMV/6pDUhF1tBof5ksMQtAxYfkzpR1fI3/0lFdbCTlnhBGouzY3VbCThykutqOUBFtGh7rw8Y5zSuVbiHRaZg9zltX0x/wDdYvz+6C/5b+zKGEIj7M+C14LSMk/NF++Iv/xz9G5ALQ5/1yVVduXybTy6yGvDG0ZCtAW5reeevP5oqjqtx6Q7LwNBVaNxagu5QLAN87wexu6N8qLYcvtU46tENKd7fsYzxLe4RnfJTjdyL/zAupWmP6y/IlV51cjwWWMud7cAFYguXKpHJAoC8w7m6RmvySXZr+ibicx8/kn9Y86ezUXQTV7Cfa/sAG350UvE3OjmjR4j0zOKGXLomElrQdb3jQeQZPrMxCv5ZxLWr3mx4f2hz9EPqp9sLVAThacBXVpsS9c1T23F4HqJoBHQiu7a6mOY4L9n6GwQkxqpSngZWG8YJ8z0FgDAriHHERuADLO9F709nWdfWyhx2yQWbm7IRo3ScNvQJEOcR8m6TxtKXSHsWucT8YQ3C6pjvEa7DUUi6GXORD6RkcmChnM3m65w961QMp1EdVsB0IeZ0kk6zT8mOxL5KbH0YhETuWDsxcGKk8ZzJqc4DBjM8bofaPa1nbkXW/Km0WtUAAoIDl1YJo9KgdP6izlWkc0CERZlMPr5BEgLJEkp8zPwjFt3i73O3pJusyUZ+grxaXYfUAxN2dXaxjuLl/utWirpXKxMlro6ib/a0+LUycvFjSEpgNX0p9A7J0vYohNuCoYgU7qdL+R7UWT0c6PizNTOaWSjfl7fTgksb8l7pVjTH68InOBtW4AABhOfX+hNaAy7L4OeWR38RElpG0Yc3AFNVWutet6czwqTpV6E24C5yebrfoqq9iTvg/9vgqk7/PSBz5ZkdZ7GKcIFlUVsVmV7YTEZZfdTpL7nX18+IQjt8kasMCLSesrbUQfVG4gpzUn0dGlC2VycKxWSYK7xJsh0G3mguLJKKA9/1GEJ69KUMiZm/AIYSjGryKx6By9wxlMpGUQHdW2hbisgbJjVVqyjM8IgHOD8PrqdHXNVtr9XTHp9YiY+I9fuMiqWa3ugc/Wjdh3VHMRXGGzt/JigwZovFN0VZZTKQiGXuDq7NGC7iv3e47r1DqGN6mnUK/IG2GOW/cDFxCgPy9z2/DGyG7WT84K6CRvQL1KKILCcRxd2iltmjfD20a+xlQpFYdCyCO+QONpd0nPT/hjNnEAsWxBbJvD3q825o58RkwQ5xm9xAlcBOB1bNp2pmxJFqwPwNHX1WzLUocpJIJiO67VEDkfgJeC/M1uZXVps65HMO3yiHI6DoN6MqP5Au5jvUIY3P2B1+vdbwR11QAKt6VIcXcFSzyvGFgFTWjjE50FcvbEdL/XiLQ3XIf62A1u+4LOkmOhtZwR4OqIxtLvYRl1bTjC8J16CFnVZ2EpEeDSdJVaPwwmGm6HeJNl+LjKWEqSoVFOHbaVHjZrPv9HLo4u3Jc32Ch3vwhuDwdJlkQug5iOcVjO7oSSoYLsaNaPHr7kdOKKNxNt9Y2gRqndTrP1vRrxcTv7R0dezKUkQGS4e3sgZRjXfBdYc8z+rKwv5bI+csCK29SInajrd1SFYsdUHGprJfDTT3iIRKq8Oo4Z2sWIygm7g4gR9bsN893fnzh/yOSmH3u5S+GMeRUKGCUfb9zdYffgDwAAdAPY9YEetJuzImOHB0hYyQw24RBznMuftZgghB6V61boKH5zqpkuIck89NXKITYiGRohu8yo/6cxUChG7cgfXBwM3q9Gpagjf2V1tNkqNdD2Cx3MojWqCedju7nuhVje580/0FddLyLuM0HAur4oLnwy1COdbLDNN3JaAU2jhZ5uc7UI++ziFtkWErppLNhJBW+Gv1NCDpnpxVZrSj0CupgON5HDeqQ1KvB66Fv2ldrjUMuvL1KnpFuv29NiZQ+0ZoudHcFHnSYIjkLxAeh2YxpcR7oaK3QiyxABsB3juzcNZ50dGuXgmpNSwcJx86/b85ERXElEaVYMCYUH9g7/6uHPG45UvXjtXZYhcyCtQzZAxViiLzHPPDmlbBJ5xVYTF0Lbj1lE6jDAT4FvLIlpCAEPqXzzFe+SywxxGLPOVuCXFbiSmoW9+WB8ZgQVNyAWBaRtN05bhuoVbYlgCdlqp4uq0PIXzunPvIpceeRKXh2tsG7VJRsOO+kw727McmrlTUte7FBvBFqWHyN/RSsaiU6siZLjpW5NOLfUOR26FUBBfKBL2GkNMfkVIHsd05fMztpHDNR8DPUfg3lW6PhpWX4R0kJEY0+xf9o19LIJf7y+pHpfuzXHsmFJLThLNj65L3nIdx4l0gLIVhd7vQIOlL9qzrVFIFHRCtV0FUtgu8geOR1Pv8aOPPKRKAePMpE0314ywoHsxPw0n9CtdCTsc6cdFxIIvVmbVbXBTqRqMKaJEVmdyyDl8ZoZbO6WOv9v6LRnwFqYBxS5ZPkdjMx5OmeeTlt/OQNEJzySbx5r29QCjFzB4dqbBfpSnOkqLQBZ2ipzCJwB0Se0v5xaWGx01RuZCi7WOXewQdjW59dpAfCE6de/QVyPuIAPPrSFg2Nc0sp/oIhdfm0iauRtQucS0o1yUCNmWZM5IIpMnJwvUDW9pYMV/XFV9ddN42RqHKjNm90AgnA9fZW1uCIMoUOpwEU+Tt0oCRXE2TIIQoHBX1fmFLL9yKAC80JwsDI3Wk1NGZq26EQ4nhL0ClNd27sjuh2MkPAPslVlr3VI/G+x7u4jMjbiaU5Eyh3X+c+4sTkE0BS+27GEe0ys+xuFyXJnoTkgBVIh9N9slLzhf9zCPWAWOLHJlZQrzUmgAbPv/naGkGArnvDG8JMPz6NTWdhEMa61IUGsEEAt170JZ4wFKI0eiLRpM7a2G+Fyh2/4smm0XvW9S0Bl2rWYrmtSQi7O6bXe4xlqVEhPEhydp+LDpSlk0m66OcXjrs13SsxGo7/2JvLIvJmUuiLNBPorAxdo41/jGt0Qy78KCtdP1kuf0Yik+6RSHAYE5b0wJ6rMeLjwKy969qVCayh7MwX4Yw9lpBZAqER+6kAQ5/eNAQn9oXnvi+SyPk0B80DM2Rm5X57Ly+G5kUbkxiAhUj7N2XMJ8F6JPBicOt8b0JED2WjgIWH8wadG4PRihx6bNCGggjw2IIhdza+wdTe4ZfuoO9BFVxDvV1lyzEeGfL98XFlmATXUkrgiKRiVnzoPlQXO/+81/udBd54xaE9CtKCMZ5/wpDevdD1RtEdqaPIcVTbGGpuXZugqhhgNbQPSIudX7bX72e69JuwDa2o9bJ+ilzf06dPvGxVVUITVVhwvpb8zkTWkbZdmL0rnyqDtF20Dm5UIvNyVhBPEMyjyPcu/IFEYiKUbZUIuLXe8L0f4zuwCqbFa2NLKXtsglkdke8PkM5Hq7TOdDZe7iiXGYco/oGQmjvwOVjw+EbMJk8oV38QqWE8sBSGrVMUfjFiULpR9CyYaUctIlQ4eZY6y9RNkjTQxuzF5AlQAAoIIGcsteKo+CJRZ1Kr8+6SETvd7YIhkCkwGXtrk/DHpAs7QoEKY+1uQza1Rvv2SMCyWEr4tSVgIdjPexye4TKthMeUpcQ02xITHxW3fCki4iHVmY79QumydRF3STumfUxSH7MqleJ8ydWDIxkOukQbYvnwbEkkYrgNHG1P96FS+j5ILxsz4M2qQSLIIVQVWNKVPMk0S38+wUXapH/uUvMMqyBkWMc0Lt3+lkkQI4lkh7OJFGIcvewAVu6eMd2E2XSNszeuMst/shkrigDHbw8leWoZwfw0xlW1Y4Ij5slQM/SJrDGYpVTy3s08zj62nZDgzMVusmh9vjYSC22ZK5No+/3f7yAghgKt7b47QSsBwNmG5lUSM4IdphYPG6bdhfHIMA2fUahqEY+bEVQgjECittAOo0wcw5XHWQp+uECOGsbzylmsPPsCnE3+ECKlkMpQoSYxShHBcDCYnMA3l8NfbO/OrXM0bzRoXy+pRUKXWenozpHmd9K3/HhgpWdZYV0BMSBqSz1gccs+QGw4MPteVMKk5n1VrFtTJMJUNyYCQplxgbeeLBSRfbVDhBrOk7HxGdaX2uNA3ohK7FKhGupcl3k62JwzEOL1v/RJkd6y4QlxMRrh/tT6kfCjU+kTeTtTgkFF6Nss+MXgGVJSnPhMoqdmTGLGj0lgsqec6DKPrzxR5EQk/eDSuW0FuQf02rcheFg6DL/RIyP2s6QFc7hQEJXzK0TiLnRoHSSCAtqKD4tg+4eMoJDJX7X4xWg11kAeKDG2UdU5HWpT0gNUcnNdhCIb14CVimfnwYt31bHCx9mQG6xLVZzgXrb3ERwBdRZdbeSgr8JVPmzGIgxaSE1Lo4PJyPwrEuzgIFlYEd1DcDvG9c5qHBOWhpf0JQvtIegTSufXZyQ6G2uYZ035p+PrzmYWdVvl1PQpZytUwc/AVvjhJWj5OxeWt3JgGW+0ctLnuai73uvA0JSNACr455m0PCx4R241Aenwyjrmniocw/krJkNI+tZCZ9ksWB9k6nNH0NqCXflHo1LV9+oKoPClHXugAo02uI34r6y2wI8AiyjNrmKxqQkmSE2tVsgwt5ShcPx6XOaCGvFmYsYxAHDjBXXfvPZrWhnQwlOva/7ckmDMWJrJ27SX1LkfqeoPKpPig2k4GaTA26V5QM6Ra3ZWhGm6otH1XdjR+s5+xH7wq/0n3CaiMelUM7TYG2umJMNHh7dVGASOlZth04rWK9jQsEpRSrbvjwcrr2VxzNTn/84USwxVTFBrSQlSexaHrGZnw18904XJNjnrJvOFK5Le+yi+wBi98IqEqVuCGNnLISfjePg3dDE1mFXVe43yuycU8kZZ42G9WjirJLWENBw14PeTHS48yC6A/VZhAuTGBMx9JTnmqf9quwltTsMH6DWctjjegxui/BboILHHpXbboTS2IfJK4xJn97k2tcBzn/78XySKDAftEumbB6clomgGqv5h5YVgLOow0kyR0eUcH0lQKGmVoQoBT+5aitfemxANWLKEmXpzgFS89KanCHuNdP9BdlsMeKCV3z01+6S9tnmmSwby47P+pyVDyTVQKqcDXjyIHdu8JQn14eXtE6W3gS0AwajmJGU+xlj16CpOoBHbPirxFQ5Wnobaf0IAyWdAp6arR5BGrCjKfy+AONAu9kQ26pZTSMBTSBSCuOuUnD4ijSUf6qlqLL1KXlsol7beKd6dUuY2XhUb2w32LeHGUk8xC+xV8+HVkimxawDFCep/rffADoo3/LGcseXLqWuaqEOduCfsUnmbl2UEnefo1aZjMdTaX0lCnielHx8xETLsWUXZaa7RlIyY+VG0t7Di4d4ArCXX1tfUvUat2Lqh8byWb62YNdxgVt8ZIQVT5UI6ld0ZBRtsWvRbD69ikvp97KIkKpGHoNMGVanox3p0/xTE+fq2kUvUs3SApvS682eeZBfYU98SDHEaNDZ+08LU/BEA9NPl+B+veI1KqKveGH4ABP96Dwy15piJaWfVt2sgpzJwiGur8/zaFhJL8rXs+tBCS5DztQ3IGNpHjFQemEW1Cz2znhxC73Kft0KSrB1a46ak/gneNvtTWpCujevS7wIGqkrUEA5aaFe4SguN90j4/3/WF8qVYoY6zGf1TiM9pP1K2yGs9C8/MDQXjsB8P4E4x3mWBVmEk14+VuVGsL1SeiFmEI1G/fzyu5o7GWLsBZT1yWGbp+I2WpXeDDKxKcuoS3oHJ12VWDMSMDM6ZpyHQ3s5NKls0R0gIdwhoQvjGVmx0Rv1hFhiAOCw+9s2SUheqmrBu7QHnecHS8tXAvPOr4+pjWUjnzh5jmyIkLX9yBjmzccxGU9tHXjpvJY810uqBT63RZQ7RaW1Xa0X708AJVyQvY65rLvJd5CqLqaq0OrQbh+7rVRetO6wcQ5pGYnv8/o9LznaldTlGat8aw4xhOi9nf7RlFvOK/GpgaU6KmOc+HnsRBQUyCjJUW69xKiTXm4nQz0qvM0mf7WiLsaHbVQn+h/3Ti/B9oClcpA2MAvttWT2vhc03u00mRQNlXySQMKWceM9b6tx00eRBmIqAh08+NoRQ1+XQ73t2hqcUcikEuY+SVqkdwWf/TLxm/lH6fxzFOhCU5aQyd0wdg+i2lvelP4FFws5ie1gzxaxqQfdpye+bXf0xeK5CenfVut/LcbPXyQNHdZos0zcpX1RDUWpSH4kb1vrGfDS9NBiBAJmXDA90aIlrPC319gRbCzFhxllgUFHvvIbh/oaCKqv6RwQ25v6fC81ns3LhVZixs0V2bv7tvcjCbc3JXcRZfuIcrHRRXJOCKQvGUtTRgrWjpc0ufqLnD4ypLBjBCcHj087w2rQX1btRxv3Ab9OifaXJkKQqlCe0PpojZZwsPqzwYqpnGNTwGA3k0agXmGtixBau3KBeFyOSAEAPRP/mO3F3Xj/2Yu3NWYvbe8m4CaYz16fxRZr32QOrHR953SO/6jpJUs+gK1hqKakiLMCpCXgAoiVB5Un3DqM5OKxvVUQWofpQObmJQceqnXuy4K+tf7mGUHSi43u+CIh0NRszJiarE9mD2X9AmZ4DTm8+jfSIaw2fZ7uEmwMhJ0/2MKjD0BVGa64sqUELrc2XHoWdiXXiy2G/Ppyvc1XfH2qAD4oJvda8mUVRL9LGdCxOZ4HkSs8hlJGzrN9sAaEqGGUY9pxdwuzzL5AVt8XCUFsEBWiFB2/2MMm6JxpnF5fv4pvAs/tC0rAKhKSUXzAJTk+zc2yGXqMY+XaQpQW9jUIp/RXma+Cxiim3LSzaXwcHavOLaUv41Q2Rxm+eltL3LBAoa6CvHgRRtMYAmK5BZBJ53ytuZ1ag1Fh/GjLcmtbfcQrhUt+vYfqmRRylEY36MtfvWuHr3a4vx/h8pX17q/tzFBAZQDlfVz4ea5RWgNxjKf2+OQ5DcZSDM9ShhG92PwGUlEIbLTwivJKJr/Ll02BRGT2oBEmtJhGdhUmOAov9M6poGFPdwepA07rDJLWLNf47BPwAMYGlvad/sv/0oViP0umr0dBSbNnUfTCIiC8vXwK+9DWcKe3clKxnXusg7PEfTENBXAm/SgxyWog2Hg6hQO/clNvvLEWGxmHI8QvXt0r8JIMYVREpGv9l/P9IhDxUH3l773kS83HtlEEv1CPfpGaV719xSK5n5qS6uPAqXsFemLqdslBZ3XjE0qX99BPhgtipHlokA064eemdj9LFlciXId6nA20HkQk3zvoJPTtzZRpFeIP8H7/NKrQmGS+bqy6FoRqx7weY3ylcwnYRWwKGJJwYa4Q0J9AddeFevdIFl6snvzZ6btsWwq1rBTkPuVctbviuTQSyEnU1x8y2ic7dVcP307VdHhMEd0Mc06jGrTM4A0eF2M/NDrRRT0dVnc7Aps8krCEMBam5r3nkdjnilSyv+ZOYFuXdxd5U2fFMztu/JiWzzBjOiLWpqnoySDJGzIgLaYXEWMSsyQyxAJ7UXxRhpa1SIB65WPUfUnSrIp0AM83Dpd1pzx+WPMQeNLCWaLHRQLEkfWKuHsnqSNnwFufYZH9+MyEBu0wl2utvTv4gGA9WU9b1/fmJapS5bbE0R0QuV72MaCKWyQNRNzEanw0GLQ/6ucn9o7XCKUQ4PI6mR+W8eArZ54ZVNhvTL447CHRX79uKK9BwT0KQoFuHOTNUcinWlSFxrMBSR7J6lC9diPsN6UVKbLloRzxFXHeRXm84fu3nqfJfpyraCQv+msS3+e0JXxwv2FxsdqRba6WarWEgCynLAfsotOngn/it0jrC1dvJZN+dFVupgo0I3W5PRb2/nZ9IaezkRgad6EHGMJguPzVTr0JDr4Kk5oLXhXIXNv/SZDdlJfE+4dg5pMdIah0eD1ZeUofTh+o+ljkBCpRcdMifZMv9EzqDhMsN968v1KhjsVzpFroCgAx2AeQKdxxIRBR8H7Q8E5Gu6fJn6oS5b/dC4OTDUTkNjVpwyxHeDBwJFDFSZfuFZiCkThxTaIao7WU1RKO1aD8d2JJkh3tIuS7O0GK9u//aS7+2Fxyv6iAIsbzHLq/LbfHnRX6vAmM8I7Fiakyo0vMB/M2fWm7DR11a4H0CdG6ytgCWXqFjUJyLJkOYc3yPiiTXL4tKlAHc5FAglXflh4ar1xdDg8mwWdjblzC3dvT08UpWZKhprx/GqfmAKHpEjO0ngVrrVM07YYjiTJP729ydcH07NY+46Yp7nTFeWXJfNVaUqAXA9HtyGmCzj1bg/QSmp2rqDnCtcWMHEnJXWdDo17ev/awo4lTlNDd5Uxbi0drfH6HmXF86oPyP5a8rHSpvJz9zzkRyIqB+dulAiR6IeUyA5aZ9yNvtAVq/3Wvyhjookpz2fKS777+WMpGgx+ICdyisQ9sWiXnwte4Kdifs53LFqmB77PQtt2QiK8kYmRTp3+fSBukXz9CxbjiHVaOWrnpUncCuKLhznM5mkl4TMHzqznWDq8RztJNJPUXIaCZh14uGrT3nFNDOfd6EeOYxHXI2STRFposxJpgwf6hbG4HCj6CU6sN8mwnJXtqCtBTRCxFPbm9K7yHhVK4fjTlmbbwUhmbxTLgYpx30RMt9D8J2NgU1Qg4HTUP5Z8FaxuP+xdd8B5SctGP9KS99WRIpwoE5bI47I+3LZLiRcx6t7Gz8tyhZnOcZisfXnoe8tVED2S8H6VvkVhq8Wrx0DosH7ZBIlXEij/yCfrSqY6Y+Gf6gBaQKBCSD8/pegsBtO39q8TNQYPxZxzHiwANc5W2U4NzY/tvSNDHSfACVMSUf4npMZlXAGL5kozSotlYEQbdrf1DXac/QJALFefNnSOs30fMHukVZOIZ3e6dPoR+vc8Miqbc1QX13YvpbFYvLbJmmTkPZ7qUeMt0w3F5h8AHj8rpbyfEpRVD8l7U5gweumSpc+Qm65ETKGXotWOZx97X4ZUJRCmrPKtl1j9VyQj77cDMxVRBYp9UcMvqvIVIBoyI94SGK/6PkRCxnXnAlV6jPjSh7d0cYWkPzxr04SABBJflp6PMgCDrlZBY+DYbTFy6X/GStrSkSSYlFbPsCABcGhC3IMlHAX5/O0kAW+PZ81jPd8djlzSd8MC6admtGLYtsoIJqIwQNaDNgXDRlzE45WYoADbPWYNnBEMNJvWUCEwzT9ctJ3uBxSta7q7m7CdPrVgKI1LbucDkERzQoDJFvPmVvO/L6c/BXehRI4HxZQQA5Pq8+c0qh46Wwc/GwNEWURxGBkSgVqXZm/xSV90XcNh2vFqI1Ty6TAVboj6TRnY/eZRbifOYj4DzYJuEPWab+rLx3LyNtV6wWy7uhUxlgrGmOQVy0VrcksSwum39kVaf7jCYUBvL2XIbZI6naHkfipS1rtcvYCnvd7zBYY4y+wADk5ETmQb/7YrSB3ENrNjoxKvJgA0ptqlUrEVRG87PcPZgDw9dmhZ3fnYDlLp5P6Nm8czN1vrCYD6xaldhhaPSQo1dZNrz+kJQ+iWPozv5Uv/wBojiLrIcVW0fMefHQI2xd/y0jKfNeN28c2c7UAlo6LQMPsjXIHHjQkC3j6YQaXh6gt9JuEVNEQBw/Rmjm1f6FrEcyiIpfn7THlKpqsrF/ynZsvd1NHZ7tpeOf1YofY1Nt+R7Lo6Gpe56cLEYvTSb92gG5Kq1/PqjAwYGdIWhgP6dVkI8hz+88vJ8bsyI6P+8hiM6fYKpj4/+UyvhXVD0vF9k4FZBKDVk/OAnRp74koVjPqQve80mTj5sXOq7576hQ9uvCKD6IiewokhEGvNWRHx7ghcREx0C3LgvZhyQ18RR3VNwWEQh2tHQXtLpYUkiBpakfyMqbEu7quT7Ub61ptNB/Y2xOEz2Yc+9hHiIPvoyD6+aV+vQ4/7w8vqU4HcyATlt1Z4g6/eAmnlgVNsOMn+RLnpork+5YxOFGzlHgbOft0nZIhqMo0nw+9xo95k2ux0Hpn3A8CLMTILcac5bnuypgzxFjQhMIGMOX8ghWGDa97NZV8xrJ8TKlsttspPBD+kqhUM99WzFnswS8SeiyxUew9UopQP98UexYApxSuMBuT/pcxntQaCq0sswCHacgl/msSVNEU+CjPD1017TqRZJOSyN7dX4WFHkPo39Hg30TYmcfIl2x0DGeXZaUq5CEHcsofvxRSN24ClBastHm8YFvt87G9oo9K2J2pyvJ3hCUgfhQD/S5TuozWrQw/2iF6AtZR2L4vQ+dUwaYZM847TdtuOupv995OkxsR/SieiOKgMqW7PyqK+7jVZvlF3OTHKKogMmohWTQAFxZc3lHqtujSeqTDl8i8+Z1Cvw3vpSBn31ZXoBHOzYj2A7HQPVFMF5bk07x/EhF91iVoaVl5Ef7MKmdcny7yOIYzX8wp66tTgJTNGd/YOJZsZH9SRmpHpKpVYFIJstjwK+EtadL7JpAVWrzWfE+Cvt2O+ao2yz0YZeym4BabRoVSsEA3xcabxXg7S/0LL2tef2nIXFFtiuXtQrOLuawnyk570Exy4qOdXZSna0u4W6PC4wcfdGB466DAiuvr34IJGjYApSC3fUs8B6NbLjg8jtg1qzTb+brXqAf2ubiBLdZWa1764MSV3uxreuIl3hkOEzz3oQ4VIk2V9o6515MGmEVz7XyKBd/bMSxS5GKNAd3wvxMrX9CjriA+VVUyJQwW356AgbYFNCljuNk7S1UuzUqRL4rWBwBs+bkdJQ9tjCJQWy/GyqzNmjd9M9bfF9EfYtB6LSkosKdDxErgYiSOuC7uoPX6mGDbUxg4swkz0zy8khZ8pe7JVqg2aJe49Vf4q7v6F06Y+acR+Feo3Tll4OSy+HCyTRlr2syeekxu+PKLv79P8IiZLu/aLVwBRokQM4LGKeooGalkYIKQeP2/lZHUy+ykQyuaEFOeqC4PEiKspR8rTRdIt5cR7XDmQG/6Gcrczhio05ff3a1vK4ohkdp97Tly3fviyajUKsGeyFxohu5P5DgIwMbbjQTjbOayr/TbxXPtcJvk3jTIrerYElIurYBtpeJUQVDbg3a8YUweMqgttZsdzDkhl0g1p29yYIEKrGAE/ZzwiGH54+cY3hT5Ggj4GiHw/hEi4otpXy1BfPZaRtSLcgvsfGegmdLxEDyDCDyY6hZkeVf/3ivM2rDfFxqQfEpMk38gWTfUw2QmvAuu34n0PnevofRfgXR+bP3ijQU4Wu4WKdneNTVj/Xla9k25LlI1a2iGuIfLAtcYVn0AWyUjdsDCsXwwKWrBkkh4CWr1cazmkdsrFokfWekERt0/yr7u/J3pjQV83MgYlEX5BkneF+bScsRq7iJ35qgUJ26H5jDwHCchUCszZ1k0wb2bT/HKVo75qev9SsZR7dioynfn9P2HneBlslX4ipbuyzAY57BmopsoiOkrktXYI/FfECcTr1zAWYOjz3ERkbMVYOxE366KzjzdtvnMewmRNqSeVxqV5VCv/MAwDe261o87E4g6qRDB4k3FVGLqhoAskUe9dZjXxWOtoq287VgjJ3M9sxjnRXzEPY/asgi0nd1AuQDD2Lb4eett8MNaUdvXgMNhIyCJZz2u8c6PWMSIHBpHZc+9dA0K3zduTxgqpukcQrmYAOUnPUIvS7QsbwPLQzMbTDPXrirBP2FOrQ+INu+S2NpQ9Yo+WfSlo3I1qXZkJ8cBoFZVK62usGMxO9VWED6xIWzztDnpWyBq2SjxyeVfhIDzq/wIMbfoYxNe3UXhin7wBBUXHVch6btEA/vKJfzXASW0b3TxG5oM8gWIRlVXhWGcxgcmWg3DFUVM2pLuI7Mky6vudDPFIUfDnOxCylz+sEIvtbCsjfsjr9TK76lh08EER/TgorXJRt4fst5zZNK6GDUkBZn8HlZaEFJNQ4YnlTbHvyNfKM9sU84uwkfuJLP9iFwp2OtP9h6sdBDGJ7sSuEXcCmIm9nvuhpI57vNmF41UZKNkZMahL4yq2PV92yTHFjCx93O2eBC2+e1LF0GEK4Py3rJoLjSAmHWWtS8ZUR0g4RR7lcHeDVmPVNZQh1bPFod0M98c2n2lbBiF8HCfvEffJnHBrj1ppu4YCM5ny5Lru7Dfq51eAWKj/Dij1weXi9xlBmDBQffxM/f+0eflQSggmtYt6DBsMWJteYFenuVJaNUfcHYsK1Aa0wdqVFjuwJl83G+/kfghsAb9yTJe1L1xmgqiFkITm7PCJkMdzx6dIeQ0jdKC5BAJ5ls46Y7c/b0wsSIM6Qpu/mO8wjWexv8EzIpPfgNtFhsbLcp/SJzXD95qsTE1Bbfz2ywX4x1IAUuzxFdpDBFEXleNhR+BcltZ8VJL+Kw9+hQXrn2GNDsemD6ywVvHEOgP3XHssMuo5vBPFWbtDaDzsUtYKLDiIF9qTGhOaLqW/CkqdehUXVPRGPl3SM9GK1CmLq26XO5mhCA2Y0VhKX3/FQb9RJkrVe3Z416IJ6kJfMKsYQduJ+lspyXJNPdMRp1fL6+OHmAh/+F1pXmO3i1aqfRjLWGEgZKF+Nei24K0+Ba0d97Zdk5H2BqQgvk4Zp34W4Bc4vhFh8n+w1k6co3gTt3ONcYoD4KQVcnha0VTRCPKtgE6qhl2XiYzBcXDTC6Ku8ZpSYG2cI62VFSofWV1VPWc7XkL06LtS6hCnDwPv2p/hkMGyV73eiSX+sNNB8p7hrxdOfYq+8ovfbryAJxMxanln1lPGh/4UjrNkWTgsYkoqZaPVvwT8a0DIgJ1c3V2meuobNWL2BZ3yKSGjGeM+KMZH73EZxGPe2f2tOIzi0xhO3XHovO9tqU4oVn4b3xw5DLQA26fvZ+Zqz7RTgRZA+jcjez8lsGHiAdfrZMrckiBvVFWpscBktaqVGWMa/2yDiEKRZzh9y7xyh5RbVHOSvCLFoeOlxt8tbql9hqh2zEADPduDZYjAsduLr1AVY2okaGzeuI7K9dS1psAzHh6+RggHMqXeCGvs5F0ysb+fcfxZP02Z0Zf9c4xaU9UNv7pqinJDlxoki93npv/CY/y0Qs8HEsx1t/I92fuI6VHzKl0mKk33ukoa590+Y1BLO4ceE5sRHMzBjCV+Fdqj7Rwz6ZqduQOeficvmkX6/aFsn04dgFKqqedZKrnH6pM0PlKL1SNckyAerj93bvX4Eh8DcFHbvcanHO9oe2UtHTM6DdQ2WeUYCpgeeZ11Z//q4T61ffGrr9ZJHkcvEB64nIzh+f8ejWFpZExxA9lh1jFw1ldPT4kWdLOB8iiS/ZNr+t6X4poWOGIm484iatPEpe9kYdYlrpoLv1Sti6mXhqBWDOKneW337sI2cLtbf8UVTd+VVZOHFqKLlE/GMPRZ0kObsJAuCEStppJT9c2lEK5fKx6U7cWgS8T0ERpBqUcNIbBfaLBajf4RDt+iByTWD4YsCTc9FJoX+59p8MyshLlvjVurbs9fOGktNAidh8PEMNx+mVDgfSt/y4lhhL1QfYSXd0jodJXc7KkkTqwSOJckKawMajddnf3hosp5DdA66JTm/cjGksQ1q9bvfksH+JcenHGdK6Yp4ACEVxuq9sSBYaIP702Gm0kYbiBFln7GGLHzrIZAfZmr5GDCOjaBgpWYWL5QvTSrc95p35VFBAW2mDLWbzaOaThO5izX7BtlBwCvujzxTIC82YuuF4BkEsZNEeEMRM00H/2QH6SCP8KjZYsQYbIkuJBO6Su9sdn9w6PpTbfTcMKHB5vEfnDBPQbRQIZKLh2TbeeQZ/gDduCM46/c/IzkjOu5DWNgHhyR9o8aFoUeCexzVcw7e913uhuWYItdMNBMgFaZyUHmNBzyk8EHAVYmJAbg4cXlwb/Dx78++FN8mjDM6/CcJnCHH1B1a0Gg+1yHaxJ9xbMNJz5AGv/7tlTNh3KUMxAhe4wNLJBIUCFPtPgfZc1bDR01Vc+Vzei122LrxDP4c1GRyJkMAT548Qn+dWAwhMDwKf8A2l5yDLRe3V5IYcSOllbBTNujWoLRfiR94cdzKwOvb9+KBTxbam4IGse6jo/dVzTbX8wz8KFxkH2VWnbxFJvwesiCnlQi2ZOQf88nPqhXXCvAfSw+lwTdPAlc2/2bN4u1dZZbnVFFDIUUrUtiQRQvjBKPLQ29y9g176vJa9+374LZUe2gSd9EQYc7P7TKrn4QbqbhplmTX0A85vyh4cfpOdjEgKf+IQ8qQpXDlB21MOM8O3N1uZyJ8ge48A7EgnGheFwu+Em6Mi92yUGr60wnKgZ9U1uT5Zmbkfk54wms3ILgdGvTqGCQ5uOahmIn8PRelxnjgrUo7pinEf820SkqF7YNodqzgpH+jVOY4amouLHWbfqchmemOEq1iu8ix9SyqoTcyVtVvidRP7ZXlQIINOy+NBJxTOQrMmSZHzaGrH+2IHNgXDyWEMsir6dj4lklBiUO+VCcjrWWCYnErXrMYlW8RtN+kdWtuCLjP1PyMM+FEtLGDPK74Ow5WXvbXGpaMggKyg4Gkves9pqibhummHWc55LJ2lqqQx0+SF0i3lgouE+SaYgznvcY3hkNty4q78vPJ7HjqqqfCF5LFxbUCwBW9Jz2UPtD5mmfuRkO2Aok9lHAN6KFm9SUzTtI10VquD1iAth1QYLKIw5aaKH9snKsG0jTrRVQtT8+moVRGf/+nZfLS+7yL6LlyQIQdAem+McBXL3RO7d/qjVEDcAI8N8b7Tutfo01IoOKe+HmNZYXe+GARMs5ACvACTS0MS4bYQc2bAwdvab7258Ea7jJ9kgmO4hwxY5lqfzt18kUot24RIyFvdXejjwa3wn9VRT9kJsLW/BlC4DzTwbPr0sSiIUE6r+eB+sXrEO3lkEIZnpqagiTpbPXsofUn57/PFFPEnATxxdqooYwPa9BoupaiAw1T/2w0FOmtf4DFZCKMD22MbDyQrRp+3uxV+kdTF49r1jRmjK32O8bvzyGF0vVL/jTvuVddOtheLhpffbEPMSRgr6mhgUeo2es+pyAql2pVoc5st7rgICEXqfJESFTT2uc/onc03hbws6EGF2Au64+2rVGBzNIYm9Azrc6Zz4vRDFRSCsZSxpAogUEmFeD/VBrIHYjTo6PPvX36x++Ok3wu1cWO18YMPFTgqn7m1pmmGvZczbNQPzZmaID56wiCEuI0eUIz77CyUqKume7F1DYyNKsEXVFEKue4a1eb7gN1f/99qpXlSYOIiUXpIJcfmlzcaP9MovsMfDPHFXayyhXWOBONwg0yAcznXl65b1GL9Zwj4YWbk0Agb4dDKIBYRK/yyWfXITyRcf6lj603amEYSqIC9QvShhCGdM9fV81kxYDI15vY04PkSKPOHXB2v6JpEtsjOmvSZfpnORjgeqfSenHpS5jOZDyVGNLIo+LelzrUQJWr56jbHt5LCz7okhJ8jWAL/7w2C2wFXSoKI02/x+cNyl9jsRZsy8043n0fn8Ro4GHR1rgi4qbsJUnL4K4UuGF/5FP0A4cGYA/Q47MG2UyDqjQdExysPUV63UKqoIe7/0EJy7Ea5Y9+2Wt5GkRrVGAyRUXkI0OGWNsOB5oS+W2nFUpj8yHHRsgf2VGECIjirFV4f8dNY9+yXETD+K/bu5CoA6gInFMBFK05oGUATphHWsQJgx1uh8Ke+ckintksqeXlQBs23S0gu5YMWNBZM7K82kEZfDSk//+NRpdI0l1q9P4Ayd26Pg0Z7iDYQ7tvW4NKcthKGp8j/DhNS/gfYU1tAMNuVsRJkRgWUyiaT5v8LpLgqi4J2O8pmF1dzYWTmCpZv3s5E8x5X/fNIBKBWK8e+jZN3enZiPlNuGD2xR3SjGW0g/CuGFMLxdz01SxDMatpaj9K87M058iWG9Dx0ISNcXY+FZ4DAv1kfwPFMwv3QRpKCOpCAuD2Lj1xYKGKslfmwueRFFD8el5ri9c4luQgzDIE6JlVEiuC2hcEafb1DEp1C7KONRYCfRjYKfSZ9b0OVFy7V+BSQH7ESM2gaHluIXKWK+PYMKBUwJYK3VZKofu0r1BGmyPCUZZpVSJF2QcXucTfIV76nZtsPLwHAAbyOE6jmCscVl/Ycsu45XyrqUVxGRIBDgK4A5NnIDlOh20pM79wtPS9o+sAJPFpK3M/y3bbNicIVFTlepapK0hLb688p8R1oyv2wFquogXepoPWkvS4wo1LQJNLDSXKB+vrSY/DtpimyEF0BiZ3oEQtTTwM9BhEKbp94KrUlsTCUkkyejUx48hsHJ414Gn+1yFPsb/m/4yiyqlz2JzknBoSqRYw0HQsgjjWEm8YcctyIC4DYqnChr6nsd59OkXmHTYKUSh8cXPSWH9Vwxz4/mGA9jSBf7EKuPmxwSI+mKrT1KCI0y0GprPaN9txnCodyx9zAhbH2Aosmh1Slm7abA4tdsplnyBlY4v0gq8SQUsVenI/tA2CRdGTetyNmZjD5OtXFApkgbZkEb0TjePw+/QmFXH2CoB7rq2wz36Wmgjq7xMc8aks0lY1aT7PiaOLa/6S8mgjA2Sno6p6kUgs3T763y8kRHYnr45izPcvhu8wuh/P9K+x2T/2A/1JSPiZwL6p+BWPDU3n8zBtjIVL3inCKt5Nd4qEsm38/7EssX2MeWrX0LKGEXo8RPPP9zsw4j3XynpOcYCpusNOt3DisntMuuODWN2tuog/ON2X+aaD29yHmsRXhlbLTPQNYXyz3VyH+NzHcDrRpMgpXgLqAseU11dUBCncjE7BBMXOC9vMPQHKbP8NJSI9IXoRrvAlNujnXtQTlFKRymB2PXSPeqPMyO9800TBxtI93QR2hvijpuW7H1Ksd8KBuZHNJoKevSobFl/8VBAtpJz76R2YdClLPVJpd9ZF9b/iPez7bWmAWKuZiVL2xqossR96hHhzWOGm20bcOaErD9SjyOL+V/n0HvOLx1Ri8watG/xYpsAczq4IEegSHkBYl+sWNEWgxbfMxXd7jdw7LRmUzKEc97ITbiwrrFLZ0AcfjtFgljV1VaoQNSmuA1tklqaLGzSy+tuwPAqqd77EUHUjCSGir90T3yvXWiMe6tf+J9j3oiVS21IRMRktciNPo1M8TjxzEQ0vza8vqPVixM17lyJgmrZqWGZQViSVYDezkqA6HtSokzoaseQzfN3QM4zfMAStBTElTAvTpIwskusHFKh6ycvDfOCw2FdC0AhbpD4Qnc6Nl4oiDRGT77ReWSvr8I1uFHILZINNG69GTRSSFS9/6icjxcgkFYtXEqHLWGPCz/yAlYeJ+YEvGIkFaNBVdAG2sVmRvg+ZQ48uAfDRl3t2MTrky2E+OwnSrgvX70QIIVIbuRer9wVZxdIUdRTO+f1PRXmg6aYJZWHt+GH70sfKwh1zJBuFKOFzw38u9/qbCp+cC3T+hHMvp0t4H+qNDM+B2wGSWAZXQX+2lwRYOaiqMrlLEfeB2MUenyu6z5xlbiZnvpV9bEdoq468yfCB0PU/fV+8T/+WivMF4mqtTnxBxxGNlgSpD241r+eu46NI/aveuA3uC9IDGWxoC1qNm6+HjWhZMRCYcET0/ydiz4OwmJU5xwgNT6e3dl+jXvUfxNNYX+cmTNqK73c8Ko8L/LE7E1anBM9JZa2UiQOogTlNc1u4JMw0iCvnDoUdutmmpya3bTks+O8l27Ow0Bze6mKnE5H3bkUePI7jZ6k7Ze7rDR0d3a/xLxRw+mwTv+tjRInwMWLD73c0oyMxuaMTVi4DA4yfImnt+Dr2kRV847eVeCqh70LGDji/fxpwn2FZzwK2kJuXWRtUgKXjhsgh9+khSSK47S2fwT27JwgREPwLMhK7Zw66EtIJUyOJ0ltEheMDPyClJRfltxziMFDLXA623I1AQwDeVR9ZGUyXgwBYNqLclHNUsYjJZIN8kKvfiC15pmy1TjFgjmcy2QzJyAeW6MveYnV5fjYFmmNdQf+U0nO3yiQI3Dxm0Mm6bdAXTPGuZBhTwL+w2Y6SePZWEyENU37qQzonVh+hC8sOwGxvBfkbWstHRqWp995VwpJ1F8EBKiQmeWXm/62w+SPLcMgW028Tp6ZfWAHXpZKrc1jskTjKCfODlBj9WDwoSw1X0P62O+8vjV6XTJV+VKOZ61Jt5/2QLUCkRJsBMx6r0Rn8th7ZOikpvki7v7GP8BIviSTIfJfut9VLGFr9OLrUYkX6eEzY09/MkBRNc2yjzeE2pazj8x/XuUVsWXGx27TfH3f1reaSkL1njQre1KNOxTC0v/Uc84G7PbLbA+dfI7/eosbPf8gjX8Ze9ND8t5UBQKpWQnMOWZCA0WuRHnp2jlN3l4Vgv0WzqqK2E0N4FPvf5w8mjuj5ZjBUxJaTmcTN3eVQoUaWe09v3+JHPqxq7eq5MvLBN+aPHqyaNsN5lfV9s5pSFJ5Dw4vDJa1pYcZG+IiH2RVlDYjLAmLoqoI9oCMaWrrARFQcE705XP6sre5EOIEpiWco/8x1EtD8BY05pKRw3Bf3eYyp03UA11IHdX45MaRpwGnCYSfRs0wdDarTvpV1pdXP9oJeZrVua030MbHjXh3yE6+PSurAagOeqgl10KGg8mqdIYcbhjKhGfqq6UCESSqU2y6L5TMFg5zJJjZiTjbQA0wGU9LM+mkKgIpNXZFf6wHmakLvxV5VMs9vTSD24QfbGBIXjKfaOflSWq0z+MqivJPhoW1eXWvxyJWk7rYSmb7hrG419CpkvJ4zo7GGIGQEDq4I1X1pW1tI6YyDHRUQAe5+EvO+E/J8enPIBh+jxjnJoRDn+2ySjMaUe9356g6fUVs90VoafyjZII7EIc7BNvVfXd1HQJdQLLJiL8lHALZ5oCom2bDNYl9WO16kfYxVz7t1NJSnI6bW3LTOfICvj0/hZ0orWm5W6+ROLsfrTOWQWtfTBUB3h6I86R/3Y2XdZku4Uvwl/QcR7FoX9cFUU6ipHwi71SEY0lK3qAMIbjd00+USuc2X+YU57lnO0/ZloF4HbJqLxkQbqDifXp6P8/oJ4w4wLg5JPIQdhN4kNVqXW/311JlshVuNU6KSEy7QRtN9Bq4Z7yHow+4IQ1cw21lfmbBXYrNBlHzj0XQd5vqXNXsenbEN0UYYtjeD4CVnavjXJLDcZnLlug1EVAYqGgEE0Z3rH2qNTh9PyJX4qxI8nGDlBkjmAEejFI6pSxWn60gVOZ6MSh/OqR4n3JTksSJXNFNymTElHNuMe5mgM0DLbbDBnIyggcBqq7e4tiP4f0T23s6yama90VYlTPvIYtnnCHPoRtY5rTSAX1jdCucMuYhP0SPWPicTxhvyT6p0bwhT6H1lHYBe5Ht8pzK9vTNbpMBQN1z0qvx+wAZ/2Z527F3oBX/cpFWNiON1Em8TRo5weGBn3SUDnG5Gax60Jg7c6f4W2PuTyAVyWMtOe+UZbzmkKmnYUG1/b9cyyaJcBDnxmHRaTGl3fBfOnX2Pt43hwoDNQBVToJifufQ4Wybot5cGoHP16wZyiQHN6wwVliqpNrdkMPAwIPXLF3r/xHWKsJKusPCUq2D38dz2tzYcv90vIYDiIfBRT310zRaWqB34ODnkYPQLx/oUc2ZanMjEEN8JXEu1bUQnh+w9s0ZqLugzexOKuHveEVWK1DU6FqbE1aMAABvkU3ZHzUWe+ksEmXWbco8ZCwxy3Mtm1W9WpZ5NiPS1SlPHAlt0hWLpCrHpnKMaJmNk9kRrCS/kolvdljK1SHHQ6+8wfe3Tpdkh9F63LPAIYFjly3WWlYi5CWICMFxoP6qQHSbX07bU2/rCfOVenl8P+AaRCh48+eJNsoW9ks5GgaU21tQF8D2WKJTQH3CJL6Tpv7fH9QLARzUhUMU5PltuwWkiCZMKkhitqfIvf9MXNyuevT9KVv7EvSa/dJ+OUQ0QnnN7kC8D9EnvBqn9AuW8OtzA4q85jo/Amt8ZC7oGfGXolnBuVaCzZXGRohEGzm1zsLqiqF9jby7Seosu4XpJLB/GrIld+UxthYw2nPFOAtSigj74DITd3YS9veDVRGLuPC8J7k1SokN7zYEbeEqUAv6QP2NtZfzh+HArd/QvLs3co8u8uP9iFOCRrGZry1LF8ghzor+OVOIk0LJfhZ073nwD6I1jpBbWseEI2OrziMv/qDhHQOFtF9NoVDGdMv/6ogINkK0t0Nl7oQr9sPGOoeMiqMPj2XT9YH7Y47OJjE4tZJ6Cc8gMGxx2Xhg5lgYX+Vnu0xtZFSdb9ShY+kFj/hSsX646kK2Zk2qzjViYZvjKnno39MAxYo7WhdFiQ4zHhFgMhtgn2j1glRkQW9zvoCzO9bl2xmaiNDmo5VNS6+0j15Khy+pMb3QqqMwOk/+g2nN1GXGsrIiVdTcpUkL1czsu8aAaxdodbZghWF5ymUGOK/Wfh2kZ5XKYpY2gvJfrMMAAao2Jr9pi4HGpAPJ/NhAEyV/7rp2QxLGfE4s8XQWDlVKmbP3yZMF6xB9y+bbZkdEMX5yQzDxeFuMGL10S38KqFMmvwqQXjzdKAP/5iMsqf2BgEWNFT6PA1vLX0J4udZC9dP394uj9j1sCboAAKyHPHHnpPXgOtpusPHDN840WU5iu19nrH+RznDrEmgCVMEHLrZUZY86xWnkeDsx8d/0iHTB6PW8FYGDO496ol4kFL6g2K2TnjHStVi0iIz38I8wXcT8JtwX9fw8B6FyyXNlUJRZ0ZE4jG6N4f5BJUWsyWA5KT2FQQ7mYG0Nfd0VbW9kuo4Fyxj2/dFPi8b0nHoxyrFnR3xOXcm9ClPFJlzb47W1VPe2gK6q4zt9nNaaXpuK+univZOSV4C9kx8vx4Nb495CYAfknvWCjSH7XSKrGilQoR//UglCobJPW5SSB1vjFc4l6ilJo1WfG364BA4zKruChKkYflA30/dMS1V57Ynj0SBZbbNgxITRLiEXl2nv3tZ0U6hX4QWwrV2E+rRttXPvQFoQ+VBtwsbdHxUgx8x4nL3Z2fCfBJMQtTr2HbJ7BU8U2zyFIetdoWlo4yidugEID1TnuQVhtrgls+eK8POvpahVHspDL7pTTN4fzh+k67zykb5Gmm3W8mXe+YZ3Wg9IBQjGzSBYm6HLSz7CWjB7pV7ctPu6w/4S3H5edAOhiut/uleNjoxHINEhxcfS3Ufa9b83B+9diJ48R4vUdPNymDxyTLWH7VZwU/714ISVKQQkNZ5Q3Q0EF2BvF3uEWssKU/DmjJ+pcvx709pEbX147bgYIhXfd0MmBzyVix6OwrBDurUJC6wWIQU3AZYPwQCdxCHRRMRvQgtAQh1/pbyaHp470FrbSpYf4fVn6mN0hvuHholHpH09KQzXOf5pCMQ0gE1Tl0ktMlxOxhW8MvlUjIepybpA+seaoQ3q5EOtUpZZX0qd1ukHyFq9L92JH7FpQPINs9ZHUTzFnBD85YUPheVrWVByaPTs449vEOgewWMYbOJA4utKI1fS8vPCJ43A//V7c7iY7IDdoIq7Hf13Z8jRBa7n9mckeda9x4x+/v7F51p60s3+y5vD3/vpqBK3wEKToUZCFJQev1K2mSP9FJvUqIuB4gKK/W5FE2SJWdVg2spmmnU9gVr2Hq7/S5Ht6K6HRa8s8AqHrvctC4IOh6fz83d9H1Yw2TliejkSrcPKF+il5nIdsDU+MoZM7wOBs4ZWGvfxgFog8itBPC4XzlCmZ4rSKotw+7Hx76/6KWHN0eW8wBmJSg+Cuex4AoY8R/cPWIoNPLf2m1R+Wy8XOWCqjcRBQlWYrtRiCOpb5d7KthrCsd3w3CFTc1yQUIEDrBxgGDotH6Cc9Daio/mU1Y3YM7WTfgrkXmE9y45CQXu8pre9j+o/C8S2njGfb8dep1tA23EeiRMhmvOZUVpe1+Btq3RrW1GeqSZPEbH4drxO0R4j/e3Mq3g5HtyjlMpUU9AAZYn5Wa79lCeqAk5ARpkbteQmZqnL7MDPVoNWfF+1P5jLrIpc6EsN1LZ/azrZeWw2dwULewD3R8XxPVCNVyIyPURRrwFxhKz+lFbmrHc2W12MOHYJ+boK7MUtjgJQJIxxW6oaKbXnLk6rVxIdcxrWclthyF7N6IV0/y9s5h1ZN38yDt+PTN0AAAGYxizflY6wnUlpKm28JgClEXwb1sMNqkbjd0kCWZiaFuD/7BZDjb5wcAgE+iRwL1NWfKn85+bbkM/io/+78xkxcDFrZTsywDlpHHIxlaKvoSIYtGxzhLf5KAfmDrZoUaMOd2J3128wWHYFPDM2bv0O5qvkPks3XJqJqCmHne/7Hx4Rap9FIOq+gjo0xGAFg2uQGE0CDvNat43+FhBtB2YSrblTYm1WmrAfMiRjvwlUY41XhaiGTWRJhtCjIC4N3Zj0TF0XGdfYGcGMlQjdi9Z04oaMce/KG1xiEUlcDft8zBjC9ZWh+uXNSystpddWG34OCQygH6q8ZgnGa0I3jMUIdsB8OL9WNzmZLOG+D0cp1mV5qP6DW6whwj7zSiV17jpQCVNz9UcB+uTNPqgCsUD8ktMRLOYQtvzSLTRICOGWwF/QyUMuJRI8rVn/5NtcV7HEsIk5EdDJyDkIJkJ37hSDXY4JtHxy8YGFMgxhv/PTEf/BDzzImHoE7yBTGWLaDfsstoFPiBJZEGJ7uevfQaRiM5T4xWsxUSOMewagRKRoqyQWnEY1dXxrImaIL1/paO9rprLEbDXgiGiHx9a0s7yzMYqTFxl8CxUzkK/I4GTgC+bFrFgm2DI11ykVPCRnX+I0ZwHeQlGa6nH2WVr8P/eUYNB+MjD6A7KVwhE5mzjRsITsGcQIly9zaY3X+M6YHbU/U5/ojdtx/RQUiUAzGBRfw0mTPFe8x3QqBGkWVzoIYi10A0N2WEpgYpiEmuJbkwCOl+yfCuuTv6ObgCAYBN9iW3mJ+2dja1v6bZiVncaKXW04Nk+fj+isEvA3g2ZjA7PHt8RYGyPcA/nSHReQvDW0uX7UwlGggE0Z5d4P1GmJHQQPTeyn2vuYQr+uayDE4kPFHiIhq7SP3FTJa/djMru8fLO6i+fgTTsR57Q6cGMyLVNUGxFOjcxZWonMel4gjHSkDE6KApITwmK5VHZkBpe4ijC+ld0firM172XJNQxvr0sNxLACi7cj9R0j0dyEXKwdIBtgttHQzeLHFuOasW+hZG3cxRvUWuMx+Jfntzk0cx6SO5gn0VeB7RKqhPbmonlQeqsoKgLeh5zmVGlyULvVSRUOLxH7DYt2KzUKMIWGSPvhgjDbV7JBgKXxmXZEpzt9bA8/e3vv/x8xAEzNniuggiFb6cZT5gIpNqsvkDRAoK6vCGOqaaWzN19Evuw6nuCSlqEB5YNMYzzwfKvima2dQeJZPAQ0oPWD13PY6s1jyrY7JXAf3dzYAUmAYG/pb6vJrhu+jeEPt6Dp+iR8CRYb4U6QuxkiyE6Uam3bYbbRj+CMU7a28xM9dYSlEzjDpaEGu5wkVmOOHELhNIuIS40l1JCqf2uR77oDA6xnggd0vskb0qfuSycjgmPnhDVCwgkxkGN1ENUTUU1rbn/bAfhGvOdINDdtlBwzx+WDZzIsMMAiRjCwaBdeCbJxJ88XVggkIUUwUwzX298m60AkyrqnHu/sib9W100hHcqHIw3yzgChv7WZcKn96qkXpHJuFQdsAgu262IWOspfpAUxNohs/qIQ1oF5S7A+syhTq3IjEZHOIdfyo/EluZFjLPF2adi5SK1AogVMZYZssTEontv/i9iSUI/7ZpGMqGeAm6GpemPfkuNPf52n0w0DXkY+tWharvPL4AsVk7kt+Q9WGAI01hrcoBqhQwdNBjjFDjUrF0KzfDyIqm2XAJgiRIMyBD01Ffy1QAhhuluPYvu7VZcvQ8wsG0KVGWXGYet9Yut71Ho3EVFJap4bs38LbFb6mnCUv/OBEnKmyPhm4jZu0zLS5F0mkmvBJRG6jObuep7njDShCwgTe0AlBBJK95d7X3rpEaFcpe+bI7PtUt/Gj6OeXPLczO1oILBIe/9LQgXt8sZ1lNwGjmXCKzKyIx4QMRBNgUkLAhVdbJWH6QtWynGuFZekNnH3kr8U0xnTpZ0Jmxv/Rmw5vCD7G54WlBdlJqNsdeXnbUd3RxTFuB1h1f3/bvx4woDX7BDtKeWV9VLCpY9phOU6ucwke8jO91XzyFij3rzCNTLkGhbgy3+FzqV7Rmfn6WxFYfmVHKPwDkOOAsPNr7FH2V0HkqFVzmhyiqpyONGm0k8qJVS3KEmJDtoMOcQ/PPyxMqeVEfcVmxq09W0BcbxEYU+4OpP2uXGvvi+RRyLK5A0IQymQrKtpBOdQmn0toXMsaVUPh2jVG+kkn0r/1cdbAWCdWVZgjAA9UGCm7dOgRT9HRw4d0eRo/3O689Ld9pdXEbobq2iRSip46LCu6TWfdqk5Jrg+0XUCiMT5bOyLW8bmfy4+gj6/SJ2KOAsEEL/uZBDm+YkkL8+f8ZI8ZzPptpyC0Sa479TThTnCk1USq86iYA/AVU8vmGf7nFoYQ0UZ9n3ivAowGxH5SMYl1uXZn1qYwTcOVxc+G+IfhQjZ2g0RrXqk5h24k/blZhn9VHAxfI4QOlLvumPZPHi9nOMgfZdjYPc/gOwI0xSL3B8uvhbsAAhF6QqhXyFDSBqkFZK5j7vqHA93fLlQFnGKPWmttDF4pi2bziZW0/L+rhggAT0N9Eu1tOl5Ni84Z44FK6ofO2xmi9kFLfPGvmB8eZ6w70kjkckqz3zhWRczE16d+O9tWmgVu7FZQ+RgMs2wrSN42uN0pwXQA1z+TI4DkseuO+1LBfiC5Gtawq3E44s1xiBJsGslBcgnOf3W2u440YUO2WHXD6ykYX0JxwYePvx8tTvkYZ9atUpe1oSnmZEFpIKKQ8VzgZWF7emt2icYdUAiW+18YDnvSQbczXz0nxOaptGvy6OUidprnzqD/79yMuPuq65fIFrEAQCunTfsLepyEuWGDrvi+pDxwWdkhjRK/KnEmqhRZLrRZqT6tzcmU8Qe2p1iVl4cVMzmfXQ03/2uC+pTCnUaXXDkn0NwXWN15YKdhrPEvIFfQSGKoogIXAzNvzbn7CfZafDDUkgkEYY57oZtX8RD+aYZjM7TjFm2vrH1BKz72KNU+Ejki9+kH703GHFlxIEJ0pZfsw1Ibh1cTZETu9Fd52mrM6Q8FdsgT/0yFkIlCdsWGb5DloUhNczWPlge7fdb8Ur5YN6UiiHiFr/OAXIpyhwVxvPLqI3lao3KElc0bblvzT+ydEyyH7AuP/nfYtrdzhYfU4vVFAtloActY1lmiehdMLqYbldHu3KDe7UDfXl+MIWgRXPTri0jY9c3Uua/vRMMLAebQDn+zO6V4VVPmfd4f2Beo5RsW+zIt9b5j/FgLYcTym1FyNbEUkwzRL/j90nWLe+/i1tfV5zowfAi8ehyumPRmM/KA0LE2PPtr+CkUKh67qgU3oVA1L47tpV6EHUo5Tppnd2PbTGrjTd6xuY2JFa9kjNhRbJYfDVTNUGBqYqTixQZgeTLur23ekx8ZBQOgmXaWOjNBZsABpJCpF4FwHkTubpzvBlxhyZCQ80CnkRxtS4LiPxPywtnaib8acwTonHqUCGSm4qgrfejKVkmfVuj/rsjDgIzMefFgRJ6Wm8RocPXg8b0Ew7CIdhkEwapPwe90kEGdUtYu82pN/zh9OejN6SrYQfnCf1r1yOcRIXdcJ7Sl/rl0B9UUBu57gigHgF0U8yhn7vrWZjZ9ke7mDJE+MaYNcoU7SkAgnJQZTY6+ySAqYNDx1Se6hxHPEe0Z1e6akqKEdYLzQERUnHsEuhHLv0XmmR1ioY7dOZCQu09VIl64+QLJpcAAABf/npbiJapxllR5yy7dcpF9ZF5W7njRu1Ggiq4asL+xqWhdwNXrfOTpcFgOfucjFZyQnoXQ5gTwSzwMQIq8qhxB7plwxxfxDVCCS1fBf2JfW6FnwcQACTqYeQZl6EyDfeA+GUslTgrKp3dd23et4g7uqjHQDT99uD5wA3ixlYH4dswlrElWOl6kvsnmtibh4C1Zd4TmSZQTEtxX4aTST+ihhkEsdgnRvZM11KHprS5SWjZKOOwsqAENYkGn1jVx76NteVgRJCs+xSpDs2cFd3g9s18MlrCOwsBlqNOo8fdyH75HIKNkez5L/Cf0jh6IASoDbdaDp6FZmatBs73dvAYV7qjrUee80wW7A9o0RusFCMQDc8Q7GSPbamYWJOzk+ENzefctW5t9oPEWsoj4vrqU2Y0XBMsHMFW1E3fRLhpiuMXJ8VDckjfCpEbh7jj3Wdr4zcTBdKDMBFI379InFxgEFxIwJ6xaDPgC+fkcrlSn7P/U3EcbdJhQLBL37nI0BX5wQ95pDhWYiOSHK+XlgXEs9iBXAJ5FcrwMcLxZ8cANTx2cjxg19x0VO72sz9yOCAil6e+CxgbbLs6NBrXwPGCDk77ToumHlLrqUWIPu9uQ+0RWFZIQOzjNRUZQrl9CciGa+Bmv+X1Mpkn8Viki/yz69JXh5ObW5Z3JE8o9Vp4x/HG7+7eHd5DsgU/FFqay109JQwHiNysr+sBQCRL16WUfp+ncqsfixppc+bw+3Mknk/Opz74TLIP+TFdiLmFfpi5SSbkg8cr9fsYRk0asVI7udVQ74U6OI/Wfy1VcZHWQ6MuNmZnV5eIUW8B9uuintOIlEy20tQGG1K2kRKdSSj9KxNnu8YmiLHTZfAOczdrjg+SnILAw2Di9P1VMG5zenHDBptCPRxI/0a4pzAmAb49Tu4q/bD2Rhyx9SD0bn8KmhUSVG/vmVkOMONNbQjeOgFG6N3fYOrggKkGYMOE3L61oKSTR5X5yAk/ncvtxfBag+yQCjdB5hmPzHBR4AjSlbBi8r7hyI5xIXkS0MxnpA1a1TnVCEZ41ok6uJ/X8GWpYJlKx4ejQALmsI3G9VxZqI74m5l2rnB7p3Kajcb7ndMCRxQOe8JNc/l+UIOoDrbzSA0RF0z8Znp8l03FSvr9Dnd5U/1msyrqGidw4eY1d6IHIb3GUlac+tRasSXP3pw10AcjPWHbW6acNzZ/DTiFRZVpihOQQrHrVQ425BVOYt2ex7ftbiOvn+xx4BSQxeU8V1wooTkO9WSr7XKjVrtFNKiC6tDb78+/0QAAUSXED4iVKHn18Zm1VJb8bScEHdGnKWvU6FCTFl6dpoeiX5yG4+sQ/rkB4N8soaq1VDVz+apKtkOlJQotw+Kzt/GxkdbtKJTz7fpkbh7Ivmghc3EcDV2lIVS2kyB5M06DSossR4rjVbG7Ubg5hCeZpx6xw3RqAS3VVcNCf8CiGnpCh9V+hIhJbf3ev4ieAnCknboW+yCTgXMQU/eOGT5BQsKlUf8Z5vLJk3xU7PGnNqJd9oDA3qemIfPYz/QdA5XwwqM6eIVjBFq60KIE5WNutCcmCGrh7GDE7pV/HshV6nTdQ5Zs5YPObLsyVOw3wJBfCE9G2ptmcFqqkCjuG5RTMH8i4XNIyX40wUl6yQffHKYb13SE9magILJVVm2qyv2G8MBFrXWkoE0JcpuWK6XxIhGagY+cCmTiIMXAc0fr7jhK4BCO9QLklsJ68AeyBbSbLiuyQBVTDl1jMiYxnOSkZQfu2ggFKOyTZC+T2OIS9VVExWRJIKph4AOgGjAS0jsXk9stZp8sc9WRIMbChvQMGCyh2Hw/XretIhOo53fvfJ8OFuAl6fqiPX11rZ95GuKhMommKN2rwShYIbKlwI/tuCnStThqPkaJhvA88a0sirjWcvgBaabdBXolDRTcC14aHrovNXkgpNbjyFj2AwzRIzU8GMkbENzZBNAsdnH3JNHZ8luLp6kTuZUyQiy2JDPUHJdfti1/t7cqV3Apo/eIhMzCWXF47pSd/shbapqdaK2VLOKymfvym/AGU0FtAiYcZ+/R2R0P2D42+E65Q/1DBCkyKvHmH5hAkBLFVwfFAbZ+2wBYPZCytgzQVfJsmPLoToDBofYpRxIVMiYbo7mg07iw3rCHKzqu8Zpf0xk0OxNgouNVDguYMsLMvASp5T2yJJY4DLG9u/NGJNj1mbqp0T7mQg93hbC1OnuSMCpPA7ob5D+5rnSZddjohAMPpUUmxvvGq9viOdYkhT2gm1sC9xLUJ5I1Na09U1DYbPKBDexwjrAoNAcGA7WV4tHsushD15V0xUN/BvwA0T8DE+4TPso/NJA4+Yz6HEUya1HyUuZSybh9wGzZQv1aImiyaSA3RwSo4Ld9i5Xa3rxeLZYSZQcI4ci8YkFKSP96PiogJrqdl+q4xL+o2hyl2CPuYUFywBwt0ugFeN/VRtQldfqHH/LWTojHBJO8JpUZKfTncF5w60i2Td/2xt9+/8vU9GIYOvOBmijriZA/Cziq2e2f/yRMc+qt8eXOHpi1fSRWj0jl8MAiAAPXaKNAAnEyvewIDprurxg6gDXEjLr96yTCEsCr9cGyvLSVLC7ixJaxc6WAjJD+ndzQpdoBI2sKqIeOc7yoyDQDKIsuX8nNCSvmqmn2aNM8qiTPmM7J2qujmW9P9G6iTdEKW9fGDXjG1bCyCtN8pwe4EzfgcxfS5XrypvqaXRel2sjsXz0Zu72hT/X2EyePR65hG3hG4iDzuYz6oZmTZMFZyRBczSRxqQb5jLqmupGSHjV3IXC13RFC6z2q0aL0NxFZMS0a+eQDF9JpBmMjYgdCakaxR1occEI5hAOZQPZXJuCtgDk5lSundNlPB3bRXbBVCcA9KyUhGIpZ2uPWHfLB940YCoYP/YNIcVEsdnoFJ5iL4/t6hRSH/UQUWVG//nSANs3UBvCpONzJZ8Ql6gtaCjjiTICpLYeZ3/AmRt6jK5meYc6+Fl398Vk/Ik2SDWy8zP/6HTep8hmQmmhv3nTyANt/DT1w6sQt222jQ8+5l20pmV274bPg9mV/j3E7coE43X+gqUUd3O6biVI3R5dcvwcE7a485SpnQiwpucNeam8ZDa1G0yNq+z1T8dMN8Y3TCayuFtbo3faorzDA0j7j6Rhn9VaQd6rIYPP8g62weNACyn+NZ7VnLUMIvBKKHPxBhT3cqBZ/CxoBUQ59ZHIr9fDmPbJQ1GGw0D8Z6fifLGJYy+RYGsnYrDlrrARbosgPPTZcGeSe+fYS0bPoLvbwEeJ85tpfoW1Cif9z82BG1/LPzjjzbCF7xWFIW4h5MNUFzpAHHOjGP1hZNUXEzPemtVvGCQnJhlgPj/qA/WnbgyhqMx7Eegmguwu9mbtN906keGabsoyfVV0FKWdq0TWAmkqBoaNyKkFjhFrBqP7sAIKFteboJi2AE65dF481smc5PeWKPoOavj0ZW2emfJiC5ue0krDLT96t7CLN7iM2YI/dtC+wsvI2aweWm3zPgJVWBYKDmF4rhv2NlwBUEQPnNEhJnYaz6ge9RE/5/GAM0ezz1MqfQnllRIaBrn+PFvMwEojPi/aVUeJHpUlu1EIR0NhSh/oht1mNNhBYGoeH6P+FXT/WpOWz978QhgRYnCnuQXwpMABYVBlIYIxw+3qt70Abk5HNxvOABjsTABd2pNNOJze5l51sZEWff2nEU9TqQbl6S/l1FCG3dW+DtAk5e0aqqnRtt6TfCCj2MWJshcC8/zK4I98wJ+ROO+l5meladpfZ8dqWejd0O2cjOh0VU9ZyLUf4jrPKeynogXnRdnxdim+KpeCSEXVtSDK5i036zQlCgHq9Z52HHDexbmewJE7B69br3Nkfy1fMKyCtqQDKQExoXMQMdQizdq5mk4GTZicBQs4ORozSzXYUdYxVCZCw13FsS8H69Gd95VPPl14vyHskukjas0fwMin3LFy5iDrXm1dL/c6qZPi+cKXpq3YLSuBXFOLNGOVaZUH51kU5/MDv6bU3fovR6eMijmXssHHrNdmOcU9LVCzRo/Z3dcGNEAaNJTwYo0yxDVjMVmhzSKZYbfvAXfcPR6W9QO/9p+GA6w7biBM2IBu4Cy+o1EUXHJzB4pfg8bkLpqTsRJKXgshcyZRgDkgYf9CRsDJG9Cd/2BNPGmwYBwo1o544FJ1rp0nDKY2+I9bCsnN56X+F+0EvQAS57pN5XNVh3tw0RN3iKzDwAnfCjv0N2NGHWCzWDEKtuk08pDV0X+E9npxPWbex+wMFViXN5GD7sh77vKUbSaEAEJtzhh5SASS15l1rkVEzwAH23eVctRCWEoGyG63cN8ctns0mOLMkt4SyYPbP9s7xgd/h1Qz2nM+AeOQtXpGxVdxy5u3CjvMZtrUPxgUzi5omW8zmVzla6wK4T1j3/ONUm2Sp8ITyf7+HpgD/VRtL/jwpcszbfcH6icsX6oASvn5V4qfKHpiDYqa7tenVmomgmIPu8bb/c3keHCRb/wqMG2+HN0MkQhpmqtGqouGR/wzHI7NL0JMxSlwAy32xmRaHS75hUKm2XyCZKxGk7h4/8apE6etJYyvlGLlOc0pZ9bYc5pRwz4tGLgHyEVkwE5NDdvgMEJJU3ApBV55P43QEnwTV7ALsl5wBUHoFds7r3EELK2Gr8ZjU4aVSg56KTMErk1NKi/EQVgKz+ULU7gq5dd2PzdPeKpUdL4kTXBf3tt5krsb2ennhVJpz9hlqJiRUtdwOkJnK4PqHuy8xGjUYidBMjqo8ry9TK7FUookHWXZpae+ctWZrh6AWMfevdBfrsgR/u9Ix0ms+OfLIH6TE3/mv8S7xbHkcCTaGOUltx/UZ6E6udf5gvSLULf725x0yrHERgK07FCNWhSO0Mu/TkKXiq2+h3uKJ8BZzQkdqCZQM3GlJP4yuQBY5VcubGVmgvycpgdY+bqs/CdmlV97eTui3lOjxlo0YHv3DtqoWrGNqgFZSGe86TDtN/oGT0bHphBjOYcvh8sERp7N1RB6iSzS7SOdOeDfrXk3ov13NnwWGNhyNzUiM6uO5wyefzHMzHlbIoe+WbAJgEhTnLhMW+il4jZZzsaDxSp8hSIRfH3Hz+ls3tolUlnIlBBwBCEmLS/0Sm6N0pGb7QHIS0tyZo+dOJ8BhS6fIo6xXPKuk2JGYoASPDvApnwIyPDs+DyZtxtkBBuWwJCo9NTPwsdPhU/G8OAs5HpIDLRu8dLOgmdc4Xlv40iDQbY0nQx1PUTMLdhd91eYP4j+HqEjstEdcZG86ufHFWN3GcEqF7gAv6AJHVFpijrkr9sIUeh9/nQkDrbyacsbPzwZafETX6NJZUgodBuj6zzKr8oFn4V4cosrqF0x8fkP7atGZeJHCFOBmyR/XJ0Yo8WkFOKO9EjkjOf/L6SI5WwVIZASKVdMKgS9ltKTtLlL/Q/9Vh1QqyGuu74ilYZqXeOrgY1aRpwrVJA5kDNhL7QBXF2CMgwVK8xCzcKnWvh0BXFzkMqEQgTVTjr7Q4JATXgLKAQvOaJyVPQzUPlqXTFChLX2bMknYJ7m4RH6HvDZ/DckGLQn8yQRakbUzM8Pt1Fp9Hs3Z1hB7z4WDJvp5wHV19T7i1EXm1sc5ji39r3l+2a4NM+B1Bx35iMjUkcnbIsfo7lgN1lPEb1IZvk7U1bV/r9Ns1vfxlha0D+cnujT8NUIdfJWsY/fYN8xQA1XqYoB8VHJX1+PDDeBOINFAG14U+AEt2CtOh3bfsAS0eHht6adyD/wy1kQ099zk0uxt9u4eC5mHdFz3x/qKa97CFke5J1VAk9ys0fr3MimFjDDkXU4v8Gnc7m8CyV/If0bcUvypCf8WbtECA0y0Bgn48D9VZWPxrOx+z8npsfCfXL64HA2xOtEQD7335FJkaWTWOEeNi8nuDLO8llTm5cfcG4m3ywO/fXzDP+L3B4NQibZR0niQYPD/TztvoUY61aktqvHoUfJkq9hr7pfZleegg3StStQ/vF6SNOo9pHIEqxl7J2Em5DELhByqbGIWJd0WuaY7PrPhEDMv7et1MQfIg+J0kTqSsz9sS4zdkqu9CmqZLwvC1IaXixrQ5w8u8JJZUNk6oc8q6XmBZRNB2TjAkiRqk4+TXRHCLyMHz3X1t8Mm1oDPT6HChWy14U18zPZCqRVhs8SlFoyIxxc/Nu6HCcih2W0g0DYSLLQfrjO/hHRxrGpDZJ1E9K6h1PIt7yk4gbUvSIAlqDCMMms7dj4L1QtYZ9vdl8NqMCrIHANKAlM036mV/5SzzIA8B7VsfJe5WRaEqFnRFcG1wESIuhh8NTJDBtTKkO/mJDad3aRWFXmIq1AvmTp4rUsx3NWDgcj5SiyoCXtDUnZSKA0ZXTlJJJoSBggkbLjlZJc6Njhpfx/zWFtMdR48XB8rw/G+JeaT7n9GcUxLHR3W5+QtaXpG6+iiUFPYQJOrAIbSej/OQCm97+dSGU/CNnDlYA0QZKas32e/B490VUR8UtPrgtaYaBijmGMNekb+cL2Ixbvc4v+Gbw4uRQITd0sC/19v5hIZw+P5T00rRQwlUMHEXpljSsd7Y9ZxupsGDU2v8Yf2lLnzLBCBdZ+JsU2XzyPuSc4FrIfXW44GiaUDn6yc/6edJnjdsh0I/R4gD04KDsI9tn7g1kANKSwpHN/vuh3/QqFWmPPoffqoAQU1Yje+z5mvktGiEvl/+B2fpsin1txfZhX2e5i4yZLJLWwkw4cawJEogAgU987fYmrsZPGRXcQ5QWIQAsoH0oSGFl2PMf01IZvxXZkPigvH2hhZNyx3XNgVB/kkll7CzguUQhsEwb/LM035wyrYTnbHfPYp0zo+T/gqwyvf2bAnOqghyYEXv9ZzU/ib73hCGlGdIr9JqaOncuv2uAlPibb7zApsV1KZQJt1JKzrWBBdZfMLiBRLVhxgbPQPvuItMk4qF2hbtt5LLRK3pn6/tC2v63+QY8UTNraELz0rVEFdPAiDcnPSQf66WdQnWXcOThUlE80pubD3CEmkGiNn99Ck90i1gEd5giSXtq2eFn2qFFnD7g3cwT+Q9t50uFfhYl0Yo0x2sU4ujmErSeEvbmW++NPMMAMs//++rpGTTo/codKoEaty0sTkQNp/S2e7I+yWbK6k9sHG3gKwMxi0PqYe2wrW/nYEirfD+8TgWRhsg5c7W4Uvxmj/i3H7yLWxEt9vEzX83z4t9VyrQZj+tRr3vAP7NNenrItiyzi6CE4EFdOWo+Xsq2eT0vd87o0wrowtW1zsgjeEin0icbEwcuBspxQ4elnuiLDJzQ4v6l+QaJymHOSWSkqoveNJTxD3GiAVyTNW9It0HhY9HLZCQ1UDNMrlnHcyxfnLU4/JpvwnjzBCNIJ/9UKgP0mj/gS4DIuORO5QTCorsvf5qSqa48N+je9WySmQCkovWMwIgyHdIGvbLWw14ibGMunMSnEIwcj452fEE2e/51EX6KokZ8WEV+jrfiz4SLLls960jgLswS66TdXJB5uZPspAGmTaCzEkQxaAjG3pdGH4Z00TQ0v/5D2EO8yqeixFiSgOuuw57JlTrHTac9kXdp9xuHDy7rDJlFcyvPK/tuLFM9B3Hr3DBlH+Qt2iEfr87z2aL8RgtWqwueRcDvbTYQsDgpEOJzd0/T85MZlhi271pj0dfS/NnWQvgqGQYK43A1dlw4t7el0E2oLrA/ywQwafYERC2Bx1M8cHaU9qnxP2IaOSFlpwCurJ3s3TQeiake3n4TBLlPI/yCV8TZ5eD1vmejgInVad1y/t/tkcP8wYvhTAR0PSQ2RcP4XWNNFvZqlXuG/DISkDCi4qSlWSupA7f2fiCzGUMGR4YzIIPnIbr0hnhKceVB2fRUfJZWXXfsDhQ6UWDaoayjcfDiRG60zHEbRspNl3pDAMrqoAozFyVeL1IAaxirCRioMv2utheGQDAGdq3UUNZrjPPrMxLVPKBSkRp/Zw23URHfLgBwKzkFHt/F27RE99FsFcfBjg+OpCvEfoia8Fvh0leBd2MVlkhRhZEq9+zcyZEZFgjnrjTl3S4aSqZgWRLbxci/+SvXqA5q+nBu5E/hCJoRHXwOMD6j2XxoIQbXmrqK+8xhy5xmP4rWGUAWdegjYvag9N9zjW+wW7oQu3oEg1uD7YkT/FTaNUkCpMxvQ2LiyB0MSR1esmvj3G13LefLwhIYyi3bIOKwMcliGnAkp1kbFt4yUY/uCPlLTjPAQsxDwi5wcfU41k0htJ8FTOsRMHBXRt5T0dGMDCc7ze284sijFcLQVdnmmoiyzDd6zMkV1nH2p2cpgywxL0PmITJgcnsGIWpYTPMIBGmd+H96flrer0HE5+IKmFJM9Rgw2JCEnGHE8ceu45wVjxibp8q6k4pFyUgEQJPWwtqL68Csn4sE4Ig+iB5v6sHpun+ulWh6ohiGGMiXHcNcXv01oB6YpD+dQKMABk7zI/OPXIKbPCG+dJpAPnjDkPlovn/1/Z1r3Xr5Naf8VN7n0VhGQevpwqe8SGPtr9IjUMOlJst198GCMIR8o2eMpgRt4lQm7b62W4QI1BQrh1eTSOS1M6037ZqxiaU96XrUs676ekSDaq5EI7/F3P2HK+/gfVMvoRfVFfhaUS3jVDdOjjonf6PSCj94ehVh0tAJUaUDC5wmzzqOBdARPY/76eAmTD1htYmEy/Nkv8SAboZ7PZisZXBqzTVo8cDAfcAm7b2fM51q3wC32ii+6Yye5WimTFd5nVOhB6xa/vnX7QrvZxQFMt6EH51aegrxxd4AfN66IVNUpdAB4e2N1/3RZqObrbSy897Op+BYbf2hdBEABRYFuvFf+3tfiI+iUDS9w6Z0aehs5kYEHr2Edd4sub3f6dGoh0hld66CM2DMH3OeU5XgwlIbGa51vaL7rv8ARHSzfVsAEagG90TShg9BpM8ei3A1uSEa+7JK4jXVtm4GKEjMhwVwVT7v/Fg3Llw34ms32S1DyDya+/fekv429J+hZsmyEItAAweI0R2/vL10MXMEP1EcUgE7cy5xhfySwC/AJV96wORJ3B27yBEBbOgLZI3H7UcFuU/TaEjAl5rHwig5BoduCaL6sY8Ui31pmXYW96p10ZMKOuAEE43XLMv7qKAOCO/vqEdOk9kHwZi+7FuOOxt1rsu9B2GMTx5G1z4NXD6Qgc78PgZQORsO9gMou7nAbG4MTdsJDBxeOma0q0snvNvIs/A1ef89hFUfTpXDWvIB8Hq9lFdTJz55rgVvgv+uzkQXGyt9gcNr2+bPxXQT4NyFDGYjSQpcyzzMnoaf+HxIZMqcdLXwv0UiuxfthktXzusIIDrgDkgfbuYKXsgC74VOTWbUMXughvswdEJt8Mhpwl6duWkM484sEm8mZZ1AwXJ2xqq9R2eKaV80SKoYjnWTJKDmIw8YMlfBNagmD5ybp/xGUobtE7eh1v+beQENt1CobDbeig11I3NKEg2Tp0LV5jievwNDp63cdqVS8FhgoY6rZktqHZtR0m0x0GULxCw3Mu+rrHkzF45sbO8dIFstHik3lv+l4uml53PG5KhE0qRYeKr0wzHwnnJvTnsPif/THxMlukF+MJ6zzx2vQpaqiLICkYjivCESNo8+8a+Q8KVlTecnhqT1pjBYzCTfuTzhaxw+byKt72C1RIRlM61HbBeIGiAkQ06Jkshuf0e9xjnvQT4N7exnWDFqaU2qq1b81Fg8Kw2iFpfJDrsW3MIY4U+ozajaJT2T/jPaWpgPxzW+wvDL9r5hYq36IDK8qOWXo7jpVKEt+TZbVhXDwtFi3d/bwHN6KNTZ+7IXjEt9bhunyDfqto4YKprGaIkeGgHm51hCZ4AQWc/R9CVUvFhbgxIhuA3qkgFBOzkTLZaMkHyytlq8/9b2uuoSYCuShpw1e+h3Z3tBpmk3FX3O+YoUQzFSFqCKfHiyIXs0roMUDD5jfE2Vo0rzMDofg0QCLc0NcAtU+inJ75q9QGmwyx6s16uJ+4oK2Hirthag2tbCG90XkvNm6el098ttq/F9q+lGegTmQJgGp38H73Qz6XUi7CybGfG+q3WoI5nra9imSmWuflc4LT637iRVVv4P00/09sNzbdXQHj7Z7z8skZnjKz/jPLnA/5JARb369fiD58PmyxaV/JrncGlJ/r5GRd7Gta8kBFNk1R05PjyWRzR8b86ZlPz8miDJJf7RBHBowLwKvxaeabxlY58z2PDdZyn4HsxNHglrtfANvv/GjV2+wbiGKfs20PIUwF2Pb7ceACG67ehUUPt68BzwY6AzkcqhLUlsQyq0SXrN8iUhXNPjOZu2yqrAhcXWBH7rVcqCypneD5k+RQKUhPNPR8fenXAcBqrsfFIURj9t7Ce6iTFNriRP6BmrSAx2qpfNK4Vogcnqyxn50Se4LmL/DkqGlQu9BsrEIaNcOHbqV5KNynJXvQugGnL+GXj5bdmBt/+qAQ3ITVavT3CbmxgNLUEPPNYg9cBFS52s3fyPfT6v0YxppCq0ea2BvSNkizVTQnwrSlbkbriwIZTwjLZG2o0/Y7EeCtzdPXUSx+QcBHZhyJRf4p5vq7kNb76LkNxAwCsMKI+RjJZepT/6cAZWSd+bV/8wYupTkRGye05YvlSyInivDDAB71faZuTP8Bj3uowDkfzhgW2Aify+h3J85F3uzpg60qASNCRO/tr0hyGS0TLvFfJqpJ28Yw5yxEyj79YVC3HdRwzsSgcEgtRP9dXoo9duaJPq4kCYpjp6ZmDRNqjjT+7MOMLJJG2P4jNHF/0OH/3fYOlJYPueleGCrbHRR0Ee6TxbCBwjtB0mevmfqXmgQd5vl5n23ael2pzZZM8Gnmf6O81Kq0iduYre4CQmwAgLKjU5owdiRjfRjigekdO1vBUlz40H8hKMgmbUJKtzAiEdeWCZw0qbgR7EWIXo/29SMwxfGqKUo8Amtk29VuAKsz3KEgynnQ6KVyX1OxNpQZRkruoWXdK8qeqhYOJYWPKOCC3Q1EpdvM7V7n3EK4JRXEm/fHrvtZGLxtYG3CZQn0kT3n77WiJRDBkR4CLTqWC4l1vOirBq+rDCgc1HpsLTizJtpg1ElO5kd7Zxk5tikZgllBWQo5JUqPqEI8JEJplUWSdm97sltOPdeYvT2Ul3Lh7MtNsXNdONJiUSmDi6CHVEFw9ao4dlPcwweAACIBN3gZZIswCf1Gr2A7cl+y3bQXBuSmEMYFt0tTs2W7IVDBrhDfqrMAsYEcABCo6kW26+17Z6fAjLGzFZKzhr+UZPlJGTBbJJHaUBInonC2uGFMDJ5xnYqupEnJti997HAxZMuvhtJUsL6YNfiwPavA+YrLvZmTNvCdC2riHHwobns1m6LunN+0Wjugp8rVahibECwNIpy3dr/KG742jwsdfj3tg00QJKkXEdbpx0rngruISFbM+Z/9eX+80vzWi5Bbajzg9/oYg0iAyJRYDvHEnxUnqqLQUjwT//LC+aY6I7wtQUbievwlU6b69xBNE07bMVuO7hrrxkBGdmH10HWh/GsndNZCiu0A3ofeFLh8f9BOvbb2yab++8B0FW2YSAPVPVx5r2AkAxpow6GCUVKu7nKFIOA4dC7NOQ3lHgK9g4zj7uaV7PGdAN+yK2SIMe8BTLDa7mxy2kyle/JL4WCYJ1AnuTXvjELkrurR323dLRGnydghHY+qtbiKqcsGnjAp5Q3PnHxFINYkTCpk+dTUYDPY/sT5JdVOphBrkfsNh7jZf329Gk6n4W/KvAkmf8x1MWRQDHpmw0z2vKsNvoRLD1GgMv8Ph+12h/H4eqN5YwpXpmupu1t0c5OJf22Rzle7SSQB7HTwGjQkQEJyo0lDzzxdU1IOk1Oxvn8PmEhLi++lDCiT/qjkT2+YCI7R55BsTq3UPiLcqud+/poyYY+Yz3UAoIasaez4l6lqAQFpuzdamXg2wQ4z4HUs7KqYJLcnjeLFOon2nRneEwuth5NjEzyEKm1MWJXK5k4MUHXHsCve2CdV8uvBNGN9ksOJgnHRJ2VhLqVn24sB+MEWtBuUIYyH5Ysvy1HIzdvWvhdw2h1D3TNedaBBJLPOGjXpicTv7c2UAj7/ihquEllv147alpe7yyzIyGKKrHYZTeJYL+YXZst9TTulGpSEH0Gq7eE5b2MUP0Jkhh5QsS+kc7ffJXk209jxOlop5HEVD98QM2I5/KGGvMN1qx7bRH73DjDD+POWNBO3nWVmhkEnTLXtO0//xmF3JkMdeKWOfYU8+8RS835aIvhEd6V1bsoe6AFHKIrqGIIh0nF0FqguHA/A9rCN9avMGYxXakXt0t+2dSW68gY0ebNcebtzdnN3DHdnxeGeXFUGHQTetzNf2UeKx3yR41SLszAVMk4cUeEAgmBrdsyrFnziTs6CgZnd4W03lV9az1fjZwDb9wqOPvWuReBxMivmQNVwc0qhdWhNUh2ONeL2Xm/1ssLbc530Ej6OggaTd1zW0zqnn/yO3QZwc/MsVOVOT6T2G+pCAkjdekMARMfC/QNZNnP7ZQaCf8Sii46G5mLaAaVbT4sO0QfEvBzSSFqgPi1DhPGJEJMaSWfjt34xK7bW6fZdJBnAGxuzLiVltjcT061Sl9gwY6nFQQ5VVG58OoCNsWvnWgT840EgfWyCkL3F4URuCk9Tgd5eBd/CNs52U3j6ty+YiOWfWUH3b/Up3/48fGx8eUYTSXqjiEl6tmx15a3GDTB36lxMMRIl9pZFgxbGfyP3Gt4Iua6JAIjclBeKjcqn521Xu7S1lpVHOlED5QU9wVEho67EXGbxvAh49+PbAD/XV16GgCpCwr+wUzkEXJgh+84Pfebeia96iKNjANUMChqwDGWqqTMGu2ArhEmDDVuRb51zhAw55/dC16nVWf0dPKdu1qvQqbYWo3oi9hOcehk6kPvd3fbXq9hDcyJ2zlsuVA5acM9LfgorUjIsoIbFu4eHa/Ah52+sMfBR9YZtSxVUpSLA5yIxeXmnlveqSAdawoH3Lv5OO95iHKH+EYdWXjZ4qIB1+zq7c4lKc2oHm6BalqKx8erLSxSSUTvYvaqv++7SwaopZXCpYGlEKsydJC8zDzuTtgHQoX0VmTM+wv4HNTWwubXVROzXVYwIZ2XUpvBm0lAbXfDWWQrVn1xYNFbrKqnBxb9cKQ0ysdTvqG8fXzry7RC7kPXkuW9xSY2zMJXKkvUfWEAM2DoIG9i3pyoHe98stZtJLhpMT+NyaFSkrcV85jm/IHmWDlJc38jFf+6D50XWTKpSMh5mr0eFdPJ44n9KSchsydyqEfjMrgSssAnnGXiLvg89jDx1cdBmifdvFGllla+y9Z8OdWw9JNyyh7PEYboq+d6eHg1oDjyEB5dUu8PQMUs/gfq9lii4Hq9zqbZ9MerFsb8sDbybh3o8P5irqy9Vvktc3eObh+neiGEf8vFox2Vw29BmkUEYZMy8brKa7Anndy/KzuXKY29WmtS8l9Dvzb0BDf03qyF7imgNtsoZP7++gARKxYNTkCu56+CZqkI+ZvAWPhMoRvqA3L4mb4RD6zAo/WoYwRNc1GG/hADIwLDpyzpIxBwKN0zguIJz1WDqVKh/zN8gKojHQd3xdS6V3/hu1Tn+wFl7Il6iuDw2eZeddEivI67ExWORVRL4bi1q4DbGtZd47W4hyCr4CrGXmVpcxgZ1ZTvSlFNb2aPK3m4ddI0jHiwowND/KgKtzLiPdL525Uh5iwEdsxM0P3szMwafeVbF6eTXhF1dTEkiDnKj1svD4ilgzvNMiuL0vZDw2NlM1Pm/qxtLm2Z9/Sr+3XMKhhu6DvE9fon8j2fMSe5aIKf5dvQakb/f/QVGC28uWK+25aHFLHuipfVbDYQSxCQ9bIB1KtBwR4vqBmvAGqB9CtDamWocmZqPDq4WTOIA3geGxoA37RtYOwI7e3ebxpcjP9V6X4891aufTiiTq5o+HpK//W5Ce9YZlZjNAoBXWvy1pc2eRpZg0VbIP7jZgOFOMAhRFpB8u7/1/cmbVMrATkAyUy6kHpyI4hF+tXXjChNzRViXffsBpl5/iZRdVGS3dNLx59ZI+b4H6Na8mzim2tLNnQHLvj/Lc6A9RLlK39L7HcBodj8Et17KqdfOS667BTOBTOXTTSBkca0zpYYYNgmT17H4zDUHxsmjDMZrgS6Kc8Athi5Q9sVPFWb3rL8PDJJSxRpOEIvMNW/5LQ4aQELFPk3/vtP5AOMgEAYkQ2ymmGSLVGR0JRKdVpGiGt6GV6pIhO9cyrK7BjxpASZhvZeBz2JI89BC+J98OwPyJ0pvhv3UzXGQXidph6pXczOUWxlRRjUee7Kma13mK2RiEY2jdNQc8a+Fz3C+5GAZX4vHF3C6irPq5AY8qKUUdkUeFWD7yvvjUwW1wz0dlLhlpOLWYIxOPmJAu6lzChnH57ag0yddZiKeRXG1TMpYp/6gMCp4xb5rp06h1NygEpAM4AuREPT6VEEpfT1oaOTS/1j5XWS4CxYXgKki48uGZ62xB18bq4PAGlDFPPNzYnClyTiWQQeFFq1QwbiaeFEnzUxiL8Euir12nzaJQ28v6zoGJCB52l2VC9E6oBiG6KX+Ur8x6MksOCkTV3kHOuY3gO5jZ9yAfqPzvov/V3XOVgc7OInNKP5J3H/a9c3Q9V4zEDFhZJTKttuWeJo2Vp+Mxdhh3FOIZK4AuARZmHXJXeMeMjAOgWmGl2uowV+6ncPwzoe6J+Cke3OD2SjbxyXhXvLGcYxfvKWsmo/uLtrCKrBIdbw6BcNr/mTaq50w6Or5o8LqQ/yy3PSRf6mUe9aQU2kkeJSMmb0N5BFc2GNiZXbIW/Tq2cS3VavKLx+bbhioFCUPzPBOdM5hGMBaEGuM35r366qPDooNxg8WQvPBnLuaGdDnVNp1sKekxIE4X5y1XfmyNDbccd8T+CmHL90l/8bViXTQ3BI/6W5U/T06o8GjmLZjysl4VHT3PtKwYuWDRAn6cSQB22Lqzuk6LUzUNYlTx1QV2+II9VRZmTZHJyFGNEjNo6LmMFj31bCi/RjDh5ijcK4SwMzgGqDYjcRbwR1rMPtN2Do0W9Hc18M3ZZ+dyILDrhoGDNHLHoBbM9QAd2oyG0Y7JjIFaE9SnEsAKwfQNA+WP5K3gQYYEK9Xuh50bF/qjKYw3SobwCIT5ggl0Uf22NJVPCYDyXrloplauteJDKUc2UmDJi6S5WxS+n1oCk1fyOaGyv/coafaq9D/bEKCOP/BaN2lrw/pLS8/7QPl0IryfkMnWrZQEHq3jQclthRkQjzu3syjK35F/2iBbiZIIiM9J/A/I2ycqTh+Tj+46ZpCEFdIjhX2BXK4QVhq4whUvYCjfi1Brf7tEUizTolsx8sJDZUWgiLzbybZobW5xmBUqb7gZiw7rXTL5tveWIbHUAvN8GTptfgANPZsk+4gpYXz5jXpjrMAuDaHbmEF3gfLgCJ931vB88il4WG3lXZnSvl7glYT3PWH0AdVg46oCkcpTa/l35AIfgtgFdvOAeS6t/iiSp7fLsqmj/KaMl+Wxge+lrxDyxMdlNWdq7gGvxFr2x+mgtkmad8AVrWNfBNsSiJ0juh7kTCSqLNFdDv5YAn2VuQJlr2OB09fgor4ZruzQXXNlgfNmwJli/9QO5hbKcxtPp0BFJ+eG7DLmcxeXbNmzIWZzc3OMg7l2DjkQHJnfS6DmaEODuxOkiEGH64pVQZh+YiUPSxTkcolHnghXHl5oSUMbq/g7pYa/sRlpoRgZykxFTsvyXbqM4NNW4tMMGG9DsUUhSS+t7sEH+9PQZEJRNbXIez7gT6ewGbP0f2GmhWyqdhilfwPzEH+eNXY0eAiOefHzIp6XALGYyEovCKz/IwKUbfxMcrE92etny1ITUww8cLMNJJys7Z77Hhx32NHpRa62P8ys2KgI1VzrQ5V7SWwj+NWAfIC9O0m5vW1J/zDY5bTYJX+Xy2Om6AihfDHikhr/l3L0I6uo8lHfJu15QrPptJ3Su/4Y6UmfXZ8jMmQk/WpbCEfsepM6XObeobu5Qx/Ooyn7/cYRBlyGJL9J24V9sPRZZAqYgnxeFSm0MaZ2dzZ0+PSrEjE3vb/gml5zNlVBIor2mrCgNiDTNKEZqEOHHNQnpH/LAY+UScCO/huXVc9oJE6bPRYII5Bjk9b/Ge6fYz8CevnMh4838Ve/n1QjZZ18RBnnwxN87hL6uYDZ/nyFE0E9kAflMLZIY2vvu+1MXyVCuihbpbBzFiaAajGfb/3RcQgBf/QogN7KCQ9AzG70PoD1SWsphp2fRuREYMNgFUytaZHkCCxAv6G5uv6pf4Zdh5/8g442OWK9A2ZSZNuwZHI3JceVvij4S6GUMZLYqx2rd5t+jVuSHtnPYX9ft+1QxEpno7TkQ8gE25mFdojccumpmFEDuCEjUR+UGF6QRwKXvzS51Nf3aWOzK3nTSyvQuYUieDGUHgjyd7nd3vce23JuxloaIsLmAV+n4PR+UKqND2za3OCD9OCHjC7ZpSDJ1vVFpD9+7crahatJMjVc2GCIjWOqJx3JEfC28fUITQ0jfR7g7LZj8yOKiq9k1/MAqac+7PA/hWq+c6iGJjt4PDLpHy4I8ERFuWBrFoDWWti+qKZaN7zdoYmF1VGhexQ6fSlDTjnndzgwT0XisgiBrXt5J5QpDZ/xjCLSn2UJ8sqQ/z3N/jVwR8NU114QstGCJGMTedvoukPNrgh9DpRfriRfYcIq6VTMaF8KjoVwsrESTma8AMj3+oVPVtUgRVLJQdfX3aCjuMzCGLSngq8i3xz8XGcrjS0X7XJwQzir/9e1B91WiMet+SbAzszLnMoum1UjFES4R5t6R/tuNHmUsCoXzSiF5K9zH4LC9SGJFmHvqm+IqerTckqLMtejr4scAaFnHLaqI0h3aCpV0LuL1gnRG1e2Ap6akSBoAhrlOiFjFY5AYoKCKKcCEJaEOWxAAAAAAACFMkDX8LqfOgk55YWHcVfDM9SpFSOrOaWW9TwJnR0d165Fv4aZhIbGVTtArG0t0Yaw09y/cRT9A8HMIwKsslmlCdDAy6aoKXKZE0gJHn6SrWvGilmDxsiyLySd2ZHtQgK+ggFrCbbnh2LvYnOnwV9z1UzSud2OsXj85rZwkfc20R4tjD2W05VFTtQrYrC7VIvfUWyN8z0yXhdnNkivpWLellSE/oyFIJRNNUPKrV3UH3gOCoufrpyncl5LJsJCLKPaTWFIqWHZKZzJTMRNOrLQlNaCTRxQZQaRO8F/7+g1IfB+kyYw3SKfXYFgjghI6P4pV6EVBUZOwK7yfZy5ZpFEsb31ej3lo5GdVhS6tFx36Cf9vbKFVXu2C5/5CMemK3ITjeMKZMDe5IyJxfhTz3WqkIOlMAAAAAWi/z+ulKv8bQSJ6o4UP9C4RKjlwdLtD4oypwU1Uh53tFu+ojdjIgqKwo5EEgrKuzX2nzoUZAAAAAAK3iFjzNgPFWLPZ3yenozW2+y8OgEj94h1P6AzApVSo47fbmLcSFayRE1X04ZWeaGPl5A1rygKKCl4A630BrvU4XlEbGTqzI60rIWTNpIhG6GK9oIGwOPZS2Rt6vsK6cMkkpDSr/4fkVsA7xlCWTnV2MHe8sVTxp55t3Admb66t16mG8tE5alc0AZNqN4iwaE2A2sKiG+6N9jL8HeFE2frh09RHz28Yy28SM2tRIQ4j0rgXNlF3FoWfbSGdxvVIEfTPYnDm7PnMfCZus2AU3uoLN2KGO41kVDAq04vCVb+9QaDYyABclT9U0Pk722eWtN5d6tM5SXryjAJ15/L3vw6J7qxKuUK9kpLVKFpyguEAuPwhj6dUi7JoDCsG3E+fTYAvhHeA607dkqhq7eoZ/KletNhSfhAAAAA=";
  var COMPACT_CSS = "\nbody[data-codex-contact-compact='1'] main {\n  background: transparent !important;\n}\nbody[data-codex-contact-compact='1'] .custom-title {\n  padding-top: 34px !important;\n  padding-bottom: 12px !important;\n}\nbody[data-codex-contact-compact='1'] .custom-title .section-capture,\nbody[data-codex-contact-compact='1'] .custom-title .section-title {\n  margin-bottom: 2px !important;\n}\nbody[data-codex-contact-compact='1'] .custom-title .section-title h2 {\n  margin-bottom: 6px !important;\n  font-size: clamp(34px, 3vw, 46px) !important;\n  line-height: 1.04 !important;\n}\nbody[data-codex-contact-compact='1'] .custom-title .custom-html,\nbody[data-codex-contact-compact='1'] .custom-title .custom-html center {\n  line-height: 1.25 !important;\n  font-size: 15px !important;\n}\nbody[data-codex-contact-compact='1'] .contact-section4 {\n  padding-top: 10px !important;\n  padding-bottom: 40px !important;\n  background: transparent !important;\n}\nbody[data-codex-contact-compact='1'] .contact-section4 .form-warp.contact-detail {\n  margin-top: 0 !important;\n}\nbody[data-codex-contact-compact='1'] .contact-section4 .contact-form-list {\n  max-width: none !important;\n  margin: 0 !important;\n}\nbody[data-codex-contact-compact='1'] .contact-section4 .contact-form-list input,\nbody[data-codex-contact-compact='1'] .contact-section4 .contact-form-list textarea {\n  background: rgba(255,255,255,0.72) !important;\n  border: 1px solid rgba(255,255,255,0.56) !important;\n  border-radius: 16px !important;\n  box-shadow: none !important;\n  min-height: 44px !important;\n  padding: 14px 18px !important;\n}\nbody[data-codex-contact-compact='1'] .contact-section4 .contact-form-list textarea.custom-textarea {\n  height: 182px !important;\n  min-height: 182px !important;\n}\nbody[data-codex-contact-compact='1'] .contact-section4 div.form-fill {\n  margin: -16px 0 0 -16px !important;\n}\nbody[data-codex-contact-compact='1'] .contact-section4 div.form-fill .form-wrapper {\n  width: calc(50% - 16px) !important;\n  margin: 16px 0 0 16px !important;\n}\nbody[data-codex-contact-compact='1'] .contact-section4 div.form-fill li {\n  margin-top: 14px !important;\n}\nbody[data-codex-contact-compact='1'] .contact-section4 div.form-fill li:first-child {\n  margin-top: 0 !important;\n}\nbody[data-codex-contact-compact='1'] .contact-section4 .contact-submit {\n  margin: 16px 0 0 0 !important;\n}\nbody[data-codex-contact-compact='1'] .contact-section4 .contact-submit label.read-agree {\n  display: flex !important;\n  align-items: flex-start !important;\n  gap: 12px !important;\n}\nbody[data-codex-contact-compact='1'] .contact-section4 .contact-submit label.read-agree .agree-text {\n  margin: 0 !important;\n  font-size: 14px !important;\n  line-height: 1.38 !important;\n}\nbody[data-codex-contact-compact='1'] .contact-section4 .contact-submit label.read-agree .cust-check {\n  min-width: 16px !important;\n  width: 16px !important;\n  height: 16px !important;\n  margin-top: 2px !important;\n  background: rgba(255,255,255,0.92) !important;\n}\nbody[data-codex-contact-compact='1'] .contact-section4 .contact-submit button.msg-btn {\n  margin: 0 !important;\n  min-width: 148px !important;\n  min-height: 42px !important;\n}\n@media (min-width: 992px) {\n  body[data-codex-contact-compact='1'] .contact-section4 .container {\n    max-width: 1140px !important;\n  }\n  body[data-codex-contact-compact='1'] .contact-section4 .col {\n    display: grid !important;\n    grid-template-columns: 190px minmax(0, 1fr) !important;\n    gap: 28px !important;\n    align-items: center !important;\n    background: transparent !important;\n    border: none !important;\n    border-radius: 0 !important;\n    box-shadow: none !important;\n    backdrop-filter: none !important;\n    -webkit-backdrop-filter: none !important;\n    padding: 18px 8px 18px !important;\n  }\n  body[data-codex-contact-compact='1'] .contact-section4 .section-capture {\n    margin: 0 !important;\n    min-height: 100% !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n  }\n  body[data-codex-contact-compact='1'] .contact-section4 .codex-contact-page-mascot {\n    display: flex !important;\n    justify-content: center !important;\n    margin: 0 !important;\n  }\n  body[data-codex-contact-compact='1'] .contact-section4 .codex-contact-page-mascot img {\n    width: min(174px, 18vw) !important;\n    height: auto !important;\n    border-radius: 0 !important;\n    box-shadow: none !important;\n    background: transparent !important;\n  }\n  body[data-codex-contact-compact='1'] .contact-section4 .contact-submit {\n    display: grid !important;\n    grid-template-columns: minmax(0, 1fr) auto !important;\n    gap: 16px !important;\n    align-items: center !important;\n  }\n  body[data-codex-contact-compact='1'] .contact-section4 .contact-submit label.read-agree {\n    width: auto !important;\n    margin: 0 !important;\n  }\n}\n@media (max-width: 991px) {\n  body[data-codex-contact-compact='1'] .custom-title {\n    padding-top: 24px !important;\n    padding-bottom: 10px !important;\n  }\n  body[data-codex-contact-compact='1'] .custom-title .section-title h2 {\n    font-size: 28px !important;\n  }\n  body[data-codex-contact-compact='1'] .contact-section4 {\n    padding-top: 8px !important;\n    padding-bottom: 30px !important;\n  }\n  body[data-codex-contact-compact='1'] .contact-section4 .col {\n    background: transparent !important;\n    border: none !important;\n    border-radius: 0 !important;\n    box-shadow: none !important;\n    backdrop-filter: none !important;\n    -webkit-backdrop-filter: none !important;\n    padding: 18px 0 18px !important;\n  }\n  body[data-codex-contact-compact='1'] .contact-section4 .section-capture {\n    margin-bottom: 12px !important;\n    display: flex !important;\n    justify-content: center !important;\n  }\n  body[data-codex-contact-compact='1'] .contact-section4 .codex-contact-page-mascot {\n    display: flex !important;\n    justify-content: center !important;\n    margin: 0 auto !important;\n  }\n  body[data-codex-contact-compact='1'] .contact-section4 .codex-contact-page-mascot img {\n    width: 116px !important;\n    height: auto !important;\n    border-radius: 0 !important;\n    box-shadow: none !important;\n    background: transparent !important;\n  }\n  body[data-codex-contact-compact='1'] .contact-section4 div.form-fill {\n    margin: -12px 0 0 0 !important;\n  }\n  body[data-codex-contact-compact='1'] .contact-section4 div.form-fill .form-wrapper {\n    width: 100% !important;\n    margin: 12px 0 0 0 !important;\n  }\n  body[data-codex-contact-compact='1'] .contact-section4 .contact-form-list textarea.custom-textarea {\n    height: 142px !important;\n    min-height: 142px !important;\n  }\n  body[data-codex-contact-compact='1'] .contact-section4 .contact-submit {\n    display: grid !important;\n    grid-template-columns: 1fr !important;\n    gap: 14px !important;\n    padding-bottom: 56px !important;\n  }\n  body[data-codex-contact-compact='1'] .contact-section4 .contact-submit label.read-agree {\n    width: 100% !important;\n    margin: 0 !important;\n    background: transparent !important;\n    padding: 0 !important;\n    border-radius: 0 !important;\n  }\n  body[data-codex-contact-compact='1'] .contact-section4 .contact-submit button.msg-btn {\n    width: 100% !important;\n  }\n}\n@media (max-width: 767px) {\n  body[data-codex-contact-compact='1'] .custom-title {\n    padding-top: 22px !important;\n  }\n}\n";

  function normalizedPath() {
    var current = window.location.pathname || '/';
    return current.replace(/\/+$/, '') || '/';
  }

  function isContactPage() {
    return normalizedPath() === TARGET_PATH;
  }

  function ensureStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = COMPACT_CSS;
    document.head.appendChild(style);
  }

  function setImportantStyle(element, property, value) {
    if (!element) return;
    element.style.setProperty(property, value, 'important');
  }

  function swapMascot() {
    var mascot = document.querySelector('.contact-section4 .codex-contact-page-mascot img');
    if (!mascot) return false;
    if (mascot.getAttribute('src') !== MASCOT_DATA_URI) {
      mascot.setAttribute('src', MASCOT_DATA_URI);
      mascot.removeAttribute('srcset');
      mascot.setAttribute('width', '432');
      mascot.setAttribute('height', '512');
    }
    mascot.style.background = 'transparent';
    return true;
  }

  function removePhoneField() {
    var phoneInput = document.querySelector('#ContactFormPhone');
    if (!phoneInput) return false;
    var phoneRow = phoneInput.closest('li');
    if (phoneRow) {
      phoneRow.remove();
      return true;
    }
    phoneInput.remove();
    return true;
  }

  function syncCloudBackground() {
    var body = document.body;
    if (!body) return false;

    var bodyStyles = window.getComputedStyle(body);
    var bodyBackgroundImage = bodyStyles.backgroundImage;
    setImportantStyle(body, 'background-size', 'cover');
    setImportantStyle(body, 'background-position', 'center center');
    setImportantStyle(body, 'background-repeat', 'no-repeat');

    var main = document.querySelector('main');
    var contactSection = document.querySelector('.contact-section4');
    var contactPanel = document.querySelector('.contact-section4 .col');
    var footerBottom = document.querySelector('.footer-bottom-area');
    var footerGroups = document.querySelectorAll('.shopify-section-group-footer-group');

    setImportantStyle(main, 'background', 'transparent');
    setImportantStyle(contactSection, 'background', 'transparent');
    setImportantStyle(contactPanel, 'background', 'transparent');
    setImportantStyle(contactPanel, 'border', 'none');
    setImportantStyle(contactPanel, 'box-shadow', 'none');
    setImportantStyle(contactPanel, 'backdrop-filter', 'none');
    setImportantStyle(contactPanel, '-webkit-backdrop-filter', 'none');
    setImportantStyle(footerBottom, 'background', 'transparent');

    footerGroups.forEach(function (group) {
      setImportantStyle(group, 'background-color', 'transparent');
      if (bodyBackgroundImage && bodyBackgroundImage !== 'none') {
        setImportantStyle(group, 'background-image', bodyBackgroundImage);
        setImportantStyle(group, 'background-repeat', 'no-repeat');
        setImportantStyle(group, 'background-size', 'cover');
        setImportantStyle(group, 'background-position', 'center 80%');
      }
    });

    return true;
  }

  function softenInputs() {
    var fields = document.querySelectorAll(
      ".contact-section4 .contact-form-list input:not([type='hidden']):not([type='checkbox']), .contact-section4 .contact-form-list textarea"
    );
    if (!fields.length) return false;
    fields.forEach(function (field) {
      setImportantStyle(field, 'background', 'rgba(255,255,255,0.72)');
      setImportantStyle(field, 'border', '1px solid rgba(255,255,255,0.56)');
      setImportantStyle(field, 'box-shadow', 'none');
    });
    return true;
  }

  function apply() {
    if (!isContactPage()) return;
    if (document.body) {
      document.body.setAttribute(BODY_ATTR, '1');
    }
    ensureStyle();
    syncCloudBackground();
    softenInputs();
    swapMascot();
    removePhoneField();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply, { once: true });
  } else {
    apply();
  }

  window.addEventListener('pageshow', apply);
  window.addEventListener('load', apply);
  setTimeout(apply, 200);
  setTimeout(apply, 1200);
  setTimeout(apply, 3500);

  var observer = new MutationObserver(function () {
    if (!isContactPage()) return;
    apply();
  });

  function startObserver() {
    if (!document.documentElement) return;
    observer.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () {
      observer.disconnect();
    }, 12000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver, { once: true });
  } else {
    startObserver();
  }
})();
/* FBP contact page compact runtime 2026-04-03 end */

/* FBP current theme regression runtime forward-port 2026-04-04 start */
(function () {
  if (window.__fbpCurrentThemeRegressionForwardPortLoaded) return;
  window.__fbpCurrentThemeRegressionForwardPortLoaded = true;

  var PRICE_FILTER_STYLE_ID = 'fbp-hide-daki-price-filter-style';
  var PRICE_TARGET_PATHS = new Set([
    '/collections/body-pillow-covers-furry-dakimakura',
    '/collections/feline-body-pillow',
    '/collections/feline-body-pillow2',
    '/collections/bird-body-pillow',
    '/collections/wolf-body-pillow',
    '/collections/dragon-body-pillows',
    '/collections/equines-body-pillow',
    '/collections/fox-body-pillow',
    '/collections/other-body-pillows',
    '/collections/raccoon-body-pillow',
    '/collections/sea-creatures-body-pillow'
  ]);
  var AGE_WARNING_TEXT = 'You must be 18 or older to order NSFW variants.';
  var AGE_STYLE_ID = 'fbp-top-age-warning-style';
  var AGE_PHRASE_PATTERN = /(NSFW variants are only purchasable by ADULTS!|must be 18|18 or older)/i;

  function currentPath() {
    return window.location.pathname.replace(/\/+$/, '') || '/';
  }

  function isCollectionPage() {
    return document.body && document.body.classList.contains('template-collection');
  }

  function isProductPage() {
    return document.body && document.body.classList.contains('template-product');
  }

  function shouldHidePriceFilter() {
    if (!isCollectionPage()) return false;
    return PRICE_TARGET_PATHS.has(currentPath()) ||
      document.body.classList.contains('collection-handle-body-pillow-covers-furry-dakimakura');
  }

  function injectPriceFilterStyle() {
    if (document.getElementById(PRICE_FILTER_STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = PRICE_FILTER_STYLE_ID;
    style.textContent = [
      'body.fbp-hide-daki-price-filter .shop-sidebar.st-filter.fbp-hide-price-only{display:none !important;}',
      'body.fbp-hide-daki-price-filter .shop-sidebar.st-filter.fbp-hide-price-only + .shop-sidebar{margin-top:0 !important;}'
    ].join('');
    document.head.appendChild(style);
  }

  function hideDakiPriceSection() {
    if (!shouldHidePriceFilter()) return;
    document.body.classList.add('fbp-hide-daki-price-filter');
    injectPriceFilterStyle();
    Array.prototype.forEach.call(document.querySelectorAll('.shop-sidebar.st-filter'), function (section) {
      var heading = section.querySelector('.sidebar-heading');
      if (!heading) return;
      var text = (heading.textContent || '').trim();
      section.classList.toggle('fbp-hide-price-only', text === 'Price');
    });
  }

  function watchDakiPriceFilter() {
    if (window.__fbpHideDakiPriceFilterObserver) return;
    var root = document.querySelector('stfilter-ele') || document.getElementById('main-collection-filters') || document.querySelector('.filter-sidebar');
    if (!root) return;
    var observer = new MutationObserver(function () {
      cancelAnimationFrame(window.__fbpHideDakiPriceFilterRaf);
      window.__fbpHideDakiPriceFilterRaf = requestAnimationFrame(hideDakiPriceSection);
    });
    observer.observe(root, { childList: true, subtree: true, attributes: true });
    window.__fbpHideDakiPriceFilterObserver = observer;
  }

  function injectAgeWarningStyle() {
    if (document.getElementById(AGE_STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = AGE_STYLE_ID;
    style.textContent = '[data-fbp-hide-adult-warning-original="true"]{display:none !important;}';
    document.head.appendChild(style);
  }

  function openMainMenu() {
    Array.prototype.forEach.call(document.querySelectorAll('.main-menu-area'), function (menu) {
      menu.classList.add('active');
      var scroller = menu.querySelector('.mainwrap');
      if (scroller) scroller.scrollTop = 0;
    });
    Array.prototype.forEach.call(document.querySelectorAll('.mm-fullscreen-bg'), function (overlay) {
      overlay.classList.add('active');
    });
    if (document.body) document.body.classList.add('ov-hidden');
  }

  function closeMainMenu() {
    Array.prototype.forEach.call(document.querySelectorAll('.main-menu-area'), function (menu) {
      menu.classList.remove('active');
    });
    Array.prototype.forEach.call(document.querySelectorAll('.mm-fullscreen-bg'), function (overlay) {
      overlay.classList.remove('active');
    });
    if (document.body) document.body.classList.remove('ov-hidden');
  }

  function normalizeText(text) {
    return String(text || '').replace(/\s+/g, ' ').trim();
  }

  function findAdultWarningNodes() {
    return Array.prototype.filter.call(
      document.querySelectorAll('.product-description p, .product-description div, .product-description span, .wt-content-toggle__body p, .wt-content-toggle__body div, .wt-content-toggle__body span'),
      function (node) {
        var text = normalizeText(node.textContent);
        if (!AGE_PHRASE_PATTERN.test(text)) return false;
        if (text.length > 140) return false;
        if (node.children && node.children.length > 2) return false;
        return true;
      }
    );
  }

  function ensureTopAgeWarning() {
    if (!isProductPage()) return;
    var sourceNodes = findAdultWarningNodes();
    if (!sourceNodes.length) return;

    injectAgeWarningStyle();
    sourceNodes.forEach(function (node) {
      node.setAttribute('data-fbp-hide-adult-warning-original', 'true');
    });

    var infoRoot = document.querySelector('.product_details_info');
    if (!infoRoot) return;
    var mount = infoRoot.querySelector('.product-form') || infoRoot.querySelector('.product-info.short-description') || infoRoot.querySelector('.product-info');
    if (!mount) return;
    var targetParent = mount.parentNode && mount.parentNode.nodeType === 1 ? mount.parentNode : infoRoot;

    var warning = infoRoot.querySelector('.fbp-top-age-warning');
    if (!warning) {
      warning = document.createElement('div');
      warning.className = 'fbp-top-age-warning';
      warning.innerHTML = '<span class="fbp-top-age-warning__eyebrow">18+ notice</span><span class="fbp-top-age-warning__text"></span>';
    }

    warning.querySelector('.fbp-top-age-warning__text').textContent = AGE_WARNING_TEXT;

    if (warning.parentNode !== targetParent || warning.nextSibling !== mount) {
      targetParent.insertBefore(warning, mount);
    }
  }

  function applyAll() {
    hideDakiPriceSection();
    ensureTopAgeWarning();
  }

  function installGlobalObserver() {
    if (window.__fbpCurrentThemeRegressionObserver || !document.documentElement) return;
    var observer = new MutationObserver(function () {
      cancelAnimationFrame(window.__fbpCurrentThemeRegressionRaf);
      window.__fbpCurrentThemeRegressionRaf = requestAnimationFrame(applyAll);
    });
    observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true });
    window.__fbpCurrentThemeRegressionObserver = observer;
  }

  function init() {
    applyAll();
    watchDakiPriceFilter();
    installGlobalObserver();
    document.addEventListener('click', function (event) {
      var target = event.target;
      var fbpMenuActive = document.body.classList.contains('fbp-mobile-menu-rebuild-ready');

      var openToggle = target && target.closest ? target.closest('button.navbar-toggle') : null;
      if (openToggle && !fbpMenuActive) {
        event.preventDefault();
        openMainMenu();
        return;
      }

      var closeToggle = target && target.closest ? target.closest('.close-box') : null;
      if (closeToggle && !fbpMenuActive) {
        event.preventDefault();
        closeMainMenu();
        return;
      }

      var overlay = target && target.closest ? target.closest('.mm-fullscreen-bg.active') : null;
      if (overlay && !fbpMenuActive) {
        closeMainMenu();
      }
    }, true);
    window.addEventListener('popstate', function () {
      window.setTimeout(applyAll, 60);
    });
    window.setTimeout(applyAll, 400);
    window.setTimeout(applyAll, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window.addEventListener('load', applyAll);
})();
/* FBP current theme regression runtime forward-port 2026-04-04 end */

/* FBP live filter and mobile menu hotfix 2026-04-05 start */
(function () {
  if (window.__fbpLiveFilterAndMobileMenuHotfixLoaded) return;
  window.__fbpLiveFilterAndMobileMenuHotfixLoaded = true;

  var STYLE_ID = 'fbp-live-filter-menu-and-sort-hotfix-style-20260405';
  var ALL_DAKI_PATH = '/collections/body-pillow-covers-furry-dakimakura';
  var BEST_ALL_TIME_PATH = '/collections/best-selling-all-time-daki';
  var BEST_30_DAY_PATH = '/collections/best-selling-this-month-daki';
  var ADULT_WARNING_PATTERN = /(NSFW variants are only purchasable by ADULTS!|must be 18|18 or older)/i;
  var DAKI_SORT_PATHS = new Set([
    ALL_DAKI_PATH,
    BEST_ALL_TIME_PATH,
    BEST_30_DAY_PATH
  ]);

  function isCollectionPage() {
    return document.body.classList.contains('template-collection');
  }

  function isDesktopCollection() {
    return isCollectionPage() && window.innerWidth >= 1024;
  }

  function filterRebuildOwnsFilters() {
    return !!document.body && document.body.classList.contains('fbp-filter-rebuild-ready');
  }

  function normalizePath(pathname) {
    var value = String(pathname || '').trim();
    if (!value) return '/';
    return value.replace(/\/+$/, '') || '/';
  }

  function isDakiSortPage() {
    return DAKI_SORT_PATHS.has(normalizePath(window.location.pathname));
  }

  function normalizeLegacyDakiSortParamIfNeeded() {
    if (!isDakiSortPage()) return false;
    if (window.__fbpLegacyDakiSortParamNavigating) return true;
    var url = new URL(window.location.href);
    var legacySort = url.searchParams.get('sortby');
    if (!legacySort || url.searchParams.has('sort_by')) return false;
    url.searchParams.delete('sortby');
    url.searchParams.delete('page');
    url.searchParams.set('sort_by', legacySort);
    window.__fbpLegacyDakiSortParamNavigating = true;
    window.location.replace(url.toString());
    return true;
  }

  function isProductPage() {
    return document.body && document.body.classList.contains('template-product');
  }

  function isProductDescriptionWarning(node) {
    if (!node) return false;
    var text = String(node.textContent || '').replace(/s+/g, ' ').trim();
    if (!ADULT_WARNING_PATTERN.test(text)) return false;
    if (text.length > 140) return false;
    var childHasText = Array.prototype.some.call(node.children || [], function (child) {
      return ADULT_WARNING_PATTERN.test(String(child.textContent || '').replace(/s+/g, ' ').trim());
    });
    return !childHasText;
  }

  function hideAdultWarnings() {
    if (!isProductPage()) return;
    Array.prototype.slice.call(document.querySelectorAll('.fbp-top-age-warning')).forEach(function (node) {
      node.style.display = 'none';
      node.setAttribute('aria-hidden', 'true');
    });
    Array.prototype.slice.call(document.querySelectorAll('p, div, span, li')).forEach(function (node) {
      if (!isProductDescriptionWarning(node)) return;
      node.setAttribute('data-fbp-codex-hide-adult-warning', 'true');
      node.style.display = 'none';
    });
  }

  function ensureStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      'body.template-collection select#SortBy,',
      'body.template-collection select[name="sortby"],',
      'body.template-collection select[name="sort_by"],',
      'body.template-collection .shop-top-bar select,',
      'body.template-collection .shop-top-bar select.nice-select,',
      'body.template-collection #SortBy.nice-select{background:rgba(255,255,255,0.96)!important;background-color:rgba(255,255,255,0.96)!important;color:#1a1a2e!important;-webkit-text-fill-color:#1a1a2e!important;border:1px solid rgba(26,10,46,0.16)!important;border-radius:12px!important;box-shadow:0 8px 20px rgba(26,10,46,0.05)!important;appearance:none!important;-webkit-appearance:none!important;color-scheme:light!important;opacity:1!important;}',
      'body.template-collection select#SortBy option,',
      'body.template-collection select[name="sortby"] option,',
      'body.template-collection select[name="sort_by"] option,',
      'body.template-collection .shop-top-bar select option{background:#ffffff!important;color:#1a1a2e!important;}',
      'body.template-collection .shop-top-bar .nice-select:after,',
      'body.template-collection #SortBy.nice-select:after{border-bottom-color:#1a1a2e!important;border-right-color:#1a1a2e!important;}',
      'body.template-product .fbp-top-age-warning{display:none!important;}',
      'body.template-product [data-fbp-codex-hide-adult-warning="true"]{display:none!important;}',
      '@media (min-width:1024px){',
      'body.template-collection:not(.fbp-filter-rebuild-ready) .product-sidebar{max-height:none!important;overflow:visible!important;overflow-y:visible!important;}',
      'body.template-collection:not(.fbp-filter-rebuild-ready) .shop-sidebar-wrap.filter-sidebar > stfilter-ele.facets{display:block!important;width:100%!important;height:auto!important;min-height:0!important;overflow:visible!important;background:transparent!important;}',
      'body.template-collection:not(.fbp-filter-rebuild-ready) .shop-sidebar-wrap.filter-sidebar > stfilter-ele.facets #st-wrapper{display:block!important;width:100%!important;height:auto!important;overflow:visible!important;}',
      'body.template-collection:not(.fbp-filter-rebuild-ready) .shop-sidebar-wrap.filter-sidebar > stfilter-ele.facets .shop-sidebar.st-filter{display:block!important;width:100%!important;height:auto!important;overflow:visible!important;background:transparent!important;margin-top:16px!important;}',
      'body.template-collection:not(.fbp-filter-rebuild-ready) .shop-sidebar-wrap.filter-sidebar > stfilter-ele.facets .shop-sidebar.st-filter .collapse.flt-ele{display:block!important;height:auto!important;max-height:none!important;overflow:visible!important;}',
      'body.template-collection:not(.fbp-filter-rebuild-ready) .shop-sidebar-wrap.filter-sidebar > stfilter-ele.facets .shop-sidebar.st-filter.fbp-hide-price-only{display:none!important;width:0!important;height:0!important;margin:0!important;padding:0!important;overflow:hidden!important;pointer-events:none!important;opacity:0!important;}',
      'body.template-collection:not(.fbp-filter-rebuild-ready) .shop-sidebar.shop-collection li:has(a[title="Best Selling All Time Daki"]),body.template-collection:not(.fbp-filter-rebuild-ready) .shop-sidebar.shop-collection li:has(a[title="Best Selling This Month Daki"]),body.template-collection:not(.fbp-filter-rebuild-ready) .shop-sidebar.shop-collection li:has(a[href*="/collections/best-selling-all-time-daki"]),body.template-collection:not(.fbp-filter-rebuild-ready) .shop-sidebar.shop-collection li:has(a[href*="/collections/best-selling-this-month-daki"]){display:none!important;}',
      'body.template-collection:not(.fbp-filter-rebuild-ready) .shop-sidebar.shop-collection ul.scrollbar{max-height:340px!important;overflow-y:auto!important;overflow-x:hidden!important;padding-right:6px!important;}',
      'body.template-collection:not(.fbp-filter-rebuild-ready) .shop-sidebar-wrap.filter-sidebar > stfilter-ele.facets .shop-sidebar.st-filter.art ul.scrollbar{max-height:320px!important;overflow-y:auto!important;overflow-x:hidden!important;padding-right:6px!important;}',
      'body.template-collection:not(.fbp-filter-rebuild-ready) .shop-sidebar-wrap.filter-sidebar > stfilter-ele.facets .shop-sidebar.st-filter.gender ul.scrollbar{max-height:none!important;overflow:visible!important;padding-right:0!important;}',
      'body.template-collection:not(.fbp-filter-rebuild-ready) .sidebar-banner.banner-hover{display:block!important;}',
      'body.template-collection:not(.fbp-filter-rebuild-ready) .fbp-artist-gallery-cta{display:none!important;}',
      '}',
      '@media (max-width:1199.98px){',
      // Scope the legacy mobile menu visibility boosters to the non-rebuild
      // fallback path. When the rebuild mobile menu is ready, its drawer owns
      // the mobile open/close surface and the legacy `.main-menu-area` must
      // stay hidden (the rebuild\'s own stylesheet hides it with !important).
      // Without this scoping, opening the legacy menu races the rebuild drawer
      // and produces the multi-tap flicker.
      'body:not(.fbp-mobile-menu-rebuild-ready) .main-menu-area{z-index:100002!important;}',
      'body:not(.fbp-mobile-menu-rebuild-ready) .main-menu-area.active{left:0!important;transform:none!important;display:flex!important;z-index:100002!important;}',
      'body:not(.fbp-mobile-menu-rebuild-ready) .main-menu-area.active,body:not(.fbp-mobile-menu-rebuild-ready) .main-menu-area.active *{pointer-events:auto!important;}',
      'body:not(.fbp-mobile-menu-rebuild-ready) .mm-fullscreen-bg.active{display:block!important;z-index:100001!important;}',
      'body.ov-hidden{overflow:hidden!important;touch-action:none!important;}',
      '}'
    ].join('');
    document.head.appendChild(style);
  }

  function getSectionHeading(section) {
    var heading = section && section.querySelector('.sidebar-heading');
    return heading ? (heading.textContent || '').trim() : '';
  }

  function getFilterWrapper() {
    return document.querySelector('.shop-sidebar-wrap.filter-sidebar');
  }

  function getSectionByHeading(name) {
    var seen = new Set();
    return Array.prototype.slice.call(document.querySelectorAll('.shop-sidebar-wrap.filter-sidebar .shop-sidebar.st-filter, stfilter-ele.facets .shop-sidebar.st-filter')).find(function (section) {
      if (seen.has(section)) return false;
      seen.add(section);
      return getSectionHeading(section) === name;
    }) || null;
  }

  function resetInlineStyles(element, properties) {
    if (!element) return;
    properties.forEach(function (property) {
      element.style.removeProperty(property);
    });
  }

  function cleanupLegacyDesktopSidebar() {
    if (!isDesktopCollection()) return;
    if (document.body.classList.contains('fbp-filter-rebuild-ready')) return;
    Array.prototype.slice.call(document.querySelectorAll('stfilter-ele.facets, stfilter-ele.facets #st-wrapper')).forEach(function (element) {
      resetInlineStyles(element, ['display', 'width', 'height', 'min-height', 'max-height', 'overflow']);
    });
    Array.prototype.slice.call(document.querySelectorAll('.fbp-artist-gallery-cta')).forEach(function (cta) {
      cta.remove();
    });
    Array.prototype.slice.call(document.querySelectorAll('.sidebar-banner.banner-hover')).forEach(function (banner) {
      banner.style.removeProperty('display');
    });
    Array.prototype.slice.call(document.querySelectorAll('.shop-sidebar.shop-collection ul.scrollbar')).forEach(function (list) {
      resetInlineStyles(list, ['max-height', 'overflow-y', 'overflow-x', 'padding-right']);
    });
    [getSectionByHeading('Art By :'), getSectionByHeading('Gender')].forEach(function (section) {
      if (!section) return;
      section.classList.remove('fbp-hide-price-only');
      resetInlineStyles(section, ['display', 'visibility', 'opacity', 'width', 'height', 'overflow', 'pointer-events', 'background', 'margin-top']);
      var collapse = section.querySelector('.collapse.flt-ele');
      if (collapse) {
        resetInlineStyles(collapse, ['display', 'height', 'max-height', 'overflow']);
      }
      Array.prototype.slice.call(section.querySelectorAll('ul.scrollbar')).forEach(function (list) {
        resetInlineStyles(list, ['max-height', 'overflow-y', 'overflow-x', 'padding-right']);
      });
      var header = section.querySelector('.sidebar-header');
      if (header) {
        resetInlineStyles(header, ['display', 'justify-content', 'align-items', 'margin']);
      }
    });
  }

  function hideSection(section) {
    if (!section) return;
    section.classList.add('fbp-hide-price-only');
    section.style.display = 'none';
    section.style.width = '0';
    section.style.height = '0';
    section.style.margin = '0';
    section.style.padding = '0';
    section.style.overflow = 'hidden';
    section.style.pointerEvents = 'none';
    section.style.opacity = '0';
  }

  function showSection(section) {
    if (!section) return;
    section.classList.remove('fbp-hide-price-only');
    section.style.display = 'block';
    section.style.visibility = 'visible';
    section.style.opacity = '1';
    section.style.width = '100%';
    section.style.height = 'auto';
    section.style.overflow = 'visible';
    section.style.pointerEvents = 'auto';
    section.style.background = 'transparent';
    section.style.marginTop = '16px';

    var collapse = section.querySelector('.collapse.flt-ele');
    if (collapse) {
      collapse.style.display = 'block';
      collapse.style.height = 'auto';
      collapse.style.maxHeight = 'none';
      collapse.style.overflow = 'visible';
    }

    var header = section.querySelector('.sidebar-header');
    if (header) {
      header.style.display = 'flex';
      header.style.justifyContent = 'space-between';
      header.style.alignItems = 'center';
      header.style.margin = '8px 0 10px';
    }
  }

  function normalizeCollectionSidebar() {
    if (!isDesktopCollection()) return;
    if (document.body.classList.contains('fbp-filter-rebuild-ready')) return;
    ensureStyle();

    var shell = getFilterWrapper();
    var categories = document.querySelector('.shop-sidebar.shop-collection');
    var summary = document.querySelector('stfilter-ele.facets .shop-sidebar.sidebar-filter');
    var price = getSectionByHeading('Price');
    var art = getSectionByHeading('Art By :');
    var gender = getSectionByHeading('Gender');
    if (!shell || !categories || !art || !gender) return;

    if (summary) hideSection(summary);
    if (price) hideSection(price);

    showSection(art);
    showSection(gender);

    var anchor = categories;
    [art, gender].forEach(function (section) {
      if (!section) return;
      if (section.parentElement !== shell || section.previousElementSibling !== anchor) {
        shell.insertBefore(section, anchor.nextElementSibling);
      }
      anchor = section;
    });

    Array.prototype.slice.call(shell.querySelectorAll('.fbp-artist-gallery-cta')).forEach(function (cta) {
      cta.remove();
    });
    Array.prototype.slice.call(document.querySelectorAll('.sidebar-banner.banner-hover')).forEach(function (banner) {
      banner.style.removeProperty('display');
    });
  }

  function getManagedFilterSections() {
    return [getSectionByHeading('Art By :'), getSectionByHeading('Gender')].filter(Boolean);
  }

  function getManagedFilterInputs() {
    var seen = new Set();
    var inputs = [];
    getManagedFilterSections().forEach(function (section) {
      Array.prototype.slice.call(section.querySelectorAll('input[type="checkbox"][name], input[type="radio"][name]')).forEach(function (input) {
        var key = [input.name, input.value].join('::');
        if (seen.has(key)) return;
        seen.add(key);
        inputs.push(input);
      });
    });
    return inputs;
  }

  function buildManagedFilterTarget() {
    if (filterRebuildOwnsFilters()) return window.location.href;
    var url = new URL(window.location.href);
    url.searchParams.delete('page');

    var inputs = getManagedFilterInputs();
    var names = Array.prototype.slice.call(new Set(inputs.map(function (input) {
      return input.name;
    }).filter(Boolean)));

    names.forEach(function (name) {
      url.searchParams.delete(name);
    });

    inputs.forEach(function (input) {
      if (!input.checked || !input.name || !input.value) return;
      url.searchParams.append(input.name, input.value);
    });

    return url.toString();
  }

  function navigateManagedFilterTarget(target) {
    if (!target || target === window.location.href) return false;
    if (window.__fbpManagedFilterNavigationLocked) return true;
    window.__fbpManagedFilterNavigationLocked = true;
    window.location.assign(target);
    return true;
  }

  function normalizeManagedFilterUrlIfNeeded() {
    if (!isCollectionPage()) return;
    if (filterRebuildOwnsFilters()) return;
    var current = window.location.href;
    var normalized = buildManagedFilterTarget();
    if (!normalized || normalized === current) return;
    history.replaceState(null, '', normalized);
  }

  function handleManagedFilterLabelClick(label) {
    if (!label || !isCollectionPage()) return false;
    if (filterRebuildOwnsFilters()) return false;
    var input = label.querySelector('input[type="checkbox"][name], input[type="radio"][name]');
    if (!input) return false;
    var section = label.closest('.shop-sidebar.st-filter');
    if (!section) return false;
    var heading = getSectionHeading(section);
    if (heading !== 'Art By :' && heading !== 'Gender') return false;

    input.checked = !input.checked;
    return navigateManagedFilterTarget(buildManagedFilterTarget());
  }

  function handleManagedFilterReset(link) {
    if (!link || !isCollectionPage()) return false;
    if (filterRebuildOwnsFilters()) return false;
    var section = link.closest('.shop-sidebar.st-filter');
    if (!section) return false;
    var heading = getSectionHeading(section);
    if (heading !== 'Art By :' && heading !== 'Gender') return false;

    var url = new URL(window.location.href);
    url.searchParams.delete('page');
    Array.prototype.slice.call(section.querySelectorAll('input[type="checkbox"][name], input[type="radio"][name]')).forEach(function (input) {
      if (input.name) {
        url.searchParams.delete(input.name);
      }
    });

    return navigateManagedFilterTarget(url.toString());
  }

  function bindManagedFilterControls() {
    if (!isCollectionPage()) return;
    if (filterRebuildOwnsFilters()) return;

    getManagedFilterSections().forEach(function (section) {
      Array.prototype.slice.call(section.querySelectorAll('label.cust-checkbox-label')).forEach(function (label) {
        if (label.dataset.fbpManagedFilterLabelBound === '1') return;
        label.dataset.fbpManagedFilterLabelBound = '1';
        label.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
          handleManagedFilterLabelClick(label);
        }, true);
      });

      Array.prototype.slice.call(section.querySelectorAll('input[type="checkbox"][name], input[type="radio"][name]')).forEach(function (input) {
        if (input.dataset.fbpManagedFilterInputBound === '1') return;
        input.dataset.fbpManagedFilterInputBound = '1';
        input.addEventListener('change', function (event) {
          if (window.__fbpManagedFilterNavigationLocked) return;
          event.preventDefault();
          event.stopPropagation();
          if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
          navigateManagedFilterTarget(buildManagedFilterTarget());
        }, true);
      });

      Array.prototype.slice.call(section.querySelectorAll('a')).forEach(function (link) {
        if ((link.textContent || '').trim() !== 'Reset') return;
        if (link.dataset.fbpManagedFilterResetBound === '1') return;
        link.dataset.fbpManagedFilterResetBound = '1';
        link.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
          handleManagedFilterReset(link);
        }, true);
      });
    });
  }

  function ensureWhiteSortStyles(select) {
    if (!select) return;
    select.style.background = 'rgba(255,255,255,0.96)';
    select.style.backgroundColor = 'rgba(255,255,255,0.96)';
    select.style.color = '#1a1a2e';
    select.style.webkitTextFillColor = '#1a1a2e';
    select.style.border = '1px solid rgba(26,10,46,0.16)';
    select.style.borderRadius = '12px';
    select.style.boxShadow = '0 8px 20px rgba(26,10,46,0.05)';
    select.style.appearance = 'none';
    select.style.webkitAppearance = 'none';
    select.style.colorScheme = 'light';
    select.style.opacity = '1';
  }

  function getSortSelects() {
    var seen = new Set();
    return Array.prototype.slice.call(document.querySelectorAll('select#SortBy, select[name="sortby"], select[name="sort_by"], .shop-top-bar select')).filter(function (select) {
      if (!select || seen.has(select)) return false;
      seen.add(select);
      return true;
    });
  }

  function ensureSortOption(select, value, label, afterValue) {
    if (!select) return;
    var existing = Array.prototype.slice.call(select.options).find(function (option) {
      return option.value === value;
    });
    if (existing) {
      existing.textContent = label;
      return;
    }

    var option = document.createElement('option');
    option.value = value;
    option.textContent = label;

    var anchor = afterValue
      ? Array.prototype.slice.call(select.options).find(function (entry) { return entry.value === afterValue; })
      : null;

    if (anchor && anchor.nextSibling) {
      select.insertBefore(option, anchor.nextSibling);
      return;
    }

    select.appendChild(option);
  }

  function removeSortOption(select, value) {
    if (!select) return;
    Array.prototype.slice.call(select.options).forEach(function (option) {
      if (option.value === value) {
        option.remove();
      }
    });
  }

  function syncDakiSortValue(select) {
    if (!select || !isDakiSortPage()) return;
    var path = normalizePath(window.location.pathname);
    var params = new URLSearchParams(window.location.search || '');
    var sortParam = params.get('sort_by') || params.get('sortby') || '';
    if (sortParam === 'best-selling') {
      select.value = 'fbp-best-selling-all-time';
      return;
    }
    if (path === BEST_ALL_TIME_PATH) {
      select.value = 'fbp-best-selling-all-time';
      return;
    }
    if (path === BEST_30_DAY_PATH) {
      select.value = 'fbp-best-selling-30-days';
      return;
    }
    if (!select.value || select.value === 'best-selling') {
      select.value = 'manual';
    }
  }

  function buildDakiSortTarget(value) {
    var url = new URL(window.location.href);
    url.searchParams.delete('page');
    url.searchParams.delete('sort_by');
    url.searchParams.delete('sortby');

    if (value === 'fbp-best-selling-all-time') {
      url.pathname = BEST_ALL_TIME_PATH;
      return url.toString();
    }

    if (value === 'fbp-best-selling-30-days') {
      url.pathname = BEST_30_DAY_PATH;
      return url.toString();
    }

    if (value === 'best-selling') {
      url.pathname = BEST_ALL_TIME_PATH;
      return url.toString();
    }

    url.pathname = ALL_DAKI_PATH;
    if (value && value !== 'manual') {
      url.searchParams.set('sort_by', value);
    }

    return url.toString();
  }

  function rebuildDakiSortUi(select) {
    if (!select || !isDakiSortPage()) return;
    var container = select.closest('.product-short');
    if (!container) return;

    var selectedOption = Array.prototype.slice.call(select.options).find(function (option) {
      return option.value === select.value;
    }) || select.options[0] || null;

    Array.prototype.slice.call(container.querySelectorAll('.sort-title')).forEach(function (label) {
      label.textContent = selectedOption ? selectedOption.textContent.trim() : 'Featured';
    });

    var list = container.querySelector('#select-wrap');
    if (!list) return;

    list.innerHTML = '';
    Array.prototype.slice.call(select.options).forEach(function (option) {
      var li = document.createElement('li');
      if (option.value === select.value) {
        li.classList.add('selected');
      }
      var link = document.createElement('a');
      link.href = buildDakiSortTarget(option.value);
      link.textContent = option.textContent.trim();
      link.dataset.fbpSortValue = option.value;
      li.appendChild(link);
      list.appendChild(li);
    });
  }

  function enhanceDakiSortSelect(select) {
    if (!select) return;
    ensureWhiteSortStyles(select);
    if (!isDakiSortPage()) return;

    removeSortOption(select, 'best-selling');
    ensureSortOption(select, 'fbp-best-selling-all-time', 'Best selling all times', 'manual');
    ensureSortOption(select, 'fbp-best-selling-30-days', 'Best selling in the last 30 days', 'fbp-best-selling-all-time');
    syncDakiSortValue(select);
    rebuildDakiSortUi(select);

    if (select.dataset.fbpDakiSortBound === '1') return;
    select.dataset.fbpDakiSortBound = '1';
    select.addEventListener('change', function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      var target = buildDakiSortTarget(select.value);
      if (target && target !== window.location.href) {
        window.location.assign(target);
      }
    }, true);
  }

  function openMobileMenu() {
    var menu = document.querySelector('.main-menu-area');
    var overlay = document.querySelector('.mm-fullscreen-bg');
    if (!menu) return;
    menu.classList.add('active');
    menu.style.left = '0';
    menu.style.transform = 'none';
    menu.style.display = 'flex';
    menu.style.setProperty('z-index', '100002', 'important');
    if (overlay) {
      var menuRect = menu.getBoundingClientRect();
      var overlayLeft = Math.max(Math.round(menuRect.width), 0);
      var overlayWidth = Math.max(window.innerWidth - overlayLeft, 0);
      overlay.classList.add('active');
      overlay.style.display = 'block';
      overlay.style.setProperty('position', 'fixed', 'important');
      overlay.style.setProperty('top', '0', 'important');
      overlay.style.setProperty('left', overlayLeft + 'px', 'important');
      overlay.style.setProperty('width', overlayWidth + 'px', 'important');
      overlay.style.setProperty('height', window.innerHeight + 'px', 'important');
      overlay.style.setProperty('z-index', '100001', 'important');
    }
    document.body.classList.add('ov-hidden');
  }

  function closeMobileMenu() {
    var menu = document.querySelector('.main-menu-area');
    var overlay = document.querySelector('.mm-fullscreen-bg');
    if (menu) {
      menu.classList.remove('active');
      menu.style.left = '';
      menu.style.transform = '';
      menu.style.display = '';
      menu.style.zIndex = '';
    }
    if (overlay) {
      overlay.classList.remove('active');
      overlay.style.display = '';
      overlay.style.position = '';
      overlay.style.top = '';
      overlay.style.left = '';
      overlay.style.width = '';
      overlay.style.height = '';
      overlay.style.zIndex = '';
    }
    document.body.classList.remove('ov-hidden');
  }

  function handleClick(event) {
    var target = event.target && event.target.closest ? event.target.closest('button, a, div, label, span, li, input') : null;
    if (!target) return;

    // When the rebuild mobile menu is active, defer all legacy mobile menu
    // open/close/navigate handling to the rebuild. Keeping any of the legacy
    // paths live races the rebuild (each tap both opens the rebuild drawer
    // AND toggles the legacy `.main-menu-area.active` surface via the
    // hotfix CSS), which causes the multi-tap flicker customers reported.
    var fbpMobileMenuRebuildActive =
      !!document.body && document.body.classList.contains('fbp-mobile-menu-rebuild-ready');

    var filterLabel = target.closest ? target.closest('.shop-sidebar.st-filter label.cust-checkbox-label') : null;
    if (filterLabel) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      if (handleManagedFilterLabelClick(filterLabel)) return;
    }

    if (target.matches && target.matches('a')) {
      var resetLink = target.closest('.shop-sidebar.st-filter a');
      if (resetLink && (resetLink.textContent || '').trim() === 'Reset') {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
        if (handleManagedFilterReset(resetLink)) return;
      }
    }

    if (!fbpMobileMenuRebuildActive && window.innerWidth < 1200) {
      var menuLink = target.closest('.main-menu-area a[href]');
      if (menuLink) {
        var href = (menuLink.getAttribute('href') || '').trim();
        var isRealNavigation =
          href &&
          href !== '#' &&
          href.indexOf('javascript:') !== 0 &&
          href.charAt(0) !== '#' &&
          !menuLink.hasAttribute('data-bs-toggle');

        if (isRealNavigation) {
          event.preventDefault();
          event.stopPropagation();
          if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
          closeMobileMenu();
          window.location.assign(menuLink.href);
          return;
        }
      }
    }

    if (!fbpMobileMenuRebuildActive && window.innerWidth < 1200 && target.closest('button.navbar-toggle, .menu-bar button, .menu-bar a, .menu-toggle')) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      openMobileMenu();
      return;
    }

    if (!fbpMobileMenuRebuildActive && window.innerWidth < 1200 && target.closest('.close-box, button.close-box, .mm-fullscreen-bg')) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      closeMobileMenu();
      return;
    }

    if (isDesktopCollection() && target.closest('button.filter-button')) {
      window.setTimeout(normalizeCollectionSidebar, 50);
      window.setTimeout(normalizeCollectionSidebar, 250);
      window.setTimeout(normalizeCollectionSidebar, 900);
    }
  }

  function handleChange(event) {
    var target = event.target;
    if (!target || !target.matches) return;
    if (!target.matches('input[type="checkbox"][name], input[type="radio"][name]')) return;
    if (!isCollectionPage()) return;
    if (filterRebuildOwnsFilters()) return;
    if (!target.closest('.shop-sidebar.st-filter')) return;

    var managedNames = ['filter.p.product_type', 'filter.p.m.custom.gender'];
    if (managedNames.indexOf(target.name) === -1) return;
    if (window.__fbpManagedFilterNavigationLocked) return;

    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
    navigateManagedFilterTarget(buildManagedFilterTarget());
  }

  function arm() {
    ensureStyle();
    if (normalizeLegacyDakiSortParamIfNeeded()) return;
    hideAdultWarnings();
    cleanupLegacyDesktopSidebar();
    normalizeCollectionSidebar();
    bindManagedFilterControls();
    normalizeManagedFilterUrlIfNeeded();
    [120, 600, 1600].forEach(function (delay) {
      window.setTimeout(normalizeManagedFilterUrlIfNeeded, delay);
    });
    Array.prototype.slice.call(getSortSelects()).forEach(enhanceDakiSortSelect);
  }

  document.addEventListener('click', handleClick, true);
  document.addEventListener('change', handleChange, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arm, { once: true });
  } else {
    arm();
  }

  window.addEventListener('load', arm);
  window.addEventListener('resize', function () {
    window.clearTimeout(window.__fbpLiveFilterMobileHotfixResizeTimer);
    window.__fbpLiveFilterMobileHotfixResizeTimer = window.setTimeout(arm, 120);
  });

  var observer = new MutationObserver(function () {
    window.clearTimeout(window.__fbpLiveFilterMobileHotfixObserverTimer);
    window.__fbpLiveFilterMobileHotfixObserverTimer = window.setTimeout(arm, 120);
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
/* FBP live filter and mobile menu hotfix 2026-04-05 end */

/* FBP desktop menu enhancements 2026-04-06 v4 — rewritten from scratch */
(function () {
  window.__fbpDesktopMenuPatchLoaded = true;
  if (window.__fbpDesktopMenuPatchV4) return;
  window.__fbpDesktopMenuPatchV4 = true;

  /*
   * DOM structure discovered via live inspection:
   *   ul.menu-dropdown.single-menu > li.singlemenu-li > a.singlelink-title > span.sp-link-title
   * The injected "All Body Pillows" was using submenu-li / sublink-title (WRONG).
   * Now everything uses singlemenu-li / singlelink-title to match the theme.
   */

  function patchDropdownLinks() {
    document.querySelectorAll('li.menu-link > ul.menu-dropdown').forEach(function (ul) {
      if (ul.dataset.fbpPatchedV4) return;
      ul.dataset.fbpPatchedV4 = '1';
      var parentMenuItem = ul.closest('li.menu-link');
      var parentTitleNode = parentMenuItem ? parentMenuItem.querySelector(':scope > a.link-title > .sp-link-title') : null;
      var parentTitle = parentTitleNode ? (parentTitleNode.childNodes[0] ? parentTitleNode.childNodes[0].textContent : parentTitleNode.textContent).trim().toLowerCase() : '';
      var isBodyPillowDropdown = parentTitle.indexOf('body pillow covers') !== -1;

      /* --- Remove "All Body Pillows" from the Bed pillow covers dropdown --- */
      if (isBodyPillowDropdown) {
        ul.querySelectorAll(':scope > li').forEach(function (li) {
          var a = li.querySelector('a');
          if (!a) return;
          var t = a.textContent.trim().toLowerCase();
          var href = (a.getAttribute('href') || '').toLowerCase();
          if (t === 'all body pillows' || (t === 'all' && href.indexOf('/collections/body-pillow-covers-furry-dakimakura') !== -1)) {
            li.parentNode.removeChild(li);
          }
        });

        /* --- Fix Femboy link --- */
        ul.querySelectorAll('a').forEach(function (a) {
          if (a.textContent.trim().toLowerCase().indexOf('femboy') !== -1) {
            a.href = '/collections/body-pillow-covers-furry-dakimakura?fbp_gender=Femboy';
          }
        });
      }
    });
  }

  /* === Hover: document-level event delegation === */
  var GOLD = '#c9963e';
  var GOLD_BG = 'rgba(201,150,62,0.15)';
  var activeTopLink = null;
  var activeDropItem = null;

  function paintGold(el) {
    if (!el) return;
    el.style.setProperty('color', GOLD, 'important');
    var ch = el.getElementsByTagName('*');
    for (var i = 0; i < ch.length; i++) ch[i].style.setProperty('color', GOLD, 'important');
  }
  function unpaintGold(el) {
    if (!el) return;
    el.style.removeProperty('color');
    var ch = el.getElementsByTagName('*');
    for (var i = 0; i < ch.length; i++) ch[i].style.removeProperty('color');
  }

  document.addEventListener('mouseover', function (e) {
    /* Top-level nav: li.menu-link > a.link-title */
    var topLi = e.target.closest('li.menu-link');
    if (topLi) {
      var topA = topLi.querySelector(':scope > a.link-title');
      if (topA && topA !== activeTopLink) {
        if (activeTopLink) unpaintGold(activeTopLink);
        paintGold(topA);
        activeTopLink = topA;
      }
    }

    /* Dropdown item: li.singlemenu-li > a.singlelink-title  (the actual class used by the theme) */
    var dropLi = e.target.closest('li.singlemenu-li');
    if (dropLi) {
      var dropA = dropLi.querySelector(':scope > a.singlelink-title');
      if (!dropA) dropA = dropLi.querySelector(':scope > a');
      if (dropA && dropA !== activeDropItem) {
        if (activeDropItem) { unpaintGold(activeDropItem); activeDropItem.style.background = ''; }
        paintGold(dropA);
        dropA.style.background = GOLD_BG;
        activeDropItem = dropA;
      }
    }
  }, true);

  document.addEventListener('mouseout', function (e) {
    var rel = e.relatedTarget;
    if (activeTopLink) {
      var topLi = activeTopLink.closest('li.menu-link');
      if (topLi && !topLi.contains(rel)) { unpaintGold(activeTopLink); activeTopLink = null; }
    }
    if (activeDropItem) {
      var dropLi = activeDropItem.closest('li.singlemenu-li');
      if (dropLi && !dropLi.contains(rel)) { unpaintGold(activeDropItem); activeDropItem.style.background = ''; activeDropItem = null; }
    }
  }, true);

  /* Boot */
  function run() { patchDropdownLinks(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else { run(); }
  window.addEventListener('load', run);

  var hdr = document.querySelector('.shopify-section-group-header-group');
  if (hdr) {
    var obs = new MutationObserver(function () { clearTimeout(obs.__t); obs.__t = setTimeout(run, 200); });
    obs.observe(hdr, { childList: true, subtree: true });
  }

  var css = document.createElement('style');
  css.textContent =
    '.shopify-section-group-header-group{position:relative;z-index:10!important;}' +
    /* Smooth hover transition for all dropdown items */
    'ul.menu-dropdown.single-menu li.singlemenu-li a.singlelink-title{transition:background .15s ease,color .15s ease;}';
  document.head.appendChild(css);
})();

/* FBP mirror-repeat background generator — DISABLED V42 2026-04-19.
   History: 2026-04-06 original version built a mirror-repeat cloud pattern
   at runtime by drawing the single-image cloud JPEG into a canvas + its
   vertical flip, then converting the canvas to a blob URL and writing it
   to --fbp-bg-mirror. main::before read that var for its background.
   V40 (2026-04-19) made it single-fire (was double-firing on DCL + load).
   V42 (2026-04-19): the generator and the --fbp-bg-mirror indirection are
   gone entirely. CSS now references the pre-baked
   fbp-background-test-mobile-mirror-20260401.jpg asset (768×5400, exactly
   2× the original 2700px tall, bottom half is the vertical flip so
   `repeat-y` tiles seamlessly) directly in main::before — see
   layout/theme.liquid ~line 362. No JS canvas, no blob swap, no visible
   fallback→mirror transition at ~1170ms after nav. The IIFE is kept as
   a no-op so the site-wide __fbpMirrorBgLoaded guard still resolves
   truthy for any code that might check it, but the actual work is
   disabled. To re-enable (rollback target: V40 tag
   live-v40-bg-flicker-single-fire-2026-04-19), remove the early return
   below and also restore the var() reference in theme.liquid's
   main::before block. */
(function () {
  if (window.__fbpMirrorBgLoaded) return;
  window.__fbpMirrorBgLoaded = true;
  /* V42 kill-switch: CSS now uses the pre-baked mirror asset directly,
     so the runtime canvas generator is dead weight. Early-return before
     any DOM/canvas/Image work touches the page. */
  return;
})();

/* FBP external link hardening 2026-05-25 start */
(function () {
  'use strict';

  function hardenExternalBlankLinks() {
    document.querySelectorAll('a[target="_blank"]').forEach(function (link) {
      var rel = (link.getAttribute('rel') || '').toLowerCase().split(/\s+/).filter(Boolean);
      if (rel.indexOf('noopener') === -1) rel.push('noopener');
      if (rel.indexOf('noreferrer') === -1) rel.push('noreferrer');
      link.setAttribute('rel', rel.join(' '));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hardenExternalBlankLinks, { once: true });
  } else {
    hardenExternalBlankLinks();
  }
  document.addEventListener('shopify:section:load', hardenExternalBlankLinks);
})();
/* FBP external link hardening 2026-05-25 end */

/* FBP quick-action duplicate id hardening 2026-05-25 start */
(function () {
  'use strict';

  var QUICK_ACTION_ID_PREFIXES = [
    'quick-add-cart-',
    'quick-view-',
    'QuickAddCart-',
    'QuickAddCartInfo-',
    'QuickView-',
    'QuickViewInfo-',
    'stclose-cart-',
    'stclose-view-'
  ];

  function isQuickActionId(id) {
    if (typeof id !== 'string') {
      id = id && typeof id.baseVal === 'string' ? id.baseVal : String(id || '');
    }

    return QUICK_ACTION_ID_PREFIXES.some(function (prefix) {
      return id.indexOf(prefix) === 0;
    });
  }

  function cleanDuplicateQuickActionIds() {
    var seen = Object.create(null);
    document.querySelectorAll('[id]').forEach(function (element) {
      var id = element.getAttribute('id') || '';
      if (!isQuickActionId(id)) return;

      if (!seen[id]) {
        seen[id] = 1;
        return;
      }

      seen[id] += 1;
      element.setAttribute('data-fbp-original-id', id);
      element.setAttribute('id', id + '--fbp-duplicate-' + seen[id]);
    });
  }

  function armQuickActionIdCleanup() {
    cleanDuplicateQuickActionIds();
    window.setTimeout(cleanDuplicateQuickActionIds, 400);
    window.setTimeout(cleanDuplicateQuickActionIds, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', armQuickActionIdCleanup, { once: true });
  } else {
    armQuickActionIdCleanup();
  }
  window.addEventListener('load', armQuickActionIdCleanup);
  document.addEventListener('shopify:section:load', armQuickActionIdCleanup);
})();
/* FBP quick-action duplicate id hardening 2026-05-25 end */

/* =============================================================================
 * FBP Product Image Lightbox — replaces magnific popup / new-page behavior
 * with a custom lightbox overlay with close button, swipe, and arrow nav.
 * Works on desktop and mobile.
 * =========================================================================== */
(function () {
  'use strict';

  /* Only run on product pages */
  function isProductPage() {
    return /\/products\//.test(window.location.pathname);
  }

  function init() {
    if (!isProductPage()) return;

    /* Build lightbox DOM */
    var lb = document.createElement('div');
    lb.id = 'fbp-product-lightbox';
    lb.innerHTML =
      '<div class="fbp-lb-backdrop"></div>' +
      '<button type="button" class="fbp-lb-close" aria-label="Close lightbox">&times;</button>' +
      '<button type="button" class="fbp-lb-prev" aria-label="Previous image">&#8249;</button>' +
      '<button type="button" class="fbp-lb-next" aria-label="Next image">&#8250;</button>' +
      '<img class="fbp-lb-img" src="" alt="" style="cursor:grab;user-select:none;">' +
      '<div class="fbp-lb-counter"></div>';
    document.body.appendChild(lb);

    var imgEl = lb.querySelector('.fbp-lb-img');
    var counterEl = lb.querySelector('.fbp-lb-counter');
    var images = [];
    var currentIndex = 0;

    function collectImages() {
      // V37 (2026-04-19): key each collected image by its Shopify media id so
      // callers can look up the correct lightbox index even when some slides
      // are skipped (videos / 3D models / external-video slides have no
      // <a.product-thumb> and are filtered out below). Previously the click
      // handlers used `data-index - 1` as the array index, which assumed every
      // slide in the DOM was collected. If a product had a video slide at
      // e.g. data-index="3", every subsequent click opened the NEXT image
      // instead of the clicked one (user-reported: "click a design to see it
      // larger, opens the design to the right"). Filtering duplicates is also
      // defensive — Swiper adds `.swiper-slide-duplicate` clones in loop mode,
      // which would double-count entries.
      images = [];
      var slides = document.querySelectorAll('.slider-big .swiper-slide:not(.swiper-slide-duplicate)');
      slides.forEach(function (slide) {
        var a = slide.querySelector('a.product-thumb');
        if (a && a.href) {
          images.push({
            src: a.href,
            alt: (a.querySelector('img') || {}).alt || '',
            mediaId: slide.getAttribute('data-image-id') || a.getAttribute('data-image-id') || null
          });
        }
      });
      return images;
    }

    function indexForSlide(slide) {
      // Given a .swiper-slide DOM node, return the matching `images[]` index.
      // Prefers data-image-id (survives Swiper duplicates and skipped slides);
      // falls back to data-index only if no id is available, then to 0.
      if (!slide) return 0;
      var mediaId = slide.getAttribute('data-image-id');
      if (mediaId) {
        for (var i = 0; i < images.length; i++) {
          if (images[i].mediaId === mediaId) return i;
        }
      }
      var dataIndex = slide.getAttribute('data-index');
      if (dataIndex) {
        var n = parseInt(dataIndex, 10);
        if (Number.isFinite(n) && n - 1 < images.length) return Math.max(0, n - 1);
      }
      return 0;
    }

    function show(index) {
      if (index < 0 || index >= images.length) return;
      currentIndex = index;
      imgEl.src = images[index].src;
      imgEl.alt = images[index].alt;
      counterEl.textContent = (index + 1) + ' / ' + images.length;
      lb.classList.add('fbp-lb-active');
      document.body.style.overflow = 'hidden';
    }

    function hide() {
      lb.classList.remove('fbp-lb-active');
      document.body.style.overflow = '';
      imgEl.src = '';
    }

    function prev() {
      if (images.length === 0) return;
      show((currentIndex - 1 + images.length) % images.length);
    }

    function next() {
      if (images.length === 0) return;
      show((currentIndex + 1) % images.length);
    }

    /* Close handlers */
    lb.querySelector('.fbp-lb-backdrop').addEventListener('click', hide);
    lb.querySelector('.fbp-lb-close').addEventListener('click', hide);
    lb.querySelector('.fbp-lb-prev').addEventListener('click', function (e) { e.stopPropagation(); prev(); });
    lb.querySelector('.fbp-lb-next').addEventListener('click', function (e) { e.stopPropagation(); next(); });

    /* Keyboard */
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('fbp-lb-active')) return;
      if (e.key === 'Escape') hide();
      else if (e.key === 'ArrowLeft') prev();
      else if (e.key === 'ArrowRight') next();
    });

    /* Touch swipe support */
    var touchStartX = 0;
    lb.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].clientX;
    }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      var diff = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) prev(); else next();
      }
    }, { passive: true });

    /* Mouse drag support — click-and-drag left/right to navigate */
    var dragStartX = 0;
    var isDragging = false;
    imgEl.addEventListener('mousedown', function (e) {
      e.preventDefault();
      dragStartX = e.clientX;
      isDragging = true;
      imgEl.style.cursor = 'grabbing';
    });
    document.addEventListener('mousemove', function (e) {
      if (!isDragging) return;
      var diff = e.clientX - dragStartX;
      /* Visual feedback: shift image slightly while dragging */
      if (Math.abs(diff) > 10) {
        imgEl.style.transform = 'translateX(' + (diff * 0.3) + 'px)';
      }
    });
    document.addEventListener('mouseup', function (e) {
      if (!isDragging) return;
      isDragging = false;
      imgEl.style.cursor = 'grab';
      imgEl.style.transform = '';
      var diff = e.clientX - dragStartX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) prev(); else next();
      }
    });

    /* Intercept clicks on product images in the slider-big area */
    document.addEventListener('click', function (e) {
      var link = e.target.closest('.slider-big a.product-thumb');
      if (!link) return;
      e.preventDefault();
      e.stopPropagation();
      collectImages();
      /* Find which slide was clicked and map it to the images[] index by
         data-image-id — see indexForSlide() for why data-index-1 is wrong. */
      show(indexForSlide(link.closest('.swiper-slide')));
    }, true);

    /* Also intercept the .full-view and .zoom click handlers that magnific popup uses */
    document.addEventListener('click', function (e) {
      if (!isProductPage()) return;
      var zoomFig = e.target.closest('.slider-big figure.zoom');
      var fullView = e.target.closest('.slider-big .full-view');
      if (!zoomFig && !fullView) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      collectImages();
      show(indexForSlide((zoomFig || fullView).closest('.swiper-slide')));
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

/* =============================================================================
 * FBP Running Banner — artist links with a single accessible list and motion control
 * =========================================================================== */
(function () {
  'use strict';

  var DATA_URL = null;
  var ASSET_BASE = '';

  function init() {
    var marquee = document.querySelector('.marquee-section') || document.querySelector('.top-bar2');
    if (!marquee) return;
    var scripts = document.querySelectorAll('script[src*="fbp-filter-menu-rebuild"]');
    if (scripts.length > 0) {
      var src = scripts[0].getAttribute('src');
      ASSET_BASE = src.substring(0, src.lastIndexOf('/') + 1);
      DATA_URL = window.__fbpFilterMenuDataUrl || (ASSET_BASE + 'fbp-filter-menu-data.json');
    } else {
      var anyAsset = document.querySelector('link[href*="/assets/"]');
      if (anyAsset) {
        var href = anyAsset.getAttribute('href');
        ASSET_BASE = href.substring(0, href.lastIndexOf('/') + 1);
      }
      DATA_URL = window.__fbpFilterMenuDataUrl || (ASSET_BASE + 'fbp-filter-menu-data.json');
    }
    if (!DATA_URL) return;
    var dataPromise = window.__fbpFilterMenuDataPromise;
    if (!dataPromise || typeof dataPromise.then !== 'function') {
      dataPromise = fetch(DATA_URL, { credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) {
          if (!r.ok) throw new Error('Failed to load filter data: ' + r.status);
          return r.json();
        });
      window.__fbpFilterMenuDataPromise = dataPromise;
    }
    dataPromise.then(function (data) {
      window.__fbpFilterMenuData = data;
      if (!data || !data.artists || data.artists.length === 0) return;
      buildBanner(marquee, data.artists);
    }).catch(function () { /* Keep the original content when artist data is unavailable. */ });
  }

  function buildBanner(marquee, artists) {
    var wrap = marquee.querySelector('.offer-text-wrap');
    var text1 = wrap && wrap.querySelector('.text1');
    var text2 = wrap && wrap.querySelector('.text2');
    if (!wrap || !text1 || marquee.hasAttribute('data-fbp-artist-marquee')) return;
    var items = artists.map(function (artist) {
      var filterUrl = '/collections/all?fbp_artist=' + encodeURIComponent(artist.key);
      var avatarHtml = artist.avatarFilename
        ? '<img src="' + ASSET_BASE + artist.avatarFilename + '" alt="" class="fbp-marquee-avatar" width="36" height="36" loading="lazy" decoding="async">'
        : '<span aria-hidden="true" class="fbp-marquee-avatar fbp-marquee-avatar-placeholder">' + escapeHtml(artist.placeholder || artist.name.charAt(0)) + '</span>';
      return '<li class="grid-wrapper fbp-marquee-artist"><a href="' + filterUrl + '" class="fbp-marquee-artist-link">' + avatarHtml + '<span class="fbp-marquee-artist-name">' + escapeHtml(artist.name) + '</span></a></li>';
    }).join('');
    text1.innerHTML = items;
    text1.setAttribute('aria-label', 'Artists');
    if (text2) {
      text2.innerHTML = items;
      text2.setAttribute('aria-hidden', 'true');
      text2.querySelectorAll('a').forEach(function (link) { link.tabIndex = -1; });
      // Preserve ordinary link clicks without focusing an aria-hidden visual copy.
      text2.addEventListener('mousedown', function (event) { event.preventDefault(); });
    }
    marquee.setAttribute('data-fbp-artist-marquee', '');
    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'fbp-artist-motion-toggle';
    wrap.insertAdjacentElement('afterend', toggle);
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var userPaused = false;
    var focused = false;

    function reveal(link) {
      if (!link || !text1.contains(link)) return;
      var outer = wrap.getBoundingClientRect();
      var bounds = link.getBoundingClientRect();
      if (bounds.left < outer.left) wrap.scrollLeft += bounds.left - outer.left - 2;
      else if (bounds.right > outer.right) wrap.scrollLeft += bounds.right - outer.right + 2;
    }
    function update() {
      var stationary = reduced.matches || userPaused || focused;
      marquee.setAttribute('data-fbp-artist-static', stationary ? 'true' : 'false');
      toggle.hidden = reduced.matches;
      toggle.textContent = userPaused ? 'Play' : 'Pause';
      toggle.setAttribute('aria-label', userPaused ? 'Play artist motion' : 'Pause artist motion');
      if (!stationary) wrap.scrollLeft = 0;
      if (focused) reveal(document.activeElement);
    }
    toggle.addEventListener('click', function () { userPaused = !userPaused; update(); });
    text1.addEventListener('focusin', function (event) { focused = true; update(); reveal(event.target.closest('a')); });
    text1.addEventListener('focusout', function (event) {
      if (!text1.contains(event.relatedTarget)) { focused = false; update(); }
    });
    reduced.addEventListener('change', update);
    window.addEventListener('resize', function () { if (focused) reveal(document.activeElement); });
    update();
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

/* =============================================================================
 * FBP Cart Sidebar — click outside closes cart AND performs normal click action.
 * The overlay is made transparent + pointer-events:none.
 * We override open()/close() on the prototype to control overlay behavior
 * without triggering CSS transitions that interfere with the cart animation.
 * =========================================================================== */
(function () {
  'use strict';

  function init() {
    var cartEl = document.querySelector('ajax-cart');
    if (!cartEl) return;

    /* Make the overlay transparent + non-interactive.
     * The overlay element MUST remain in the DOM — the ajaxCart constructor
     * binds a click handler to it and crashes if it's missing. */
    var overlay = cartEl.querySelector('#ajaxcart-overlay');
    if (overlay) {
      overlay.style.cssText = 'background:transparent!important;pointer-events:none!important;';
    }

    /* Make the cart wrapper itself transparent + click-through via inline styles.
     * CSS !important in <style> tags loses to theme's 96+ stylesheets,
     * but inline !important always wins.
     * IMPORTANT: transition:none prevents background change from firing
     * transitionend which the theme's open() method listens for to set up
     * focus trapping — a spurious transitionend can cause premature close. */
    cartEl.style.cssText += ';background:transparent!important;background-color:transparent!important;pointer-events:none!important;transition:none!important;';

    /* Make the cart wrapper itself transparent + click-through.
     * The .drawer-inner stays interactive via CSS. */
    var s = document.createElement('style');
    s.id = 'fbp-cart-overlay-fix';
    s.textContent =
      'ajax-cart.mini-cart, ajax-cart.mini-cart.active {' +
      '  background: transparent !important;' +
      '  background-color: transparent !important;' +
      '  pointer-events: none !important;' +
      '}' +
      'ajax-cart.mini-cart .drawer-inner {' +
      '  pointer-events: auto !important;' +
      '}' +
      'body.overflow-hidden {' +
      '  overflow: auto !important;' +
      '}';
    document.head.appendChild(s);

    /* Toggle: clicking cart icon when cart is open should close it.
     * We patch the open() on the prototype. Must wait for custom element
     * upgrade since ajax-cart.js is deferred and may not have run yet. */
    var cartIcon = document.getElementById('ajax-cart-icon');
    function patchOpen() {
      var proto = Object.getPrototypeOf(cartEl);
      if (proto && typeof proto.open === 'function' && !proto._fbpPatched) {
        var origOpen = proto.open;
        proto.open = function (opener) {
          if (this.classList.contains('active')) {
            if (typeof this.close === 'function') {
              this.close();
            } else {
              this.classList.remove('active');
              document.body.classList.remove('overflow-hidden');
            }
            return;
          }
          origOpen.call(this, opener);
        };
        proto._fbpPatched = true;
      }
    }
    /* Try immediately, and also retry after a delay for deferred scripts */
    patchOpen();
    if (!Object.getPrototypeOf(cartEl)._fbpPatched) {
      setTimeout(patchOpen, 500);
      setTimeout(patchOpen, 1500);
    }

    /* Coordinate-based toggle: when the cart drawer is open it covers
     * the cart icon (position:fixed z-index 11 vs position:relative z-index 10).
     * We listen in capture phase and check click coordinates against
     * the cart icon's bounding rect so it works even when the drawer is on top. */
    document.addEventListener('click', function (e) {
      if (!cartEl.classList.contains('active')) return;
      if (!cartIcon) return;
      var r = cartIcon.getBoundingClientRect();
      /* Expand hit-area by 10px in each direction for easier clicking */
      if (e.clientX >= r.left - 10 && e.clientX <= r.right + 10 &&
          e.clientY >= r.top - 10 && e.clientY <= r.bottom + 10) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (typeof cartEl.close === 'function') {
          cartEl.close();
        } else {
          cartEl.classList.remove('active');
          document.body.classList.remove('overflow-hidden');
        }
      }
    }, true); /* capture phase — fires before the drawer's own handlers */

    /* Track when the cart was last opened */
    var cartOpenedAt = 0;

    /* Watch for cart class changes to track open/close state */
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type !== 'attributes' || m.attributeName !== 'class') return;
        if (cartEl.classList.contains('active')) {
          cartOpenedAt = Date.now();
        }
      });
    });
    observer.observe(cartEl, { attributes: true, attributeFilter: ['class'] });

    /* Listen for clicks anywhere on the document */
    document.addEventListener('click', function (e) {
      if (!cartEl.classList.contains('active')) return;

      /* Ignore synthetic/programmatic clicks (e.g. custom-choice-selector.js
       * dispatches synthetic clicks for variant media sync on page load).
       * Only real user clicks should close the cart. */
      if (!e.isTrusted) return;

      /* Ignore clicks within 400ms of cart opening (prevents instant close) */
      if (Date.now() - cartOpenedAt < 400) return;

      /* If click is inside .drawer-inner, let it be handled normally */
      var drawer = cartEl.querySelector('.drawer-inner');
      if (drawer && drawer.contains(e.target)) return;

      /* Cart icon toggle is handled by the capture-phase listener above */
      if (cartIcon && cartIcon.contains(e.target)) return;

      /* Close the cart via the real close() method so focus trap listeners
       * are cleaned up properly (triggerClickClose). The click continues
       * to propagate normally since we don't call preventDefault(). */
      if (typeof cartEl.close === 'function') {
        cartEl.close();
      } else {
        cartEl.classList.remove('active');
        document.body.classList.remove('overflow-hidden');
      }
    }, false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
